/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-return-assign */
/* eslint-disable operator-assignment */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unneeded-ternary */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import subYears from 'date-fns/subYears';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import parse from 'date-fns/parse';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  MdClose,
  MdOutlineCreditCard,
  MdOutlineFastfood,
  MdLuggage,
  MdList,
  MdChair,
  MdCheckCircleOutline,
  MdCheckCircle,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdInfo,
  MdSave,
} from 'react-icons/md';
import { CiWallet, CiBank } from 'react-icons/ci';
import { IoMdEyeOff, IoMdEye } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';
import AppLink from '../../shared/components/app-link/AppLink';
import './FlightBookingPage.scss';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import {
  addPersonalTravellerApi,
  getAgentBalanceApi,
  getUserDetails,
} from '../../api/profileApi';
import {
  getObjectFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  API_DATE_FORMAT,
  // DATE_MONTH_YEAR_VIEW_FORMAT,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  ONLY_DATE_MONTH_FORMAT,
  TODAY_DATE,
  INDIGO_FARERULES_LINK,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  getSeatLayoutApi,
  getSSRApi,
  bookFlightApi,
  getFareRulesApi,
  HoldFlightApi,
  savePaxDetailsApi,
  chooseCustomerApi,
  addMarkupInTicket,
  getPaymentGateway,
  getPGCheckOutAmountApi,
  addAgentGSTDetails,
  getAgentGSTList,
  updateGstDetails,
  getAllPersonalTravellersForAgentIdApi,
  getBookingValidations,
} from '../../api/flightApi';
import {
  formatCurrency,
  formatDate,
  scrollToTop,
  removeAlignLogoINBookingPgae,
  alignLogoInBookingPage,
  hideHeaderFooter,
  showHeaderFooter,
  isMobileWidth,
  getDateWithHypends,
  getNewDate,
  getEligibilityForPaymentMode,
  getEligibilityForPgOptions,
  scrollToBottom,
  isEmpty,
  isValidDate,
  isBeforeDate,
  isAfterDate,
  isNullOrEmpty,
  getAPIFormattedDate,
  isValidMobileNumber,
  getIsoCodeFromDialCode,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import SelectedFlightDetails from '../one-way/SelectedFlightDetails';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import BaggageTerms from './BaggageTerms';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  COUNTRY_OPTIONS,
  countryMobileCodes,
  countryOptionsForHotelPax,
} from '../../shared/constants/CountryOptions';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import GdsMeals from '../../shared/constants/GdsMeals';
import SelectPassengerModal from './SelectPassengerModal';
import airlineData from './AirlineNameFormats.json';
import {
  NET_BANKING_OPTIONS,
  NET_BANKING_OPTIONS_LIVE,
  PAYU_BANKING_OPTIONS,
  PAYU_BANKING_OPTIONS_LIVE,
} from '../../shared/constants/NetBankingOptions';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';
import PersonalTravelersModal from './PersonalTravellersModal';

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const NAME_REGEX = /^[a-zA-Z ]*$/;
const GST_REGEX = /^[a-zA-Z0-9]*$/;
const PASSPORT_REGEX = /^[a-zA-Z0-9]*$/;
const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

const DOMESTIC_INSURANCE_BENEFITS = [
  { benefit: 'Total Loss of checked in Baggage', amount: 'INR 10,000' },
  { benefit: 'Missed Connection', amount: 'INR 5,000' },
  { benefit: 'Personal Accident(Death+PTD+PPD)', amount: 'INR 50,000' },
  { benefit: 'Trip Delay', amount: 'INR 10,500' },
  { benefit: 'Trip Cancellation and/or Interruption', amount: 'INR 10,000' },
  {
    benefit: 'Loss of Deposit or Cancellation (Hotel & Airline)',
    amount: 'INR 10,000',
  },
];

const INTERNATIONAL_INSURANCE_BENEFITS = [
  {
    benefit: 'Emergency Medical Expenses (Accident & Illness)',
    amount: 'INR 75,000',
  },
  { benefit: 'Personal Accident (Common Carrier)', amount: 'INR 1,500' },
  { benefit: 'Missed Connection (Indemnity)', amount: 'INR 300' },
  { benefit: 'Delay of Checked-in Baggage (Indemnity)', amount: 'INR 100' },
  { benefit: 'Trip Delay (Indemnity)', amount: 'INR 100' },
  { benefit: 'Compassionate Visit - Travel', amount: 'INR 1,000' },
  { benefit: 'Personal Liability', amount: 'INR 2,00,000' },
  { benefit: 'Overbooked Common Carrier (Indemnity)', amount: 'INR 300' },
  { benefit: 'Loss of Checked-in Baggage (Indemnity)', amount: 'INR 500' },
  { benefit: 'Personal Accident', amount: 'INR 10,000' },
  { benefit: 'Hotel Over Booking', amount: 'INR 300' },
  { benefit: 'Medical Evacuation', amount: 'INR 25,000' },
  {
    benefit: 'Pre-Existing Disease Cover In Life Threatening Medical Condition',
    amount:
      '10% of Emergency Medical Expenses - Accident and Illness Sum Insured or USD 10000 per policy whichever is lower Upto 80 Yrs & USD 1500 for 81 - 85 Yrs',
  },
  { benefit: 'Repatriation of Mortal Remains', amount: 'INR 10,000' },
  {
    benefit:
      'Trip Cancellation (Before commencement of Trip) Trip Curtailment (Cutting short of Trip) Trip Interruption',
    amount: 'INR 750',
  },
  { benefit: 'Automatic Extensions', amount: 'Applicable up to 7 days' },
  { benefit: 'Out-patient Care', amount: 'INR 25,000' },
  { benefit: 'Travel Loan Secure', amount: 'INR 50,000' },
  { benefit: 'Mugging Cover', amount: 'INR 500' },
  { benefit: 'Custodial Care', amount: '50 per day upto 15 days' },
  { benefit: 'Loss of Passport (Indemnity)', amount: 'INR 300' },
  { benefit: 'Hijack Distress Allowance', amount: '50 per day upto 4 days' },
  { benefit: 'Dental Expenses', amount: 'INR 500' },
  { benefit: 'Daily Allowance', amount: '35 per day upto 5 days' },
];

const getLabel = (country) => {
  return (
    <div className="d-flex justify-content-between align-items-center p-1">
      <span className="fs-14">
        {country.name}({country.dial_code})
      </span>
      <div>
        <img
          style={{ width: '17px', height: '15px' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
      </div>
    </div>
  );
};

const countryOptions = countryOptionsForHotelPax.map((country) => ({
  label: country,
  value: country,
}));

const mobileCodes = countryMobileCodes.map((country) => ({
  label: getLabel(country),
  value: country.dial_code,
}));

const FLIGHT_DETAILS = 'flight-deatils';
const INSURANCE = 'insurance';
const PAX = 'travellers';
const SSR = 'ssr';
const PG = 'pg';

function FlightBookingPage() {
  const { appConfig } = useAppContext();
  // const parsedInsuranceAmount = parseInt(
  //   getValueFromAppConfig('INSURANCE_AMOUNT'),
  //   10,
  // );
  // const INSURANCE_AMOUNT = !Number.isNaN(parsedInsuranceAmount)
  //   ? parsedInsuranceAmount
  //   : 135;
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    selectedFlight,
    selectedFare,
    searchRequest,
    rePriceResponse,
    journeyType,
    selectedFareKeys,
    passThroughInfo,
    domInt,
  } = state;
  const { flightjourneys } = rePriceResponse;
  const { flightoptions } = flightjourneys[0];
  const { islcc } = flightoptions[0].recommendedflight[0];
  const [acceptTerms, setAcceptTerms] = useState(false);
  const ELEVEN_MIN_IN_MILLI_SECS = 11 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [elevenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + ELEVEN_MIN_IN_MILLI_SECS,
  );
  const [wheelChairSsr, setWheelChairSsr] = useState({});
  const [alert, setAlert] = useState(undefined);
  const [showSpecialAssistance, setShowSpecialAssistance] = useState(false);
  const selectedTravellerRef = useRef(undefined);
  const fareSummaryRef = useRef({});
  const selectedSpecialAssistanceIndexRef = useRef(-1);
  const isApiRequestProcessingRef = useRef(false);
  const validatingOrOperatingCarrierCodeRef = useRef('');
  const flightLegsWithSeatsRef = useRef({});
  const flightLegsWithBaggageRef = useRef({});
  const flightLegsWithMealRef = useRef({});
  const flightLegsWithSpecialSsr = useRef({});
  const FlightLegsWithSpecialAssistanceRef = useRef({});
  const [userSelectedSsrRows, setUserSelectedSsrRows] = useState({});
  const [travellers, setTravellers] = useState([]);
  const [showSpecialSsr, setShowSpecialSsr] = useState(false);
  const [showBagTermsDialog, setShowBagTermsDialog] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showConfirmHoldDialog, setShowConfirmHoldDialog] = useState(false);
  const [gst, setGst] = useState({
    gstnumber: '',
    gstcompany: '',
    gstemail: '',
    gstaddress: '',
    gstphone: '',
  });
  const [gstValidationError, setGstValidationError] = useState(false);
  const [countryCodeOptions] = useState(mobileCodes);
  const walletBalanceRef = useRef(0);
  const [countryCode, setCountryCode] = useState(appConfig.appMobileCode);
  const [leadmobile, setLeadmobile] = useState('');
  const [leademail, setLeademail] = useState('');
  const [showMeals, setShowMeals] = useState(false);
  const [showBaggage, setShowBaggage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeSeatIndex, setActiveSeatIndex] = useState(0);
  const [activeBagIndex, setActiveBagIndex] = useState(0);
  const [activeMealIndex, setActiveMealIndex] = useState(0);
  const [activeSsrIndex, setActiveSsrIndex] = useState(0);
  const [isSeatEditMode, setIsSeatEditMode] = useState(false);
  const [isBagEditMode, setIsBagEditMode] = useState(false);
  const [isMealEditMode, setIsMealEditMode] = useState(false);
  const [isSpecialSSREditMode, setIsSpecialSSREditMode] = useState(false);
  const [isMealSelected, setIsMealSelected] = useState(false);
  const [isSeatSelected, setIsSeatSelected] = useState(false);
  const [isBaggageSelected, setIsBaggageSelected] = useState(false);
  const [isSpecialSsrSelected, setIsSpecialSsrSelected] = useState(false);
  const [seatSelectionSector, setSeatSelectionSector] = useState('');
  const [mealSelectionSector, setMealSelectionSector] = useState('');
  const [baggageSelectionSector, setBaggageSelectionSector] = useState('');
  const [specialSsrSelectionSector, setSpecialSsrSelectionSector] =
    useState('');
  const [
    specialAssistanceSelectionSector,
    setSpecialAssistanceSelectionSector,
  ] = useState('');
  const [isBookingClicked, setIsBookingClicked] = useState(false);
  const [agentwiseGSTlist, setAgentwiseGSTlist] = useState([]);
  const [validationError, setValidationError] = useState(false);
  const [hasWheelChairRows, setHasWheelChairRows] = useState(false);
  const hasSeatMapRef = useRef(false);
  const hasSsrRef = useRef(false);
  const [showSeatMap, setShowSeatMap] = useState(false);
  const [fareRulesHtml, setFareRulesHtml] = useState('');
  const [isOpenFareRulesDialog, setIsOpenFareRulesDialog] = useState(false);
  const [hasTravelInsurance, setHasTravelInsurance] = useState(false);
  const [showFlightDetails, setShowFlightDetails] = useState(true);
  const [paymentmode, setPaymentMode] = useState('');
  const [eligiblePaxForTravelInsurance, setEligiblePaxForTravelInsurance] =
    useState(0);
  const [additionalMarkup, setAdditionalMarkup] = useState(0);
  const [showMarkup, setShowMarkup] = useState(false);
  const [tempMarkupList, setTempMarkupList] = useState([]);
  const [showNetFare, setShowNetFare] = useState(false);
  const [showSelectGstModal, setShowSelectGstModal] = useState(false);
  const [gstCompany, setGSTCompany] = useState();
  const [isGstMandatory, setIsGstMandatory] = useState(false);
  const [activeTab, setActiveTab] = useState(FLIGHT_DETAILS);
  const [isFlightDetailsCompleted, setIsFlightDetailsCompleted] =
    useState(false);
  const [isInusranceCompleted, setIsInsuranceCompleted] = useState(false);
  const [isPaxCompleted, setIsPaxCompleted] = useState(false);
  const [isSSRCompleted, setIsSSRCompleted] = useState(false);
  const [isPgCompleted, setIsPgCompleted] = useState(false);
  const [isHoldSupported, setIsHoldSupported] = useState(false);
  const targetRefs = {
    flightDetails: useRef(null),
    insurance: useRef(null),
    pax: useRef(null),
    ssr: useRef(null),
    pg: useRef(null),
  };
  const flightSectorsRef = useRef([]);
  const onwardFlightSectorsRef = useRef([]);
  const returnFlightSectorsRef = useRef([]);
  const onwardOriginRef = useRef(undefined);
  const onwardDestinationRef = useRef(undefined);
  const returnOriginRef = useRef(undefined);
  const returnDestinationRef = useRef(undefined);
  const [isGdsSearch, setIsGdsSearch] = useState(false);
  const [isSeriesFare, setIsSeriesFare] = useState(false);
  const [isPassThrough, setIsPassthrough] = useState(false);
  const [onwardPassThroughId, setOnwardPassThroughId] = useState(0);
  const [returnPassThroughId, setReturnPassThroughId] = useState(0);
  const [savedPaxIndex, setSavedPaxIndex] = useState([]);
  const [showSelectPaxModal, setShowSelectPaxModal] = useState(false);
  const [profileName, setProfileName] = useState('');
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const selectedCustomerRef = useRef(undefined);
  const selectedPaymentGatewayRef = useRef([]);
  const [PaymentGateway, setPaymentGateway] = useState(false);
  const [tempPgList, setTempPgList] = useState([]);
  const [selectedPg, setSelectedPg] = useState('');
  const [selectedBankForNetBanking, setSelectedBankForNetBanking] =
    useState('');
  const [checkoutPgCharge, setcheckoutPgCharge] = useState(0);
  const [checkoutgstPgCharge, setgstcheckoutPgCharge] = useState(0);
  const [checkoutInvTotal, setcheckoutInvTotal] = useState(0);
  const [isMarkupUpdated, setIsMarkupUpdated] = useState(false);
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);
  const [agent, setAgent] = useState({});
  const [isSeatMandatoryForOnward, setIsSeatMandatoryForOnward] =
    useState(false);
  const [isMealMandatoryForOnward, setIsMealMandatoryForOnward] =
    useState(false);
  const [isBaggageMandatoryForOnward, setIsBaggageMandatoryForOnward] =
    useState(false);
  const [isSeatMandatoryForReturn, setIsSeatMandatoryForReturn] =
    useState(false);
  const [isMealMandatoryForReturn, setIsMealMandatoryForReturn] =
    useState(false);
  const [isBaggageMandatoryForReturn, setIsBaggageMandatoryForReturn] =
    useState(false);
  const [panNumber, setPanNumber] = useState('');
  const hasDoneSeatCallRef = useRef(false);
  const hasDoneSsrCallRef = useRef(false);
  const [bookingPageValidations, setBookingPageValidations] =
    useState(undefined);
  const { seatmapavailable, ssravailable } =
    flightoptions[0].recommendedflight[0];

  const travelInsuranceEnabled =
    getValueFromAppConfig('FLIGHTBOOKINGTRAVELINSURANCE') === 'enabled';

  const insuranceAmountKey =
    rePriceResponse.domint === 'international'
      ? 'INSURANCE_AMOUNT_INTERNATIONAL'
      : 'INSURANCE_AMOUNT';

  const parsedInsuranceAmount = parseInt(
    getValueFromAppConfig(insuranceAmountKey),
    10,
  );

  const INSURANCE_AMOUNT = !Number.isNaN(parsedInsuranceAmount)
    ? parsedInsuranceAmount
    : rePriceResponse.domint === 'international'
    ? 807
    : 135;

  const [showMarkupOption, setShowMarkupOption] = useState(false);
  const [personalTravellers, setPersonalTravellers] = useState([]);
  const [showInsuranceBenefitsModal, setShowInsuranceBenefitsModal] =
    useState(false);

  const TITLE_OPTIONS = [
    { label: formattedMessage('mr'), value: 'Mr' },
    { label: formattedMessage('ms'), value: 'Ms' },
    { label: formattedMessage('mrs'), value: 'Mrs' },
  ];
  const OTHER_TITLE_OPTIONS = [
    { label: formattedMessage('mstr'), value: 'Mstr' },
    { label: formattedMessage('ms'), value: 'Ms' },
  ];
  const GENDER_OPTIONS = [
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
  ];

  const JOURNEY_TYPES = {
    ONWARD: 'onward',
    RETURN: 'return',
    ROUND_TRIP: 'roundtrip',
    ONE_WAY: 'oneway',
    MULTI_CITY: 'multicity',
  };

  const tripTypeDict = {
    OneWay: 'oneway_btn',
    RoundTrip: 'roundtrip_btn',
  };

  const ADDONS = {
    MEALS: 'meals',
    BAGGAGE: 'baggage',
    SPECIAL_SSR: 'special_ssr',
    SEAT: 'seat',
  };
  const handlepassportduplicates = (list) => {
    const updatedList = list.filter((x) => !isEmpty(x.passport));
    try {
      const passdeetails = updatedList.map((val) => val.passport);
      return updatedList.length === [...new Set(passdeetails)].length;
    } catch (error) {
      return false;
    }
  };

  const handleduplicateffn = (list) => {
    if (selectedFlight.onward.islcc === 'false') {
      const updatedList = list.filter(
        (x) => x.type !== 'Infant' && !isEmpty(x.frequent_flyer_number_onward),
      );

      if (updatedList.length === 0) return true;

      const ffndetails = updatedList.map(
        (val) => val.frequent_flyer_number_onward,
      );

      return updatedList.length === new Set(ffndetails).size;
    }

    if (selectedFlight?.return?.islcc === 'false') {
      const updatedList = list.filter(
        (x) => x.type !== 'Infant' && !isEmpty(x.frequent_flyer_number_return),
      );

      if (updatedList.length === 0) return true;

      const ffndetailsRet = updatedList.map(
        (val) => val.frequent_flyer_number_return,
      );

      return updatedList.length === new Set(ffndetailsRet).size;
    }
    return true;
  };
  useEffect(() => {
    alignLogoInBookingPage();
    return () => removeAlignLogoINBookingPgae();
  }, []);

  useEffect(() => {
    document.querySelectorAll('.watermarked').forEach((el) => {
      el.dataset.watermark = (el.dataset.watermark + ' ').repeat(400);
    });
  }, []);

  const multiplePg = async () => {
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getPaymentGateway(userProfile?.agentId);
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const availPgs = response?.Root?.Result?.AvailablePaymentGateways;
      if (availPgs !== '' && availPgs !== undefined && availPgs !== null) {
        let list = availPgs.AvailablePaymentGateway;
        list = Array.isArray(list) ? list : [list];
        selectedPaymentGatewayRef.current = list;
        const pgForCreditCard = list.filter(
          (x) => x.PaymentMode.toLowerCase() === 'creditcard',
        );
        setTempMarkupList(pgForCreditCard);
        if (pgForCreditCard.length > 0) {
          setSelectedPg(pgForCreditCard[0].GatewayName);
        }
        setPaymentGateway(true);
      }
    }
  };
  const getYesterdayDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const getDesignatorForSeat = (seat) => {
    const isSeatEmpty = seat.additionalinfo.indexOf('no-seat') > -1;
    const isUnavailable = seat.seatstatus.toLowerCase().indexOf('open') === -1;
    if (isSeatEmpty) {
      return '';
    }
    if (isUnavailable) {
      return 'X';
    }
    return seat?.seatdesignator?.replace('-', '');
  };

  const getSeatToolTipText = (seat) => {
    const isSeatEmpty = seat.additionalinfo.indexOf('no-seat') > -1;
    const isUnavailable = seat.seatstatus.toLowerCase().indexOf('open') === -1;
    if (isSeatEmpty) {
      return '';
    }
    if (isUnavailable) {
      return 'This seat is unavailable';
    }
    return (
      <>
        <span>{formatCurrency(seat.seatprice)}</span>
        <span>{seat.additionalinfo.replace('margin-left', '')}</span>
      </>
    );
  };

  const groupSeatMapByFlightLeg = (SeatMap) => {
    const seatMapArr = Array.isArray(SeatMap) ? SeatMap : [SeatMap];
    seatMapArr.forEach((seatMap) => {
      const sector = `${seatMap.origin} - ${seatMap.destination}`;
      const { seatrows } = seatMap;
      if (seatrows !== '') {
        const seatsArray = Array.isArray(seatrows.SeatRow)
          ? seatrows.SeatRow
          : [seatMap.SeatRow];
        const digitArr = [];
        const letterArr = [];
        const aisleRows = {};
        const uniqueAisleRows = [];
        seatsArray.forEach((x) => {
          if (x.seatdesignator !== '' && x.seatdesignator.indexOf('$') === -1) {
            const digit = x.seatdesignator.replace(/\D/g, '');
            const letter = x.seatdesignator.replace(/[^a-z]/gi, '');
            const isAisle =
              x.additionalinfo
                .toLowerCase()
                .split(',')
                .some(
                  (k) =>
                    k.indexOf('aisle') > -1 &&
                    k.indexOf('not') === -1 &&
                    k.indexOf('false') === -1,
                ) || x.seattype === 'Aisle';
            if (isAisle && letter !== undefined && letter !== '') {
              if (aisleRows[letter] === undefined) {
                aisleRows[letter] = 1;
              } else {
                aisleRows[letter] += aisleRows[letter];
                if (
                  aisleRows[letter] > 2 &&
                  uniqueAisleRows.indexOf(letter) === -1
                ) {
                  uniqueAisleRows.push(letter);
                }
              }
            }

            if (
              digit !== undefined &&
              letter !== '' &&
              digitArr.indexOf(digit) === -1
            ) {
              digitArr.push(digit);
            }
            if (
              letter !== undefined &&
              letter !== '' &&
              letterArr.indexOf(letter) === -1
            ) {
              letterArr.push(letter);
            }
          }
        });
        letterArr.sort((a, b) => (a < b ? -1 : 1));
        uniqueAisleRows.sort((a, b) => (a < b ? -1 : 1));
        const filteredaisleRows = uniqueAisleRows.filter(
          (_, index) => index % 2 === 0,
        );
        digitArr.sort((a, b) => Number(a) < Number(b));
        digitArr.forEach((digitNum, digitIndex) => {
          letterArr.forEach((letterNum, letterIndex) => {
            const seatNum = `${digitNum}${letterNum}`;
            const isPresent = seatsArray.find((x) => {
              const digit = x.seatdesignator.replace(/\D/g, '');
              const letter = x.seatdesignator.replace(/[^a-z]/gi, '');
              return `${digit}${letter}` === seatNum;
            });
            if (!isPresent) {
              const noSeat = {
                additionalinfo: 'no-seat',
                columnnum: '',
                height: 2,
                paxseatprices: '',
                premiumseat: '',
                rownum: '',
                seatdesignator: seatNum,
                seatgroup: 98,
                seatprice: '',
                seatstatus: '',
                seattype: 'NS',
                width: 2,
                xval: 1,
                yval: 6,
              };
              seatsArray.push(noSeat);
            }
          });
        });
        const seatMapDict = seatsArray.filter(
          (x) => x.seatdesignator.indexOf('$') === -1,
        );
        seatMapDict.forEach((x) => {
          const letter = x.seatdesignator.replace(/[^a-z]/gi, '');
          if (filteredaisleRows.indexOf(letter) > -1) {
            x.additionalinfo += `,margin-left`;
          }
        });
        const result = {};

        // Initialize the result object with empty arrays for each digit
        digitArr.forEach((digit) => {
          result[digit] = [];
        });

        // Iterate over the array of objects and group them by digit
        seatMapDict.forEach((seatObj) => {
          const match = seatObj.seatdesignator.match(/(\d+)-?(\w+)/); // Extract the numeric part and the letter part of the seat
          if (match) {
            const digit = parseInt(match[1], 10);
            if (result[digit]) {
              result[digit].push(seatObj);
            }
          }
        });

        // Sort the seats within each digit group alphabetically by seat string
        Object.values(result).forEach((seatGroup) => {
          seatGroup.sort((a, b) =>
            a.seatdesignator.localeCompare(b.seatdesignator),
          );
        });
        flightLegsWithSeatsRef.current[sector] = {
          seats: result,
          seatDigitArray: digitArr,
          seatLetterArray: letterArr,
        };
      }
    });
  };

  const getSeatLayout = async () => {
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    if (journeyType === JOURNEY_TYPES.ROUND_TRIP) {
      const onwardSeatResponse = await getSeatLayoutApi(
        userProfile?.agentId,
        JOURNEY_TYPES.ONWARD,
        rePriceResponse.bookingkey,
        rePriceResponse.domint,
      );
      const returnSeatResponse = await getSeatLayoutApi(
        userProfile?.agentId,
        JOURNEY_TYPES.RETURN,
        rePriceResponse.bookingkey,
        rePriceResponse.domint,
      );
      if (
        onwardSeatResponse &&
        onwardSeatResponse.Root &&
        onwardSeatResponse.Root.Result &&
        onwardSeatResponse.Root.Result !== null &&
        onwardSeatResponse.Root.Result.list
      ) {
        const { SeatMap } = onwardSeatResponse.Root.Result.list;
        groupSeatMapByFlightLeg(SeatMap);
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
      if (
        returnSeatResponse &&
        returnSeatResponse.Root &&
        returnSeatResponse.Root.Result &&
        returnSeatResponse.Root.Result !== null &&
        returnSeatResponse.Root.Result.list
      ) {
        const { SeatMap } = returnSeatResponse.Root.Result.list;
        groupSeatMapByFlightLeg(SeatMap);
      }
    } else {
      const response = await getSeatLayoutApi(
        userProfile?.agentId,
        JOURNEY_TYPES.ONWARD,
        rePriceResponse.bookingkey,
        rePriceResponse.domint,
      );
      if (
        response &&
        response.Root &&
        response.Root.Result !== null &&
        response.Root.Result.list
      ) {
        const { SeatMap } = response.Root.Result.list;
        groupSeatMapByFlightLeg(SeatMap);
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
    }
  };

  const groupBySsrType = (response, type) => {
    if (
      response &&
      response.list &&
      response.list !== null &&
      !isEmpty(response.list) &&
      !isEmpty(response.list.CarrierSSR)
    ) {
      const { CarrierSSR } = response.list;
      const list = Array.isArray(CarrierSSR) ? CarrierSSR : [CarrierSSR];
      const mealList = list.filter((x) => x.ssrtype === 'meal');
      const groupedBySector = list.reduce((acc, cur) => {
        if (cur.ArrStation) {
          cur.origin = cur.DepStation;
          cur.destination = cur.ArrStation;
        }
        if (
          (cur.origin !== 'all' &&
            cur.origin !== '' &&
            cur.origin !== undefined) ||
          (cur.destination !== 'all' &&
            cur.destination !== '' &&
            cur.destination !== undefined)
        ) {
          const key = `${cur.origin} - ${cur.destination}`;
          if (acc[key]) {
            acc[key].push(cur);
          } else {
            acc[key] = [cur];
          }
        }
        return acc;
      }, {});
      const getOrderedSectors = () => {
        const responseSectors = Object.keys(groupedBySector);
        const journeySectors =
          type === 'return'
            ? returnFlightSectorsRef.current
            : onwardFlightSectorsRef.current;
        const sectorOrder = [...journeySectors, ...flightSectorsRef.current];

        return responseSectors.sort((sectorA, sectorB) => {
          const sectorAIndex = sectorOrder.indexOf(sectorA);
          const sectorBIndex = sectorOrder.indexOf(sectorB);

          if (sectorAIndex === -1 && sectorBIndex === -1) {
            return 0;
          }
          if (sectorAIndex === -1) {
            return 1;
          }
          if (sectorBIndex === -1) {
            return -1;
          }

          return sectorAIndex - sectorBIndex;
        });
      };
      const sectors = getOrderedSectors();
      console.log('groupBySsrType Debug:', {
        type,
        sectors,
        userSelectedSsrRowsKeys: userSelectedSsrRows
          ? Object.keys(userSelectedSsrRows)
          : [],
        userSelectedSsrRows,
      });
      sectors.forEach((sector, index) => {
        if (!userSelectedSsrRows || !userSelectedSsrRows[sector]) {
          console.log(
            'Skipping sector because it is not in userSelectedSsrRows:',
            sector,
          );
          return;
        }
        const groupedData = groupedBySector[sector].reduce((acc, cur) => {
          if (acc[cur.ssrtype]) {
            acc[cur.ssrtype].push(cur);
          } else {
            acc[cur.ssrtype] = [cur];
          }
          return acc;
        }, {});
        if (groupedData.meal !== undefined) {
          groupedData.meal.sort(
            (meal1, meal2) => meal1.chargeableamount - meal2.chargeableamount,
          );
          flightLegsWithMealRef.current[sector] = groupedData.meal;
          if (Object.keys(flightLegsWithMealRef.current).length > 0) {
            setMealSelectionSector(
              Object.keys(flightLegsWithMealRef.current)[0],
            );
          }
        }
        if (groupedData.baggage !== undefined) {
          groupedData.baggage.sort(
            (baggage1, baggage2) =>
              baggage1.chargeableamount - baggage2.chargeableamount,
          );
          groupedData.baggage = groupedData.baggage.sort((a, b) => {
            const aContainsWord = a.ssrname
              .toLowerCase()
              .includes('intl conne');
            const bContainsWord = b.ssrname
              .toLowerCase()
              .includes('intl conne');

            if (aContainsWord && !bContainsWord) {
              return 1; // Move 'a' to a higher index (i.e., later in the array)
            }
            if (!aContainsWord && bContainsWord) {
              return -1; // Move 'b' to a higher index
            }
            return 0; // Keep original order if both or neither contain the word
          });
          flightLegsWithBaggageRef.current[sector] = groupedData.baggage;
          if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
            setBaggageSelectionSector(
              Object.keys(flightLegsWithBaggageRef.current)[0],
            );
          }
        }

        if (groupedData.specialssr !== undefined) {
          // const speicalSsrList = groupedData.specialssr.filter(
          //   (ssr) => ['WCHS', 'WCHR', 'WCHC'].indexOf(ssr.ssrcode) === -1,
          // );
          const speicalSsrList = [...groupedData.specialssr];
          const specialAssistance = groupedData.specialssr.filter(
            (ssr) => ['WCHS', 'WCHR', 'WCHC'].indexOf(ssr.ssrcode) > -1,
          );
          if (specialAssistance.length > 0) {
            setHasWheelChairRows(true);
          }
          speicalSsrList.sort(
            (baggage1, baggage2) =>
              baggage1.chargeableamount - baggage2.chargeableamount,
          );
          flightLegsWithSpecialSsr.current[sector] = speicalSsrList;
          FlightLegsWithSpecialAssistanceRef.current[sector] =
            specialAssistance;
          if (Object.keys(flightLegsWithSpecialSsr.current).length > 0) {
            setSpecialSsrSelectionSector(
              Object.keys(flightLegsWithSpecialSsr.current)[0],
            );
          }
          if (
            Object.keys(FlightLegsWithSpecialAssistanceRef.current).length > 0
          ) {
            setSpecialAssistanceSelectionSector(
              Object.keys(FlightLegsWithSpecialAssistanceRef.current)[0],
            );
          }

          const wcssr = { ...wheelChairSsr };
          wcssr[sector] = {};
          setWheelChairSsr(wcssr);
        }
      });
      if (mealList.length === 0) {
        let isAmedeusSupplier = false;
        const words = selectedFlight.onward.nextracustomstr.split(',');
        const amedeus = words.some((word) => word.includes('AMADEUS'));
        if (amedeus) {
          isAmedeusSupplier = true;
        }
        const eligiblesector = [];
        if (type === 'onward') {
          onwardFlightSectorsRef.current.forEach((sec) => {
            const secOrigin = sec.split(' - ')[0];
            const secDestination = sec.split(' - ')[1];

            const isTripJack =
              selectedFlight.onward.nextracustomstr.includes('TripJack');

            const isGds = selectedFlight.onward.flightlegs.find(
              (leg) =>
                leg.origin === secOrigin &&
                leg.destination === secDestination &&
                ['AI', 'UK'].indexOf(leg.carrier.substring(0, 2)) > -1,
            );
            if (isGds && !isTripJack) {
              eligiblesector.push(sec);
            }
          });
        }
        if (type === 'return' && returnFlightSectorsRef.current.length > 0) {
          returnFlightSectorsRef.current.forEach((sec) => {
            const secOrigin = sec.split(' - ')[0];
            const secDestination = sec.split(' - ')[1];

            const isTripJack =
              selectedFlight.onward.nextracustomstr.includes('TripJack');

            const isGds = selectedFlight.return.flightlegs.find(
              (leg) =>
                leg.origin === secOrigin &&
                leg.destination === secDestination &&
                ['AI', 'UK'].indexOf(leg.carrier.substring(0, 2)) > -1,
            );
            if (isGds && !isTripJack) {
              eligiblesector.push(sec);
            }
          });
        }
        if (eligiblesector.length > 0) {
          eligiblesector.forEach((sector) => {
            const res = GdsMeals(
              isAmedeusSupplier ? 'amedeus' : 'uapi',
              appConfig?.appCurrency,
            );
            res.forEach((meal) => {
              meal.origin = sector.split(' - ')[0];
              meal.destination = sector.split(' - ')[1];
            });
            flightLegsWithMealRef.current[sector] = res;
          });
          if (Object.keys(flightLegsWithMealRef.current).length > 0) {
            setMealSelectionSector(
              Object.keys(flightLegsWithMealRef.current)[0],
            );
          }
        }
      }
    } else {
      let isAmedeusSupplier = false;
      const words = selectedFlight.onward.nextracustomstr.split(',');
      const amedeus = words.some((word) => word.includes('AMADEUS'));
      if (amedeus) {
        isAmedeusSupplier = true;
      }
      const eligiblesector = [];
      if (type === 'onward') {
        onwardFlightSectorsRef.current.forEach((sec) => {
          const secOrigin = sec.split(' - ')[0];
          const secDestination = sec.split(' - ')[1];
          const isTripJack =
            selectedFlight.onward.nextracustomstr.includes('TripJack');

          const isGds = selectedFlight.onward.flightlegs.find(
            (leg) =>
              leg.origin === secOrigin &&
              leg.destination === secDestination &&
              ['AI'].indexOf(leg.carrier.substring(0, 2)) > -1,
          );
          if (isGds && !isTripJack) {
            eligiblesector.push(sec);
          }
        });
      }
      if (type === 'return' && returnFlightSectorsRef.current.length > 0) {
        returnFlightSectorsRef.current.forEach((sec) => {
          const secOrigin = sec.split(' - ')[0];
          const secDestination = sec.split(' - ')[1];

          const isTripJack =
            selectedFlight.onward.nextracustomstr.includes('TripJack');

          const isGds = selectedFlight.return.flightlegs.find(
            (leg) =>
              leg.origin === secOrigin &&
              leg.destination === secDestination &&
              ['AI'].indexOf(leg.carrier.substring(0, 2)) > -1,
          );
          if (isGds && !isTripJack) {
            eligiblesector.push(sec);
          }
        });
      }
      if (eligiblesector.length > 0) {
        eligiblesector.forEach((sector) => {
          const res = GdsMeals(
            isAmedeusSupplier ? 'amedeus' : 'uapi',
            appConfig?.appCurrency,
          );
          res.forEach((meal) => {
            meal.origin = sector.split(' - ')[0];
            meal.destination = sector.split(' - ')[1];
          });
          flightLegsWithMealRef.current[sector] = res;
        });
        if (Object.keys(flightLegsWithMealRef.current).length > 0) {
          setMealSelectionSector(Object.keys(flightLegsWithMealRef.current)[0]);
        }
      }
    }
  };

  const getSSRLayout = async () => {
    if (journeyType === JOURNEY_TYPES.ROUND_TRIP) {
      const onwardResponse = await getSSRApi(
        rePriceResponse.bookingkey,
        JOURNEY_TYPES.ONWARD,
      );
      groupBySsrType(onwardResponse, 'onward');
      const returnResponse = await getSSRApi(
        rePriceResponse.bookingkey,
        JOURNEY_TYPES.RETURN,
      );
      groupBySsrType(returnResponse, 'return');
    } else {
      const response = await getSSRApi(
        rePriceResponse.bookingkey,
        JOURNEY_TYPES.ONWARD,
      );
      groupBySsrType(response, 'onward');
    }
  };

  useEffect(() => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    travellers.forEach((traveller, index) => {
      Object.keys(userSelectedSsrRowsTemp).forEach((sector) => {
        userSelectedSsrRowsTemp[sector].baggageRows[index].passenger_fname =
          traveller.first_name;
        userSelectedSsrRowsTemp[sector].baggageRows[index].passenger_lname =
          traveller.last_name;
        userSelectedSsrRowsTemp[sector].baggageRows[index].passenger_title =
          traveller.title;
        userSelectedSsrRowsTemp[sector].mealRows.forEach((mealRow) => {
          if (mealRow.travellerIndex === index) {
            mealRow.passenger_fname = traveller.first_name;
            mealRow.passenger_lname = traveller.last_name;
            mealRow.passenger_title = traveller.title;
          }
        });
        userSelectedSsrRowsTemp[sector].seatRows[index].passenger_fname =
          traveller.first_name;
        userSelectedSsrRowsTemp[sector].seatRows[index].passenger_lname =
          traveller.last_name;
        userSelectedSsrRowsTemp[sector].seatRows[index].passenger_title =
          traveller.title;
        userSelectedSsrRowsTemp[sector].specialSsrRows[index].passenger_fname =
          traveller.first_name;
        userSelectedSsrRowsTemp[sector].specialSsrRows[index].passenger_lname =
          traveller.last_name;
        userSelectedSsrRowsTemp[sector].specialSsrRows[index].passenger_title =
          traveller.title;
        userSelectedSsrRowsTemp[sector].specialAssistanceRows[
          index
        ].passenger_fname = traveller.first_name;
        userSelectedSsrRowsTemp[sector].specialAssistanceRows[
          index
        ].passenger_lname = traveller.last_name;
        userSelectedSsrRowsTemp[sector].specialAssistanceRows[
          index
        ].passenger_title = traveller.title;
      });
    });
  }, [travellers]);

  const getSpecialSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'specialssr',
      travellerIndex: index,
    }));
  };

  const getBaggageSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'baggage',
      travellerIndex: index,
    }));
  };

  const getMealSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'meal',
      travellerIndex: index,
    }));
  };

  const getSeatSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'seat',
    }));
  };

  const getSpecialAssistanceRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: '',
      passenger_lname: '',
      passenger_title: '',
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'specialssr',
      travellerIndex: index,
    }));
  };

  const getKValue = (list) => {
    let kValue = 0;
    if (list.length > 0) {
      list.forEach((tax) => {
        if (tax.taxcode.includes('ADT_K3')) {
          kValue = tax.taxamount;
        } else if (
          tax.taxcode.indexOf('ADT') > -1 &&
          tax.taxcode.indexOf('GST') > -1
        ) {
          kValue = tax.taxamount;
        }
      });
    }
    return kValue;
  };

  const getTaxValue = (list, paxtype, key) => {
    let taxvalue = 0;
    if (list.length > 0) {
      list.forEach((tax) => {
        if (tax.paxtype === paxtype && tax.taxcode.includes(key)) {
          taxvalue = tax.taxamount;
        }
      });
    }
    return taxvalue;
  };

  const getNumberValue = (value) => {
    const numberValue = Number(value);
    return Number.isNaN(numberValue) ? 0 : numberValue;
  };

  const getTravelInsuranceAmount = (isSelected = hasTravelInsurance) =>
    isSelected ? eligiblePaxForTravelInsurance * INSURANCE_AMOUNT : 0;

  const getTotalAmountToShow = (
    fareSummary = fareSummaryRef.current,
    isTravelInsuranceSelected = hasTravelInsurance,
  ) =>
    getNumberValue(fareSummary.totalNet) +
    getNumberValue(fareSummary.seatPrice) +
    getNumberValue(fareSummary.mealPrice) +
    getNumberValue(fareSummary.baggagePrice) +
    getNumberValue(fareSummary.specialSsrPrice) +
    getNumberValue(fareSummary.totalYRValue) +
    getTravelInsuranceAmount(isTravelInsuranceSelected);

  const initData = async () => {
    isApiRequestProcessingRef.current = true;
    setIsLoading(true);
    const validationsResponse = await getBookingValidations(
      rePriceResponse.bookingkey,
    );
    if (validationsResponse) {
      const { BookingPageValidation } = validationsResponse;
      setBookingPageValidations(BookingPageValidation);
    }
    const res = await getUserDetails(getUserAgentId());
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      if (!isEmpty(User)) {
        setAgent(User);
      }
    }
    const gstRes = await getAgentGSTList(getUserAgentId());
    if (
      gstRes &&
      gstRes.Root &&
      gstRes.Root.Status === 'OK' &&
      !isEmpty(gstRes.Root.Result.AgentwiseGSTDetails)
    ) {
      const { AgentwiseGSTDetails } = gstRes.Root.Result;
      const list = Array.isArray(AgentwiseGSTDetails)
        ? AgentwiseGSTDetails
        : [AgentwiseGSTDetails];
      list.forEach((company) => {
        company.label = company.GSTCompany;
        company.value = company.GSTNumber;
      });
      setAgentwiseGSTlist(list);
    }
    const numAdults = parseInt(searchRequest.numadults, 10);
    const numChildren = parseInt(searchRequest.numchildren, 10);
    const numInfants = parseInt(searchRequest.numinfants, 10);
    const eligiblePax = numAdults + numChildren;
    const transactionFee =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.transactionfee
        : selectedFare.onward.transactionfee +
          selectedFare.return.transactionfee;
    const transactionFeePerPax = transactionFee / eligiblePax;
    const adultBaseFare =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.adultbasefare
        : selectedFare.onward.adultbasefare + selectedFare.return.adultbasefare;
    const adultOtTax =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.adulttax
        : selectedFare.onward.adulttax + selectedFare.return.adulttax;
    const adultFuelCharge =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.adultyq
        : selectedFare.onward.adultyq + selectedFare.return.adultyq;
    let adultOTCharge = 0;
    let childOTCharge = 0;
    let infantOTCharge = 0;
    let adultYRValue = 0;
    let childYRValue = 0;
    let infantYRValue = 0;

    if (
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
    ) {
      const { othertaxesbreakup } = selectedFare.onward;
      const list = Array.isArray(othertaxesbreakup)
        ? othertaxesbreakup
        : [othertaxesbreakup];
      if (list.length === 0) {
        adultOTCharge = selectedFare.onward.totaltax;
      } else {
        list.forEach((ele) => {
          if (
            ele.taxcode !== 'YR' &&
            ele.taxcode !== 'ADT_YR' &&
            ele.taxcode !== 'CHD_YR' &&
            ele.taxcode !== 'INF_YR'
          ) {
            if (ele.taxcode.indexOf('ADT_') > -1 || ele.paxtype === 'ADT') {
              adultOTCharge += ele.taxamount;
            }
            if (ele.taxcode.indexOf('CHD_') > -1 || ele.paxtype === 'CHD') {
              childOTCharge += ele.taxamount;
            }
            if (ele.taxcode.indexOf('INF_') > -1 || ele.paxtype === 'INF') {
              infantOTCharge += ele.taxamount;
            }
          }
        });
        adultYRValue = getTaxValue(list, 'ADT', 'YR');
        childYRValue = getTaxValue(list, 'CHD', 'YR');
        infantYRValue = getTaxValue(list, 'INF', 'YR');
      }
    } else {
      const { othertaxesbreakup: onwardTaxes } = selectedFare.onward;
      const onwardList = Array.isArray(onwardTaxes)
        ? onwardTaxes
        : [onwardTaxes];
      const { othertaxesbreakup: returnTaxes } = selectedFare.return;
      const returnList = Array.isArray(returnTaxes)
        ? returnTaxes
        : [returnTaxes];

      if (onwardList.length === 0) {
        adultOTCharge += selectedFare.onward.totaltax;
      } else {
        onwardList.forEach((ele) => {
          if (
            ele.taxcode !== 'YR' &&
            ele.taxcode !== 'ADT_YR' &&
            ele.taxcode !== 'CHD_YR' &&
            ele.taxcode !== 'INF_YR'
          ) {
            if (ele.taxcode.indexOf('ADT_') > -1 || ele.paxtype === 'ADT') {
              adultOTCharge += ele.taxamount;
            }
            if (ele.taxcode.indexOf('CHD_') > -1 || ele.paxtype === 'CHD') {
              childOTCharge += ele.taxamount;
            }
            if (ele.taxcode.indexOf('INF_') > -1 || ele.paxtype === 'INF') {
              infantOTCharge += ele.taxamount;
            }
          }
        });
      }
      if (returnList.length === 0) {
        adultOTCharge += selectedFare.return.totaltax;
      } else {
        returnList.forEach((ele) => {
          if (
            ele.taxcode !== 'YR' &&
            ele.taxcode !== 'ADT_YR' &&
            ele.taxcode !== 'CHD_YR' &&
            ele.taxcode !== 'INF_YR'
          ) {
            if (ele.taxcode.indexOf('ADT_') > -1 || ele.paxtype === 'ADT') {
              adultOTCharge += ele.taxamount;
            }
            if (ele.taxcode.indexOf('CHD_') > -1 || ele.paxtype === 'CHD') {
              childOTCharge += ele.taxamount;
            }
            if (ele.taxcode.indexOf('INF_') > -1 || ele.paxtype === 'INF') {
              infantOTCharge += ele.taxamount;
            }
          }
        });
      }
      adultYRValue =
        getTaxValue(onwardList, 'ADT', 'YR') +
        getTaxValue(returnList, 'ADT', 'YR');
      childYRValue +=
        getTaxValue(onwardList, 'CHD', 'YR') +
        getTaxValue(returnList, 'CHD', 'YR');
      infantYRValue =
        getTaxValue(onwardList, 'INF', 'YR') +
        getTaxValue(returnList, 'INF', 'YR');
    }
    const adultTotalFare = adultBaseFare + adultOtTax + transactionFeePerPax;
    const childBaseFare =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.childbasefare
        : selectedFare.onward.childbasefare + selectedFare.return.childbasefare;
    const childTotalTax =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.childtax
        : selectedFare.onward.childtax + selectedFare.return.childtax;
    const childFuelCharge =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.childyq
        : selectedFare.onward.childyq + selectedFare.return.childyq;
    const childTotalFare = childBaseFare + childTotalTax + transactionFeePerPax;
    const infantBaseFare =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.infantbasefare
        : selectedFare.onward.infantbasefare +
          selectedFare.return.infantbasefare;
    const infantTotalTax =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.infanttax
        : selectedFare.onward.infanttax + selectedFare.return.infanttax;
    const infantFuelCharge =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.infantyq
        : selectedFare.onward.infantyq + selectedFare.return.infantyq;
    const infantTotalFare = infantBaseFare + infantTotalTax;
    const handlingCharges =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.handlingcharges
        : selectedFare.onward.handlingcharges +
          selectedFare.return.handlingcharges;
    const serviceTax =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.servicetax
        : selectedFare.onward.servicetax + selectedFare.return.servicetax;
    const markUp =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.markup
        : selectedFare.onward.markup + selectedFare.return.markup;
    const tds =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.tds
        : selectedFare.onward.tds + selectedFare.return.tds;
    const discount =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.discount
        : selectedFare.onward.discount + selectedFare.return.discount;
    const plbEarned =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.plb
        : selectedFare.onward.plb + selectedFare.return.plb;
    const totalNet =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.totalnet
        : selectedFare.onward.totalnet + selectedFare.return.totalnet;
    const totalBaseFare =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.totalbasefare
        : selectedFare.onward.totalbasefare + selectedFare.return.totalbasefare;
    const totalTax =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.totaltax
        : selectedFare.onward.totaltax + selectedFare.return.totaltax;
    const totalFq =
      journeyType === JOURNEY_TYPES.ONE_WAY ||
      journeyType === JOURNEY_TYPES.MULTI_CITY ||
      rePriceResponse.domint === 'international'
        ? selectedFare.onward.totalfq
        : selectedFare.onward.totalfq + selectedFare.return.totalfq;
    const insuranceAmount = 0;
    const AdditionalMarkupToShow = markUp;
    adultOTCharge = adultOtTax - adultFuelCharge - adultYRValue; // adultOTCharge - adultFuelCharge;
    childOTCharge = childTotalTax - childFuelCharge - childYRValue;
    infantOTCharge = infantTotalTax - infantFuelCharge - infantYRValue;
    const totalYRValue =
      adultYRValue * numAdults +
      childYRValue * numChildren +
      infantYRValue * numInfants;

    fareSummaryRef.current = {
      adultBaseFare,
      childBaseFare,
      infantBaseFare,
      adultOTCharge,
      childOTCharge,
      infantOTCharge,
      adultYRValue,
      childYRValue,
      adultTotalFare,
      childTotalFare,
      infantTotalFare,
      childTotalTax,
      infantTotalTax,
      infantYRValue,
      adultFuelCharge,
      childFuelCharge,
      infantFuelCharge,
      handlingCharges,
      transactionFee,
      transactionFeePerPax,
      gst: serviceTax,
      tds,
      markUp,
      discount,
      totalBaseFare,
      totalTax,
      seatPrice: 0,
      mealPrice: 0,
      baggagePrice: 0,
      AdditionalMarkupToShow,
      totalFare: totalFq + insuranceAmount,
      totalNet,
      totalFq,
      plbEarned,
      adultOtTax,
      totalYRValue,
      totalAmountToShow: totalNet + totalYRValue + insuranceAmount,
    };
    setEligiblePaxForTravelInsurance(numAdults + numChildren);
    let list = [];
    const adults = new Array(numAdults).fill(0).map(() => ({
      title: '',
      first_name: '',
      last_name: '',
      dob: '',
      type: 'Adult',
      tour_code: '',
      deal_code: '',
      frequent_flyer_number: '',
      frequent_flyer_number_onward: '',
      frequent_flyer_number_return: '',
      visa: '',
      passport: '',
      passport_dateofexpiry: '',
      passport_dateofissue: '',
      passport_placeofissue: '',
      agentid: '',
      meal_preference: '',
      seat_preference: '',
      additional_segmentinfo: '',
      paxssrinfo: [],
      profileid: '',
      endorsement_code: '',
      beneficiaryname: '',
      additional_basehc: 0,
      additional_taxhc: 0,
      gender: '',
      idproof: '',
    }));
    const children = new Array(numChildren).fill(0).map(() => ({
      title: '',
      first_name: '',
      last_name: '',
      dob: '',
      type: 'Child',
      tour_code: '',
      deal_code: '',
      frequent_flyer_number: '',
      frequent_flyer_number_onward: '',
      frequent_flyer_number_return: '',
      visa: '',
      passport: '',
      passport_dateofexpiry: '',
      passport_dateofissue: '',
      passport_placeofissue: '',
      agentid: '',
      meal_preference: '',
      seat_preference: '',
      additional_segmentinfo: '',
      paxssrinfo: [],
      profileid: '',
      endorsement_code: '',
      beneficiaryname: '',
      additional_basehc: 0,
      additional_taxhc: 0,
      gender: '',
      idproof: '',
    }));
    const infants = new Array(numInfants).fill(0).map(() => ({
      title: '',
      first_name: '',
      last_name: '',
      dob: '',
      type: 'Infant',
      tour_code: '',
      deal_code: '',
      frequent_flyer_number: '',
      frequent_flyer_number_onward: '',
      frequent_flyer_number_return: '',
      visa: '',
      passport: '',
      passport_dateofexpiry: '',
      passport_dateofissue: '',
      passport_placeofissue: '',
      agentid: '',
      meal_preference: '',
      seat_preference: '',
      additional_segmentinfo: '',
      paxssrinfo: [],
      profileid: '',
      endorsement_code: '',
      beneficiaryname: '',
      additional_basehc: 0,
      additional_taxhc: 0,
      gender: '',
      idproof: '',
    }));
    list = [...adults, ...children, ...infants];
    const markupList = [];
    list.forEach((pax) => {
      const markupObj = { Type: pax.type, tax_amount: '' };
      markupList.push(markupObj);
    });
    setTempMarkupList(markupList);
    let onwardFlightLegs;
    if (journeyType === 'multicity') {
      const legsList = [];
      selectedFlight.onward.forEach((flight) => {
        flight.flightlegs.forEach((leg) => {
          legsList.push(leg);
        });
      });
      onwardFlightLegs = legsList;
    } else {
      onwardFlightLegs = selectedFlight.onward.flightlegs;
    }
    const userSelectedSsrRowsTemp = {};
    if (
      onwardFlightLegs[0] !== undefined &&
      onwardFlightLegs[0].operatedby !== '' &&
      onwardFlightLegs[0].operatedby !== undefined
    ) {
      validatingOrOperatingCarrierCodeRef.current =
        onwardFlightLegs[0].operatedby.split('-')[0];
    } else if (
      onwardFlightLegs[0] !== undefined &&
      onwardFlightLegs[0].validatingcarrier !== '' &&
      onwardFlightLegs[0].validatingcarrier !== undefined
    ) {
      validatingOrOperatingCarrierCodeRef.current =
        onwardFlightLegs[0].validatingcarrier;
    } else {
      validatingOrOperatingCarrierCodeRef.current = onwardFlightLegs[0].carrier;
    }
    onwardFlightLegs.forEach((flightLeg) => {
      const sectorKey = `${flightLeg.origin} - ${flightLeg.destination}`;
      flightSectorsRef.current.push(sectorKey);
      onwardFlightSectorsRef.current.push(sectorKey);
      userSelectedSsrRowsTemp[sectorKey] = {
        baggageRows: getBaggageSsrRows(list, flightLeg, 'onward'),
        mealRows: getMealSsrRows(list, flightLeg, 'onward'),
        seatRows: getSeatSsrRows(list, flightLeg, 'onward'),
        specialSsrRows: getSpecialSsrRows(list, flightLeg, 'onward'),
        specialAssistanceRows: getSpecialAssistanceRows(
          list,
          flightLeg,
          'onward',
        ),
      };
    });
    if (onwardFlightLegs.length > 0) {
      const { origin } = onwardFlightLegs[0];
      const { destination } = onwardFlightLegs[onwardFlightLegs.length - 1];
      const sectorKey = `${origin} - ${destination}`;
      onwardOriginRef.current = origin;
      onwardDestinationRef.current = destination;
      if (userSelectedSsrRowsTemp[sectorKey] === undefined) {
        const flightLeg = {
          origin,
          destination,
          carrier: onwardFlightLegs[0].carrier,
          flightnumber: onwardFlightLegs[0].flightnumber,
        };
        userSelectedSsrRowsTemp[sectorKey] = {
          baggageRows: getBaggageSsrRows(list, flightLeg, 'onward'),
          mealRows: getMealSsrRows(list, flightLeg, 'onward'),
          seatRows: getSeatSsrRows(list, flightLeg, 'onward'),
          specialSsrRows: getSpecialSsrRows(list, flightLeg, 'onward'),
          specialAssistanceRows: getSpecialAssistanceRows(
            list,
            flightLeg,
            'onward',
          ),
        };
      }
    }
    if (selectedFlight.return) {
      const returnFlightLegs = selectedFlight.return.flightlegs;
      returnFlightLegs.forEach((flightLeg) => {
        const sectorKey = `${flightLeg.origin} - ${flightLeg.destination}`;
        flightSectorsRef.current.push(sectorKey);
        returnFlightSectorsRef.current.push(sectorKey);
        userSelectedSsrRowsTemp[sectorKey] = {
          baggageRows: getBaggageSsrRows(list, flightLeg, 'return'),
          mealRows: getMealSsrRows(list, flightLeg, 'return'),
          seatRows: getSeatSsrRows(list, flightLeg, 'return'),
          specialSsrRows: getSpecialSsrRows(list, flightLeg, 'return'),
          specialAssistanceRows: getSpecialAssistanceRows(
            list,
            flightLeg,
            'return',
          ),
        };
      });
      if (returnFlightLegs.length > 0) {
        const { origin } = returnFlightLegs[0];
        const { destination } = returnFlightLegs[returnFlightLegs.length - 1];
        const sectorKey = `${origin} - ${destination}`;
        returnOriginRef.current = origin;
        returnDestinationRef.current = destination;
        if (userSelectedSsrRowsTemp[sectorKey] === undefined) {
          const flightLeg = {
            origin,
            destination,
            carrier: returnFlightLegs[0].carrier,
            flightnumber: returnFlightLegs[0].flightnumber,
          };
          userSelectedSsrRowsTemp[sectorKey] = {
            baggageRows: getBaggageSsrRows(list, flightLeg, 'return'),
            mealRows: getMealSsrRows(list, flightLeg, 'return'),
            seatRows: getSeatSsrRows(list, flightLeg, 'return'),
            specialSsrRows: getSpecialSsrRows(list, flightLeg, 'return'),
            specialAssistanceRows: getSpecialAssistanceRows(
              list,
              flightLeg,
              'return',
            ),
          };
        }
      }
    }
    let isGds = false;
    let isSearies = false;
    let isHold = false;
    let requireGst = false;
    if (journeyType !== JOURNEY_TYPES.MULTI_CITY) {
      if (selectedFlight?.onward?.isgstmandatory?.toLowerCase() === 'true') {
        requireGst = true;
      } else if (domInt === 'domestic' && selectedFlight.return) {
        if (selectedFlight?.return?.isgstmandatory?.toLowerCase() === 'true') {
          requireGst = true;
        }
      }
      selectedFlight.onward.flightlegs.forEach((leg) => {
        if (['AI'].indexOf(leg.carrier.substring(0, 2)) > -1) {
          isGds = true;
        }
        if (leg?.carriername?.toLowerCase().includes('series')) {
          isSearies = true;
        }
      });
      if (selectedFlight.return) {
        selectedFlight.return.flightlegs.forEach((leg) => {
          if (['AI'].indexOf(leg.carrier.substring(0, 2)) > -1) {
            isGds = true;
          }
          if (leg.carriername?.toLowerCase().includes('series')) {
            isSearies = true;
          }
        });
      }
      if (selectedFlight?.onward?.isholdallowed?.toLowerCase() === 'true') {
        if (selectedFlight.return && rePriceResponse.domint === 'domestic') {
          if (selectedFlight?.return?.isholdallowed?.toLowerCase() === 'true') {
            isHold = true;
          }
        } else {
          isHold = true;
        }
      }
      setIsSeatMandatoryForOnward(
        selectedFlight?.onward?.isseatrequired?.toLowerCase() === 'true',
      );
      setIsSeatMandatoryForReturn(
        selectedFlight?.return?.isseatrequired?.toLowerCase() === 'true',
      );
      setIsMealMandatoryForOnward(
        selectedFlight?.onward?.ismealrequired?.toLowerCase() === 'true',
      );
      setIsMealMandatoryForReturn(
        selectedFlight?.return?.ismealrequired?.toLowerCase() === 'true',
      );
      setIsBaggageMandatoryForOnward(
        selectedFlight?.onward?.isbaggagerequired?.toLowerCase() === 'true',
      );
      setIsBaggageMandatoryForReturn(
        selectedFlight?.return?.isbaggagerequired?.toLowerCase() === 'true',
      );
    }
    if (
      passThroughInfo &&
      passThroughInfo !== null &&
      passThroughInfo !== undefined
    ) {
      const isPassThroughAvail =
        passThroughInfo.onwardPassthrough || passThroughInfo.returnPassthrough;
      setIsPassthrough(isPassThroughAvail);
      if (
        passThroughInfo &&
        passThroughInfo.onwardcards &&
        passThroughInfo.onwardcards !== ''
      ) {
        const onwardId =
          passThroughInfo.onwardcards?.OnwardPassThroughCard
            ?.onwardPassthroughId;
        if (onwardId) {
          setOnwardPassThroughId(onwardId);
        }
      }
      if (
        passThroughInfo &&
        passThroughInfo.returncards &&
        passThroughInfo.returncards !== ''
      ) {
        const returnId =
          passThroughInfo.returncards?.ReturnPassThroughCard
            ?.returnPassthroughId;
        if (returnId) {
          setReturnPassThroughId(returnId);
        }
      }
    }
    if (getEligibilityForPgOptions()) {
      const userProfile = getObjectFromLS(APP_USER_PROFILE);
      const response = await getPaymentGateway(userProfile?.agentId);
      if (
        response &&
        response.Root &&
        response.Root.Status === 'OK' &&
        response.Root.StatusCode === 200
      ) {
        const availPgs = response?.Root?.Result?.AvailablePaymentGateways;
        if (availPgs !== '' && availPgs !== undefined && availPgs !== null) {
          let pglist = availPgs.AvailablePaymentGateway;
          pglist = Array.isArray(pglist) ? pglist : [pglist];
          selectedPaymentGatewayRef.current = pglist;
          const pgForCreditCard = pglist.filter(
            (x) => x.PaymentMode.toLowerCase() === 'creditcard',
          );
          setTempPgList(pgForCreditCard);
          if (pgForCreditCard.length > 0) {
            setSelectedPg(pgForCreditCard[0].GatewayName);
          }
          setPaymentGateway(true);
        }
      }
    }
    setIsGdsSearch(isGds);
    setIsHoldSupported(isHold);
    setIsSeriesFare(isSearies);
    setIsGstMandatory(requireGst);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
    setTravellers(list);
    scrollToTop();
    setIsLoading(false);
  };

  useEffect(() => {
    if (!isApiRequestProcessingRef.current) {
      initData();
    }
  }, []);

  const handleTitleSelect = (selected, index) => {
    const list = [...travellers];
    if (selected !== null) {
      list[index].title = selected.value;
      if (selected.value === 'Mr' || selected.value === 'Mstr') {
        list[index].gender = 'M';
      } else {
        list[index].gender = 'F';
      }
    } else {
      list[index].title = '';
      list[index].gender = '';
    }
    setTravellers(list);
  };
  const handleGenderSelect = (selected, index) => {
    const list = [...travellers];
    if (selected !== null) {
      list[index].gender = selected.value;
    } else {
      list[index].gender = '';
    }
    setTravellers(list);
  };

  const handleSwitchChange = (index) => {
    const list = [...travellers];
    list[index].specialAssitance = true;
    selectedTravellerRef.current = list[index];
    selectedSpecialAssistanceIndexRef.current = index;
    setShowSpecialAssistance(true);
    setTravellers(list);
  };

  const handleTextInputChange = (event, index) => {
    const { name, value } = event.target;
    if (name === 'first_name' || name === 'last_name') {
      if (!isEmpty(value) && value.length > 32) {
        return false;
      }
    }
    const list = [...travellers];
    list[index][name] = value;
    setTravellers(list);
  };

  const handleAddAddOn = async (addOnType) => {
    if (addOnType === ADDONS.SEAT) {
      if (!hasSeatMapRef.current) {
        setIsLoading(true);
        await getSeatLayout();
        hasSeatMapRef.current = true;
        setIsLoading(false);
      }
      setShowSeatMap(true);
      const sectors = Object.keys(flightLegsWithSeatsRef.current);
      if (sectors.length > 0) {
        setSeatSelectionSector(sectors[0]);
        setActiveSeatIndex(0);
      }
    } else {
      if (!hasSsrRef.current) {
        setIsLoading(true);
        await getSSRLayout();
        hasSsrRef.current = true;
        setIsLoading(false);
      }
      if (addOnType === ADDONS.MEALS) {
        setActiveMealIndex(0);
        setShowMeals(true);
      } else if (addOnType === ADDONS.BAGGAGE) {
        setActiveBagIndex(0);
        setShowBaggage(true);
      } else if (addOnType === ADDONS.SPECIAL_SSR) {
        setActiveSsrIndex(0);
        setShowSpecialSsr(true);
      }
    }
  };

  const handleUpdateTotalNet = (userSelectedSsrRowsTemp) => {
    let seatPrice = 0;
    let mealPrice = 0;
    let baggagePrice = 0;
    let specialSsrPrice = 0;
    let hasSeat = false;
    let hasMeal = false;
    let hasBaggage = false;
    let hasSpecialSsr = false;
    let addMarkup = 0;
    Object.keys(userSelectedSsrRowsTemp).forEach((key) => {
      userSelectedSsrRowsTemp[key].seatRows.forEach((row) => {
        if (
          row.ssr_chargeableamount !== '' &&
          row.ssr_chargeableamount !== undefined
        ) {
          seatPrice += row.ssr_chargeableamount;
          hasSeat = true;
        }
      });
      userSelectedSsrRowsTemp[key].mealRows.forEach((row) => {
        if (
          row.ssr_chargeableamount !== '' &&
          row.ssr_chargeableamount !== undefined
        ) {
          mealPrice += row.ssr_chargeableamount;
          hasMeal = true;
        }
      });
      userSelectedSsrRowsTemp[key].baggageRows.forEach((row) => {
        if (
          row.ssr_chargeableamount !== '' &&
          row.ssr_chargeableamount !== undefined
        ) {
          baggagePrice += row.ssr_chargeableamount;
          hasBaggage = true;
        }
      });
      userSelectedSsrRowsTemp[key].specialSsrRows.forEach((row) => {
        if (
          row.ssr_chargeableamount !== '' &&
          row.ssr_chargeableamount !== undefined
        ) {
          specialSsrPrice += row.ssr_chargeableamount;
          hasSpecialSsr = true;
        }
      });
    });
    if (showMarkup) {
      addMarkup = additionalMarkup;
    }
    fareSummaryRef.current.hasSeat = hasSeat;
    fareSummaryRef.current.hasMeal = hasMeal;
    fareSummaryRef.current.hasBaggage = hasBaggage;
    fareSummaryRef.current.hasSpecialSsr = hasSpecialSsr;
    fareSummaryRef.current.seatPrice = seatPrice;
    fareSummaryRef.current.mealPrice = mealPrice;
    fareSummaryRef.current.baggagePrice = baggagePrice;
    fareSummaryRef.current.specialSsrPrice = specialSsrPrice;
    fareSummaryRef.current.AdditionalMarkupToShow =
      addMarkup + fareSummaryRef.current.markUp;
    fareSummaryRef.current.totalAmountToShow = getTotalAmountToShow();
    fareSummaryRef.current.totalFare =
      fareSummaryRef.current.totalFq +
      seatPrice +
      mealPrice +
      baggagePrice +
      specialSsrPrice +
      getTravelInsuranceAmount() +
      addMarkup;
  };

  const handleSeatSelection = (seat, sector, carrier) => {
    if (seat.seatstatus === 'Open') {
      const childRestricted =
        seat &&
        seat.additionalinfo.toLowerCase().indexOf('childrestricted') > 1;
      if (
        travellers[activeSeatIndex].type.toLowerCase() === 'child' &&
        childRestricted
      ) {
        setAlert({
          title: formattedMessage('seat_selection'),
          description: formattedMessage('reserved_for_child_alert'),
          variant: 'error',
        });
      } else {
        const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
        if (
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode !==
            seat.seatdesignator &&
          userSelectedSsrRowsTemp[sector].seatRows.filter(
            (x) => x.ssrcode === seat.seatdesignator,
          ).length > 0
        ) {
          setAlert({
            title: formattedMessage('seat_selection'),
            description: formattedMessage('reserved_for_other_pax_alert'),
            variant: 'error',
          });
        } else if (
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode ===
          seat.seatdesignator
        ) {
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode =
            '';
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
            '';
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid =
            seat.seatgroup;
          userSelectedSsrRowsTemp[sector].seatRows[
            activeSeatIndex
          ].ssr_chargeableamount = '';
        } else {
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode =
            seat.seatdesignator;

          if (carrier === '6E' || carrier === 'AI') {
            userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
              seat.yval;
            userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid =
              seat.yval;
          } else {
            userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
              seat.seatgroup;
            userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid =
              seat.seatgroup;
          }

          userSelectedSsrRowsTemp[sector].seatRows[
            activeSeatIndex
          ].ssr_chargeableamount = seat.seatprice;
        }
        handleUpdateTotalNet(userSelectedSsrRowsTemp);
        hasDoneSeatCallRef.current = true;
        setUserSelectedSsrRows(userSelectedSsrRowsTemp);
        const eligiblePaxLength =
          parseInt(searchRequest.numadults, 10) +
          parseInt(searchRequest.numchildren, 10);
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        const newFilterdSeatSector = sectors.filter((sr) =>
          userSelectedSsrRowsTemp[sr].seatRows.some((s) => s.ssrcode === ''),
        );

        const hasSelectedSeatForThisSector = (passengerIndex, givenSector) => {
          return (
            userSelectedSsrRowsTemp[givenSector].seatRows[passengerIndex]
              .ssrcode !== ''
          );
        };

        const countPassengersWithSeatForThisSector = (givenSector) => {
          let count = 0;
          travellers.forEach((traveller, index) => {
            if (traveller.type.toLowerCase() !== 'infant') {
              if (hasSelectedSeatForThisSector(index, givenSector)) {
                count++;
              }
            }
          });
          return count;
        };

        const numPaxSelectedseatsForSector =
          countPassengersWithSeatForThisSector(sector);

        let numSeatSelectedPax = 0;
        sectors.forEach((d) => {
          travellers.forEach((traveller, index) => {
            if (traveller.type.toLowerCase() !== 'infant') {
              if (hasSelectedSeatForThisSector(index, d)) {
                numSeatSelectedPax++;
              }
            }
          });
        });

        let numSelectedSeats = 0;
        sectors.forEach((d) => {
          userSelectedSsrRowsTemp[d].seatRows.forEach((seatRow) => {
            if (seatRow.ssrcode !== '') {
              numSelectedSeats += 1;
            }
          });
        });

        const maxSeatsForSelection = sectors.length * eligiblePaxLength;
        if (!isSeatEditMode) {
          if (
            activeSeatIndex < travellers.length - 1 &&
            travellers[activeSeatIndex + 1].type.toLowerCase() !== 'infant'
          ) {
            setActiveSeatIndex(activeSeatIndex + 1);
          }
          if (numPaxSelectedseatsForSector === eligiblePaxLength) {
            if (newFilterdSeatSector.length > 0) {
              setSeatSelectionSector(newFilterdSeatSector[0]);
              setActiveSeatIndex(0);
            }
          }
          if (maxSeatsForSelection === numSelectedSeats) {
            // setShowSeatMap(false);
            setIsSeatEditMode(true);
          }
        }
      }
    }
  };

  const getAddStatus = () => {
    if (Object.entries(userSelectedSsrRows).length > 0) {
      const sectorValues = Object.values(userSelectedSsrRows);
      const tempSSRrows = Array.isArray(sectorValues)
        ? sectorValues
        : [sectorValues];
      let isSeat = false;
      let isBag = false;
      let isMeal = false;
      let isSpecialSsr = false;
      if (tempSSRrows.length > 0) {
        tempSSRrows.forEach((sector) => {
          sector.seatRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isSeat = true;
            }
          });
          sector.baggageRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isBag = true;
            }
          });
          sector.mealRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isMeal = true;
            }
          });
          sector.specialSsrRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isSpecialSsr = true;
            }
          });
        });
      }
      setIsBaggageSelected(isBag);
      setIsMealSelected(isMeal);
      setIsSeatSelected(isSeat);
      setIsSpecialSsrSelected(isSpecialSsr);
    }
  };

  useEffect(() => {
    getAddStatus();
  }, [userSelectedSsrRows]);

  const handleRemoveSeat = (seat, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const filterdIndex = userSelectedSsrRowsTemp[sector].seatRows.findIndex(
      (row) => seat.ssrcode === row.ssrcode,
    );
    userSelectedSsrRowsTemp[sector].seatRows[filterdIndex].ssrname = '';
    userSelectedSsrRowsTemp[sector].seatRows[filterdIndex].ssrid = '';
    userSelectedSsrRowsTemp[sector].seatRows[filterdIndex].ssrcode = '';
    userSelectedSsrRowsTemp[sector].seatRows[
      filterdIndex
    ].ssr_chargeableamount = '';
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };
  const handleRemoveMeal = (meal, index, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    // const filterdIndex = userSelectedSsrRowsTemp[sector].mealRows.findIndex(
    //   (row) => row.travellerIndex === index && meal.ssrcode === row.ssrcode,
    // );
    const filterdIndex = userSelectedSsrRowsTemp[sector].mealRows.findIndex(
      (row) => meal.ssrcode === row.ssrcode,
    );
    const existingMeal = {
      ...userSelectedSsrRowsTemp[sector].mealRows[filterdIndex],
    };
    userSelectedSsrRowsTemp[sector].mealRows[filterdIndex] = {
      ...existingMeal,
      ssrcode: '',
      ssrname: '',
      ssrid: '',
      ssr_chargeableamount: '',
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const handleAddMeal = (meal, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const firstMealRow = userSelectedSsrRowsTemp[sector].mealRows.find(
      (row) => row.travellerIndex === activeMealIndex,
    );
    userSelectedSsrRowsTemp[sector].mealRows[activeMealIndex] = {
      ...firstMealRow,
      ssrcode: meal.ssrcode,
      ssrname: meal.ssrname,
      ssrid: meal.ssrid,
      ssr_chargeableamount: meal.chargeableamount,
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    hasDoneSsrCallRef.current = true;
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);

    const eligiblePaxLength =
      parseInt(searchRequest.numadults, 10) +
      parseInt(searchRequest.numchildren, 10);
    const sectors = Object.keys(flightLegsWithMealRef.current);
    const newFilterdmealSector = sectors.filter((ms) => ms !== sector);

    const hasSelectedMealForThisSector = (passengerIndex, givenSector) => {
      return userSelectedSsrRowsTemp[givenSector].mealRows.some(
        (mr) => mr.ssrcode !== '' && mr.travellerIndex === passengerIndex,
      );
    };

    const countPassengersWithMealForThisSector = (givenSector) => {
      let count = 0;
      travellers.forEach((traveller, index) => {
        if (traveller.type.toLowerCase() !== 'infant') {
          if (hasSelectedMealForThisSector(index, givenSector)) {
            count++;
          }
        }
      });
      return count;
    };
    const numPaxSelectedmealsForSector =
      countPassengersWithMealForThisSector(sector);

    let numMealSelectedPax = 0;
    sectors.forEach((d) => {
      travellers.forEach((traveller, index) => {
        if (traveller.type.toLowerCase() !== 'infant') {
          if (hasSelectedMealForThisSector(index, d)) {
            numMealSelectedPax++;
          }
        }
      });
    });
    const maxMealForSelection = sectors.length * eligiblePaxLength;
    if (!isMealEditMode) {
      if (
        activeMealIndex < travellers.length - 1 &&
        travellers[activeMealIndex + 1].type.toLowerCase() !== 'infant'
      ) {
        setActiveMealIndex(activeMealIndex + 1);
      }
      if (numPaxSelectedmealsForSector === eligiblePaxLength) {
        if (newFilterdmealSector.length > 0) {
          const newRows = newFilterdmealSector.filter(
            (sec) =>
              hasSelectedMealForThisSector(activeMealIndex, sec) === false,
          );
          if (newRows.length > 0) {
            setMealSelectionSector(newRows[0]);
          } else {
            setMealSelectionSector(newFilterdmealSector[0]);
          }
          setActiveMealIndex(0);
        }
      }
      if (maxMealForSelection === numMealSelectedPax) {
        setIsMealEditMode(true);
        setActiveMealIndex(0);
      }
    }
  };

  const getBaggageKey = (code, id) => `${code}###${id}`;

  const handleRemoveBaggage = (baggage, index, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const filterdIndex = userSelectedSsrRowsTemp[sector].baggageRows.findIndex(
      (row) =>
        row.travellerIndex === index &&
        getBaggageKey(row.ssrcode, row.ssrid) ===
          getBaggageKey(baggage.ssrcode, baggage.ssrid),
    );
    const existingBag = {
      ...userSelectedSsrRowsTemp[sector].baggageRows[filterdIndex],
    };
    userSelectedSsrRowsTemp[sector].baggageRows[filterdIndex] = {
      ...existingBag,
      ssrcode: '',
      ssrname: '',
      ssrid: '',
      ssr_chargeableamount: '',
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const handleAddBaggage = (baggage, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const rows = userSelectedSsrRowsTemp[sector].baggageRows.filter(
      (row) =>
        row.travellerIndex === activeBagIndex &&
        getBaggageKey(row.ssrcode, row.ssrid) ===
          getBaggageKey(baggage.ssrcode, baggage.ssrid),
    );
    if (rows.length > 0) {
      setAlert({
        variant: 'error',
        title: 'Baggage Selection',
        description: 'You cannot select the same baggage type',
      });
    } else {
      const firstBaggageRow = userSelectedSsrRowsTemp[sector].baggageRows.find(
        (row) => row.travellerIndex === activeBagIndex,
      );
      userSelectedSsrRowsTemp[sector].baggageRows[activeBagIndex] = {
        ...firstBaggageRow,
        ssrcode: baggage.ssrcode,
        ssrname: baggage.ssrname,
        ssrid: baggage.ssrid,
        ssr_chargeableamount: baggage.chargeableamount,
      };
      handleUpdateTotalNet(userSelectedSsrRowsTemp);
      hasDoneSsrCallRef.current = true;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);

      const eligiblePaxLength =
        parseInt(searchRequest.numadults, 10) +
        parseInt(searchRequest.numchildren, 10);
      const sectors = Object.keys(flightLegsWithBaggageRef.current).filter(
        (s) => userSelectedSsrRowsTemp && userSelectedSsrRowsTemp[s],
      );
      const newFilterdBagSector = sectors.filter((ms) => ms !== sector);

      const hasSelectedBagForThisSector = (passengerIndex, givenSector) => {
        return userSelectedSsrRowsTemp[givenSector].baggageRows.some(
          (mr) => mr.ssrcode !== '' && mr.travellerIndex === passengerIndex,
        );
      };

      const countPassengersWithBagForThisSector = (givenSector) => {
        let count = 0;
        travellers.forEach((traveller, index) => {
          if (traveller.type.toLowerCase() !== 'infant') {
            if (hasSelectedBagForThisSector(index, givenSector)) {
              count++;
            }
          }
        });
        return count;
      };

      const numPaxSelectedbagsForSector =
        countPassengersWithBagForThisSector(sector);

      let numBagselectedPax = 0;
      sectors.forEach((d) => {
        travellers.forEach((traveller, index) => {
          if (traveller.type.toLowerCase() !== 'infant') {
            if (hasSelectedBagForThisSector(index, d)) {
              numBagselectedPax++;
            }
          }
        });
      });
      const maxBagForSelection = sectors.length * eligiblePaxLength;

      if (!isBagEditMode) {
        if (
          activeBagIndex < travellers.length - 1 &&
          travellers[activeBagIndex + 1].type.toLowerCase() !== 'infant'
        ) {
          setActiveBagIndex(activeBagIndex + 1);
        }
        if (numPaxSelectedbagsForSector === eligiblePaxLength) {
          if (newFilterdBagSector.length > 0) {
            setBaggageSelectionSector(newFilterdBagSector[0]);
            setActiveBagIndex(0);
          }
        }
        if (maxBagForSelection === numBagselectedPax) {
          setIsBagEditMode(true);
          setActiveBagIndex(0);
        }
      }
    }
  };

  const handleAddSpecialSsr = (specialSsr, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };

    const rows = userSelectedSsrRowsTemp[sector].specialSsrRows.filter(
      (row) =>
        row.travellerIndex === activeSsrIndex &&
        row.ssrcode === specialSsr.ssrcode,
    );
    if (rows.length > 0) {
      setAlert({
        variant: 'error',
        title: 'Special SSR Selection',
        description: 'You cannot select the same SSR type',
      });
    } else {
      const firstSsrRow = userSelectedSsrRowsTemp[sector].specialSsrRows.find(
        (row) => row.travellerIndex === activeSsrIndex,
      );
      userSelectedSsrRowsTemp[sector].specialSsrRows[activeSsrIndex] = {
        ...firstSsrRow,
        ssrcode: specialSsr.ssrcode,
        ssrname: specialSsr.ssrname,
        ssrid: specialSsr.ssrid,
        ssr_chargeableamount: specialSsr.chargeableamount,
      };
      handleUpdateTotalNet(userSelectedSsrRowsTemp);
      hasDoneSsrCallRef.current = true;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);

      const eligiblePaxLength =
        parseInt(searchRequest.numadults, 10) +
        parseInt(searchRequest.numchildren, 10);
      const sectors = Object.keys(flightLegsWithSpecialSsr.current);
      const newFilterdSpecialSsrSector = sectors.filter((ms) => ms !== sector);

      const hasSelectedSpecialSsrForThisSector = (
        passengerIndex,
        givenSector,
      ) => {
        return userSelectedSsrRowsTemp[givenSector].specialSsrRows.some(
          (mr) => mr.ssrcode !== '' && mr.travellerIndex === passengerIndex,
        );
      };

      const countPassengersWithSpecialSsrForThisSector = (givenSector) => {
        let count = 0;
        travellers.forEach((traveller, index) => {
          if (traveller.type.toLowerCase() !== 'infant') {
            if (hasSelectedSpecialSsrForThisSector(index, givenSector)) {
              count++;
            }
          }
        });
        return count;
      };
      const numPaxSelectedspecialSsrsForSector =
        countPassengersWithSpecialSsrForThisSector(sector);

      let numSpecialSsrSelectedPax = 0;
      sectors.forEach((d) => {
        travellers.forEach((traveller, index) => {
          if (traveller.type.toLowerCase() !== 'infant') {
            if (hasSelectedSpecialSsrForThisSector(index, d)) {
              numSpecialSsrSelectedPax++;
            }
          }
        });
      });
      const maxSpecialSsrForSelection = sectors.length * eligiblePaxLength;

      if (!isSpecialSSREditMode) {
        if (
          activeSsrIndex < travellers.length - 1 &&
          travellers[activeSsrIndex + 1].type.toLowerCase() !== 'infant'
        ) {
          setActiveSsrIndex(activeSsrIndex + 1);
        }
        if (numPaxSelectedspecialSsrsForSector === eligiblePaxLength) {
          if (newFilterdSpecialSsrSector.length > 0) {
            setSpecialSsrSelectionSector(newFilterdSpecialSsrSector[0]);
            setActiveSsrIndex(0);
          }
        }
        if (maxSpecialSsrForSelection === numSpecialSsrSelectedPax) {
          setIsSpecialSSREditMode(true);
          setActiveSsrIndex(0);
        }
      }
    }
  };

  const handleRemoveSpecialSsr = (specialSsr, index, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const filterdIndex = userSelectedSsrRowsTemp[
      sector
    ].specialSsrRows.findIndex(
      (row) =>
        row.travellerIndex === index && specialSsr.ssrcode === row.ssrcode,
    );
    const existingSpecialSSR = {
      ...userSelectedSsrRowsTemp[sector].specialSsrRows[filterdIndex],
    };
    userSelectedSsrRowsTemp[sector].specialSsrRows[filterdIndex] = {
      ...existingSpecialSSR,
      ssrcode: '',
      ssrname: '',
      ssrid: '',
      ssr_chargeableamount: '',
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    // setIsSpecialSsrSelected(true);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const getSelectedBaggage = (userBaggageRows, index) => {
    const filterdBaggage = userBaggageRows.filter(
      (row) => row.travellerIndex === index && row.ssrname !== '',
    );

    return filterdBaggage.length === 0 ? (
      formattedMessage('select_baggage')
    ) : (
      <ul className="selected-meals">
        {filterdBaggage.map((baggage, fmi) => (
          <li key={fmi}>
            <span className="ssrBaggageDesc">
              {baggage.ssrname} • {formatCurrency(baggage.ssr_chargeableamount)}
            </span>
            <AppIconButton
              onClick={() =>
                handleRemoveBaggage(
                  baggage,
                  index,
                  `${baggage.origin} - ${baggage.destination}`,
                )
              }
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </li>
        ))}
      </ul>
    );
  };

  const handleConfirmationDialogClose = () => {
    setShowConfirmationDialog(false);
  };

  const handleConfirmHoldDialogClose = () => {
    setShowConfirmHoldDialog(false);
  };
  const isDobMandatoryForPax = (type) => {
    if (bookingPageValidations?.dobmandatory) {
      return true;
    }
    if (hasTravelInsurance) {
      return true;
    }
    if (type !== 'Adult') {
      return true;
    }
    return false;
  };

  const getDOBMinDate = (type) => {
    if (journeyType === JOURNEY_TYPES.MULTI_CITY) {
      const firstOnward = getDateWithHypends(
        searchRequest.onwarddate.split(':')[0],
      );
      if (type.toLowerCase() === 'infant') {
        const jdate = getNewDate(firstOnward);
        const minDate = subYears(jdate, 2);
        return minDate;
      }
      if (type.toLowerCase() === 'child') {
        const jdate = getNewDate(firstOnward);
        const minDate = subYears(jdate, 12);
        return minDate;
      }
    } else {
      if (type.toLowerCase() === 'infant') {
        const jdate = getNewDate(searchRequest.onwarddate);
        const minDate = subYears(jdate, 2);
        return minDate;
      }
      if (type.toLowerCase() === 'child') {
        const jdate = getNewDate(searchRequest.onwarddate);
        const minDate = subYears(jdate, 12);
        return minDate;
      }
    }
    return '';
  };

  const getDOBMaxDate = (type) => {
    if (type.toLowerCase() === 'infant') {
      return getNewDate(TODAY_DATE);
    }
    if (journeyType === JOURNEY_TYPES.MULTI_CITY) {
      const firstOnward = getDateWithHypends(
        searchRequest.onwarddate.split(':')[0],
      );
      if (type.toLowerCase() === 'child') {
        const jdate = getNewDate(firstOnward);
        const minDate = subYears(jdate, 2);
        return minDate;
      }
      if (type.toLowerCase() === 'adult' || type === '') {
        const jdate = getNewDate(firstOnward);
        const minDate = subYears(jdate, 12);
        return minDate;
      }
    }
    if (type.toLowerCase() === 'child') {
      const jdate = getNewDate(searchRequest.onwarddate);
      const minDate = subYears(jdate, 2);
      return minDate;
    }
    if (type.toLowerCase() === 'adult' || type === '') {
      const jdate = getNewDate(searchRequest.onwarddate);
      const minDate = subYears(jdate, 12);
      return minDate;
    }
  };

  const handleBook = async () => {
    try {
      if (hasTravelInsurance) {
        let hasError = false;
        travellers.forEach((pax) => {
          if (
            pax.type !== 'Infant' &&
            (!pax.beneficiaryname || pax.beneficiaryname.trim() === '')
          ) {
            hasError = true;
          }
        });
        if (hasError) {
          setAlert({
            variant: 'error',
            title: 'Nominee Details Required',
            description:
              'Please enter nominee names for all travellers before proceeding to payment.',
          });
          setActiveTab(INSURANCE);
          handleRefClick(targetRefs.insurance);
          setIsLoading(false);
          return false;
        }
      }
      setIsLoading(true);
      setShowConfirmationDialog(false);
      setIsBookingClicked(true);
      const travellersList = [...travellers];
      let isError = false;
      for (let i = 0; i < travellersList.length; i++) {
        if (
          travellersList[i].first_name === undefined ||
          travellersList[i].first_name === '' ||
          travellersList[i].first_name.trim() === '' ||
          travellersList[i].last_name === undefined ||
          travellersList[i].last_name === '' ||
          // travellersList[i].gender === '' ||
          travellersList[i].last_name.trim() === ''
        ) {
          isError = true;
          setIsLoading(false);
        }
        if (islcc === 'true' && travellersList[i].title === '') {
          isError = true;
          setIsLoading(false);
        }

        if (
          isDobMandatoryForPax(travellersList[i].type) &&
          travellersList[i].dob === ''
        ) {
          isError = true;
          setIsLoading(false);
        }
      }
      if (
        leademail === '' ||
        leademail === undefined ||
        leadmobile === '' ||
        leadmobile === undefined
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        bookingPageValidations?.pannumbermandatory &&
        searchRequest.searchtype !== 'seniorcitizen' &&
        searchRequest.searchtype !== 'student'
      ) {
        if (
          isEmpty(panNumber) ||
          !PAN_REGEX.test(panNumber.trim().toUpperCase())
        ) {
          isError = true;
          setIsLoading(false);
        }
      }
      travellersList.forEach((trav) => {
        delete trav.gender;
      });
      if (isError) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
      if (
        rePriceResponse.domint === 'international' &&
        !handlepassportduplicates(travellersList)
      ) {
        setAlert({
          variant: 'error',
          title: formattedMessage('validation_error'),
          description: formattedMessage('duplicate_passport_alert'),
        });
        scrollToTop();
        setIsLoading(false);
        return false;
      }
      let hasSpeicalChars = false;
      for (let i = 0; i < travellersList.length; i++) {
        if (
          NAME_REGEX.test(travellersList[i].first_name) === false ||
          NAME_REGEX.test(travellersList[i].last_name) === false
        ) {
          setAlert({
            variant: 'error',
            title: formattedMessage('validation_error'),
            description: `${formattedMessage('valid_traveller_name_alert')} ${
              i + 1
            }`,
          });
          hasSpeicalChars = true;
          break;
        }
      }
      if (hasSpeicalChars) {
        scrollToTop();
        setIsLoading(false);
        return false;
      }
      const sectors = Object.keys(userSelectedSsrRows);
      const selectedSsrRows = [];
      travellers.forEach((traveller, index) => {
        const meals = [];
        sectors.forEach((sector) => {
          userSelectedSsrRows[sector].mealRows.forEach((row) => {
            if (
              row.ssr_chargeableamount !== '' &&
              row.travellerIndex === index
            ) {
              meals.push(`${row.origin}-${row.destination}:${row.ssrcode}`);
            }
          });
        });
        if (meals.length > 0) {
          const mealPref = meals.join(',');
          traveller.meal_preference = mealPref;
        }
      });
      sectors.forEach((sector) => {
        userSelectedSsrRows[sector]?.baggageRows?.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].mealRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].seatRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].specialSsrRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined
          ) {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].specialAssistanceRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined
          ) {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
      });
      const paxList = [];
      travellers.forEach((trav) => {
        paxList.push({ ...trav });
      });
      paxList.forEach((pax) => {
        const ffnNumberList = [];
        if (pax.frequent_flyer_number_onward !== '') {
          const onwardCarrierNameForFFN = `${selectedFlight.onward.flightlegs[0].carrier}${selectedFlight.onward.flightlegs[0].carrier}`;
          ffnNumberList.push(
            `${onwardCarrierNameForFFN}${pax.frequent_flyer_number_onward}`,
          );
        }
        if (
          journeyType === JOURNEY_TYPES.ROUND_TRIP ||
          rePriceResponse.domint === 'domestic'
        ) {
          if (pax.frequent_flyer_number_return !== '') {
            const returnCarrierNameForFFN = `${selectedFlight.return.flightlegs[0].carrier}${selectedFlight.return.flightlegs[0].carrier}`;

            ffnNumberList.push(
              `${returnCarrierNameForFFN}${pax.frequent_flyer_number_return}`,
            );
          }
        }
        pax.frequent_flyer_number = ffnNumberList.join(',');
      });
      paxList.forEach((trav) => {
        delete trav.specialAssitance;
        delete trav.gender;
        delete trav.frequent_flyer_number_onward;
        delete trav.frequent_flyer_number_return;
      });
      let bankId = '';
      if (
        paymentmode === 'netbanking' &&
        (selectedPg === 'techprocessv2' ||
          selectedPg === 'techprocessv2_netbanking' ||
          selectedPg === 'payu')
      ) {
        bankId = selectedBankForNetBanking;
      }
      if (
        bookingPageValidations?.pannumbermandatory &&
        searchRequest.searchtype !== 'seniorcitizen' &&
        searchRequest.searchtype !== 'student'
      ) {
        paxList.forEach((pax) => {
          pax.idproof = `${panNumber}@panNumber`;
        });
      }
      const bookingRequest = {
        bookingrequest: {
          taxInfoStr: rePriceResponse.bookingkey,
          leademail,
          leadmobile,
          leadcountry: 'IN',
          leadcity: 'Bangalore',
          leadstate: 'KA',
          paymentmode: paymentmode,
          pgname: paymentmode === 'cashcard' ? '' : selectedPg,
          domint: rePriceResponse.domint,
          promocode: searchRequest.promocode,
          numadults: searchRequest.numadults,
          numchildren: searchRequest.numchildren,
          numinfants: searchRequest.numinfants,
          passengerList: paxList,
          ssrList: {
            SSRRow: selectedSsrRows,
          },
          gstdetails: {
            gstaddress: gst.gstaddress,
            gstcompany: gst.gstcompany,
            gstnumber: gst.gstnumber,
            gstemail: gst.gstemail,
            gstphone: gst.gstphone,
          },
          wsmode: 'test',
          ispassthrough: isPassThrough ? true : false,
          onwardpassthroughid: onwardPassThroughId,
          returnpassthroughid: returnPassThroughId,
          travelinsurance_included: hasTravelInsurance ? 'true' : 'false',
          travelinsurance_amount: getTravelInsuranceAmount(),
          bankid: bankId,
        },
      };
      if (
        bookingRequest.bookingrequest.gstdetails.gstcompany === '' ||
        bookingRequest.bookingrequest.gstdetails.gstnumber === '' ||
        bookingRequest.bookingrequest.gstdetails.gstaddress === '' ||
        bookingRequest.bookingrequest.gstdetails.gstphone === '' ||
        bookingRequest.bookingrequest.gstdetails.gstemail === ''
      ) {
        bookingRequest.bookingrequest.gstdetails = {
          gstaddress: '',
          gstcompany: '',
          gstnumber: '',
          gstemail: '',
          gstphone: '',
        };
      }
      const userProfile = getObjectFromLS(APP_USER_PROFILE);
      const opid = paymentmode === 'cashcard' ? 'TX004' : 'TX005';
      const actioncode =
        rePriceResponse.domint === 'international' ? 'INTL' : 'DOM';
      const response = await bookFlightApi(
        bookingRequest,
        userProfile?.agentId,
        actioncode,
        opid,
      );
      const apiStatus = response?.ApiStatus;
      if (response && response?.ApiStatus?.Status === 'OK') {
        let txid;
        if (paymentmode === 'cashcard') {
          txid = response?.ApiStatus?.Result;
        } else {
          txid = response?.ApiStatus?.Result?.Txid;
        }
        const markUpTobeAdded =
          additionalMarkup === '' ? 0 : parseInt(additionalMarkup, 10);
        const markupResponse = await addMarkupInTicket(
          userProfile?.agentId,
          txid,
          markUpTobeAdded,
        );
        if (markupResponse && markupResponse?.Root?.Status === 'OK') {
          if (paymentmode === 'cashcard') {
            setAlert({
              variant: 'success',
              title: formattedMessage('flight_booking_success'),
              description: formattedMessage('flight_booking_success_alert'),
            });
            setTimeout(() => {
              navigate(`/flight/ticket/${response.ApiStatus.Result}`);
            }, 2000);
          } else {
            const { Result } = response.ApiStatus;
            if (Result !== '') {
              const { PgUrl, Txid } = Result;
              let urlToRedirect = `${PgUrl}?txid=${Txid}`;
              let selectedBank = selectedBankForNetBanking;
              if (selectedPg === 'payu') {
                selectedBank = '';
              }
              if (paymentmode === 'netbanking') {
                urlToRedirect += `&bankcode=${selectedBank}`;
              }
              window.open(urlToRedirect, '_blank');
            }
          }
        } else {
          setAlert({
            variant: 'error',
            title: formattedMessage('markup_adding_failed'),
            description: markupResponse?.Result?.Result,
          });
        }
      } else {
        setAlert({
          variant: 'error',
          title: formattedMessage('flight_booking_failed'),
          description:
            apiStatus?.Message ||
            apiStatus?.Result ||
            'Payment failed. Please contact support.',
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleHold = async () => {
    try {
      setIsLoading(true);
      setShowConfirmationDialog(false);
      setIsBookingClicked(true);
      const travellersList = [...travellers];
      let isError = false;
      for (let i = 0; i < travellersList.length; i++) {
        if (
          travellersList[i].first_name === undefined ||
          travellersList[i].first_name === '' ||
          travellersList[i].first_name.trim() === '' ||
          travellersList[i].last_name === undefined ||
          travellersList[i].last_name === '' ||
          // travellersList[i].gender === '' ||
          travellersList[i].last_name.trim() === ''
        ) {
          isError = true;
          setIsLoading(false);
        }
        if (islcc === 'true' && travellersList[i].title === '') {
          isError = true;
          setIsLoading(false);
        }
        if (
          isDobMandatoryForPax(travellersList[i].type) &&
          travellersList[i].dob === ''
        ) {
          isError = true;
          setIsLoading(false);
        }
      }
      if (
        leademail === '' ||
        leademail === undefined ||
        leadmobile === '' ||
        leadmobile === undefined
      ) {
        isError = true;
        setIsLoading(false);
      }
      travellersList.forEach((trav) => {
        delete trav.gender;
      });
      if (isError) {
        setValidationError(true);
        scrollToTop();
        return false;
      }

      if (
        rePriceResponse.domint === 'international' &&
        !handlepassportduplicates(travellersList)
      ) {
        setAlert({
          variant: 'error',
          title: formattedMessage('validation_error'),
          description: formattedMessage('duplicate_passport_alert'),
        });
        scrollToTop();
        setIsLoading(false);
        return false;
      }

      let hasSpeicalChars = false;
      for (let i = 0; i < travellersList.length; i++) {
        if (
          NAME_REGEX.test(travellersList[i].first_name) === false ||
          NAME_REGEX.test(travellersList[i].last_name) === false
        ) {
          setAlert({
            variant: 'error',
            title: formattedMessage('validation_error'),
            description: `${formattedMessage('valid_traveller_name_alert')} ${
              i + 1
            }`,
          });
          hasSpeicalChars = true;
          break;
        }
      }
      if (hasSpeicalChars) {
        scrollToTop();
        setIsLoading(false);
        return false;
      }
      const sectors = Object.keys(userSelectedSsrRows);
      const selectedSsrRows = [];
      travellers.forEach((traveller, index) => {
        const meals = [];
        sectors.forEach((sector) => {
          userSelectedSsrRows[sector].mealRows.forEach((row) => {
            if (
              row.ssr_chargeableamount !== '' &&
              row.travellerIndex === index
            ) {
              meals.push(`${row.origin}-${row.destination}:${row.ssrcode}`);
            }
          });
        });
        if (meals.length > 0) {
          const mealPref = meals.join(',');
          traveller.meal_preference = mealPref;
        }
      });
      sectors.forEach((sector) => {
        userSelectedSsrRows[sector]?.baggageRows?.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].mealRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].seatRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].specialSsrRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined
          ) {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].specialAssistanceRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined
          ) {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
      });
      const paxList = [];
      travellers.forEach((trav) => {
        paxList.push({ ...trav });
      });
      paxList.forEach((pax) => {
        const ffnNumberList = [];
        if (pax.frequent_flyer_number_onward !== '') {
          const onwardCarrierNameForFFN = `${selectedFlight.onward.flightlegs[0].carrier}${selectedFlight.onward.flightlegs[0].carrier}`;
          ffnNumberList.push(
            `${onwardCarrierNameForFFN}${pax.frequent_flyer_number_onward}`,
          );
        }
        if (
          journeyType === JOURNEY_TYPES.ROUND_TRIP ||
          rePriceResponse.domint === 'domestic'
        ) {
          if (pax.frequent_flyer_number_return !== '') {
            const returnCarrierNameForFFN = `${selectedFlight.return.flightlegs[0].carrier}${selectedFlight.return.flightlegs[0].carrier}`;

            ffnNumberList.push(
              `${returnCarrierNameForFFN}${pax.frequent_flyer_number_return}`,
            );
          }
        }
        pax.frequent_flyer_number = ffnNumberList.join(',');
      });
      paxList.forEach((trav) => {
        delete trav.specialAssitance;
        delete trav.gender;
        delete trav.frequent_flyer_number_onward;
        delete trav.frequent_flyer_number_return;
      });
      const bookingRequest = {
        bookingrequest: {
          taxInfoStr: rePriceResponse.bookingkey,
          leademail,
          leadmobile,
          leadcountry: 'IN',
          leadcity: 'Bangalore',
          leadstate: 'KA',
          paymentmode: paymentmode,
          domint: rePriceResponse.domint,
          promocode: searchRequest.promocode,
          numadults: searchRequest.numadults,
          numchildren: searchRequest.numchildren,
          numinfants: searchRequest.numinfants,
          passengerList: paxList,
          ssrList: {
            SSRRow: selectedSsrRows,
          },
          gstdetails: {
            gstaddress: gst.gstaddress,
            gstcompany: gst.gstcompany,
            gstnumber: gst.gstnumber,
            gstemail: gst.gstemail,
            gstphone: gst.gstphone,
          },
          wsmode: 'test',
          ispassthrough: isPassThrough ? true : false,
          onwardpassthroughid: onwardPassThroughId,
          returnpassthroughid: returnPassThroughId,
          travelinsurance_included: hasTravelInsurance ? 'true' : 'false',
          travelinsurance_amount: getTravelInsuranceAmount(),
        },
      };
      if (
        bookingRequest.bookingrequest.gstdetails.gstcompany === '' ||
        bookingRequest.bookingrequest.gstdetails.gstnumber === '' ||
        bookingRequest.bookingrequest.gstdetails.gstaddress === '' ||
        bookingRequest.bookingrequest.gstdetails.gstphone === '' ||
        bookingRequest.bookingrequest.gstdetails.gstemail === ''
      ) {
        bookingRequest.bookingrequest.gstdetails = {
          gstaddress: '',
          gstcompany: '',
          gstnumber: '',
          gstemail: '',
          gstphone: '',
        };
      }
      const userProfile = getObjectFromLS(APP_USER_PROFILE);
      const actioncode =
        rePriceResponse.domint === 'international' ? 'INTL' : 'DOM';
      const response = await HoldFlightApi(
        bookingRequest,
        userProfile?.agentId,
        actioncode,
      );
      if (response && response?.ApiStatus?.Status === 'OK') {
        const txid = response?.ApiStatus?.Result;
        const markUpTobeAdded =
          additionalMarkup === '' ? 0 : parseInt(additionalMarkup, 10);
        const markupResponse = await addMarkupInTicket(
          userProfile?.agentId,
          txid,
          markUpTobeAdded,
        );
        if (markupResponse && markupResponse?.Root?.Status === 'OK') {
          setAlert({
            variant: 'success',
            title: 'Flight Hold Success',
            description: ` your transaction Id is ${response?.ApiStatus?.Result}, navigating to ticket page`,
          });
          setTimeout(() => {
            navigate(`/flight/ticket/${response.ApiStatus.Result}`);
          }, 2000);
        } else {
          setAlert({
            variant: 'success',
            title: 'Flight Hold Success',
            description: ` your transaction Id is ${response?.ApiStatus?.Result}, navigating to ticket page`,
          });
          setTimeout(() => {
            navigate(`/flight/ticket/${response.ApiStatus.Result}`);
          }, 2000);
        }
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Hold Failed',
          description: response?.ApiStatus?.Message,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleGstChange = (event) => {
    const { name, value } = event.target;
    if (name === 'gstnumber') {
      setGst((prevState) => ({
        ...prevState,
        [name]: value?.toUpperCase(),
      }));
    } else {
      setGst((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSAChange = (event, sa, sector) => {
    // updateTravellers(sa);
    // const { checked } = event.target;
    // selectedTravellerRef.current.ssrSelected = checked;
    // selectedTravellerRef.current.selectedSsrCode = sa.ssrcode;
    const wcssr = { ...wheelChairSsr };
    if (wcssr[sector] === undefined) {
      wcssr[sector] = {};
    }
    wcssr[sector][selectedSpecialAssistanceIndexRef.current] = {
      sector,
      ssrcode: sa.ssrcode,
      ssrname: sa.ssrname,
      ssr_chargeableamount: sa.chargeableamount,
      selected: true,
      first_name: selectedTravellerRef.current.first_name,
      last_name: selectedTravellerRef.current.last_name,
      title: selectedTravellerRef.current.title,
    };
    setWheelChairSsr(wcssr);
    handleUpdateTotalNet(userSelectedSsrRows);
  };

  const handleAddWheelChariSsr = () => {
    if (
      !wheelChairSsr?.[specialAssistanceSelectionSector]?.[
        selectedSpecialAssistanceIndexRef?.current
      ] ||
      !wheelChairSsr?.[specialAssistanceSelectionSector]?.[
        selectedSpecialAssistanceIndexRef?.current
      ]?.selected
    ) {
      setAlert({
        variant: 'error',
        title: 'Flight Booking',
        description: 'Please select any Special Assistance',
      });
      return;
    }
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const wcssr = { ...wheelChairSsr };
    Object.keys(wcssr).forEach((sector) => {
      userSelectedSsrRowsTemp[sector].specialAssistanceRows.forEach(
        (row, index) => {
          if (
            wheelChairSsr &&
            wheelChairSsr[sector] &&
            wheelChairSsr[sector][index]
          ) {
            userSelectedSsrRowsTemp[sector].specialAssistanceRows[
              index
            ].ssrcode = wheelChairSsr[sector][index].ssrcode;
            userSelectedSsrRowsTemp[sector].specialAssistanceRows[
              index
            ].ssrname = wheelChairSsr[sector][index].ssrname;
            userSelectedSsrRowsTemp[sector].specialAssistanceRows[
              index
            ].ssr_chargeableamount = 0;
          }
        },
      );
    });
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
    // const list = [...travellers];
    // list[selectedTravellerRef.current.paxIndex].specialAssitance = true;
    // selectedTravellerRef.current =
    //   list[selectedTravellerRef.current.paxIndex];
    // setTravellers(list);
    setShowSpecialAssistance(false);
    // setAlert({
    //   variant: 'success',
    //   title: 'Flight Booking',
    //   description: 'Special Assistance added Successfully',
    // });
  };

  const handleClearSsr = () => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const wcssr = { ...wheelChairSsr };
    const activeSectorWcssr =
      wcssr[specialAssistanceSelectionSector][
        selectedSpecialAssistanceIndexRef.current
      ];
    if (activeSectorWcssr !== undefined) {
      userSelectedSsrRowsTemp[
        specialAssistanceSelectionSector
      ].specialAssistanceRows[
        selectedSpecialAssistanceIndexRef.current
      ].ssrcode = '';
      userSelectedSsrRowsTemp[
        specialAssistanceSelectionSector
      ].specialAssistanceRows[
        selectedSpecialAssistanceIndexRef.current
      ].ssrname = '';
      userSelectedSsrRowsTemp[
        specialAssistanceSelectionSector
      ].specialAssistanceRows[
        selectedSpecialAssistanceIndexRef.current
      ].ssr_chargeableamount = '';

      wcssr[specialAssistanceSelectionSector][
        selectedSpecialAssistanceIndexRef.current
      ] = {
        specialAssistanceSelectionSector,
        ssrcode: '',
        ssrname: '',
        ssr_chargeableamount: '',
        selected: false,
        first_name: selectedTravellerRef.current.first_name,
        last_name: selectedTravellerRef.current.last_name,
        title: selectedTravellerRef.current.title,
      };

      setWheelChairSsr(wcssr);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      // const list = [...travellers];
      // list[selectedTravellerRef.current.paxIndex].specialAssitance = false;
      // selectedTravellerRef.current =
      //   list[selectedTravellerRef.current.paxIndex];
      // selectedTravellerRef.current.ssrSelected = false;
      // selectedTravellerRef.current.selectedSsrCode = "";
      // wheelChairSsr.current = undefined;
      // setTravellers(list);
    }
    setShowSpecialAssistance(false);
  };

  const handleTermsConditions = () => {
    setShowBagTermsDialog(true);
  };

  const handleConfirmBooking = async (type) => {
    if (rePriceResponse.seatmapavailable) {
      if (
        hasDoneSeatCallRef.current === false &&
        (isSeatMandatoryForOnward || isSeatMandatoryForReturn)
      ) {
        setAlert({
          variant: 'error',
          title: 'Seat Selection',
          description: 'Seat is mandatory for this booking',
        });
        return false;
      }
    }
    if (Object.keys(flightLegsWithSeatsRef.current).length > 0) {
      let isSeatSelectedForOnward = true;
      let isSeatSelectedForReturn = true;
      Object.keys(flightLegsWithSeatsRef.current).forEach((sector) => {
        if (userSelectedSsrRows[sector].seatRows.length > 0) {
          userSelectedSsrRows[sector].seatRows.forEach((seatRow) => {
            if (
              seatRow.paxtype.toLowerCase() !== 'infant' &&
              seatRow.ssrcode === ''
            ) {
              if (seatRow.jtype === 'onward' && isSeatMandatoryForOnward) {
                isSeatSelectedForOnward = false;
              }
              if (seatRow.jtype === 'return' && isSeatMandatoryForReturn) {
                isSeatSelectedForReturn = false;
              }
            }
          });
        }
      });
      if (isSeatSelectedForOnward === false) {
        setAlert({
          variant: 'error',
          title: 'Seat Selection',
          description: 'Seat selection is mandatory',
        });
        return false;
      }
      if (isSeatSelectedForReturn === false) {
        setAlert({
          variant: 'error',
          title: 'Seat Selection',
          description: 'Seat selection is mandatory for return journey',
        });
        return false;
      }
    }
    if (rePriceResponse.ssravailable) {
      if (
        hasDoneSsrCallRef.current === false &&
        (isBaggageMandatoryForOnward || isBaggageMandatoryForReturn)
      ) {
        setAlert({
          variant: 'error',
          title: 'Meal Selection',
          description: 'Please check baggage to select',
        });
        return false;
      }
      if (
        hasDoneSsrCallRef.current === false &&
        (isMealMandatoryForOnward || isMealMandatoryForReturn)
      ) {
        setAlert({
          variant: 'error',
          title: 'Meal Selection',
          description: 'Please check meals to select',
        });
        return false;
      }
    }
    if (Object.keys(flightLegsWithMealRef.current).length > 0) {
      let isMealSelectedForOnward = true;
      let isMealSelectedForReturn = true;
      let isBaggageSelectedForOnward = true;
      let isBaggageSelectedForReturn = true;
      Object.keys(flightLegsWithMealRef.current).forEach((sector) => {
        if (!userSelectedSsrRows[sector]) return;
        if (userSelectedSsrRows[sector].mealRows.length > 0) {
          userSelectedSsrRows[sector].mealRows.forEach((mealRow) => {
            if (
              mealRow.paxtype.toLowerCase() !== 'infant' &&
              mealRow.ssrcode === ''
            ) {
              if (mealRow.jtype === 'onward' && isMealMandatoryForOnward) {
                isMealSelectedForOnward = false;
              }
              if (mealRow.jtype === 'return' && isMealMandatoryForReturn) {
                isMealSelectedForReturn = false;
              }
            }
          });
        }
        if (userSelectedSsrRows[sector].baggageRows.length > 0) {
          userSelectedSsrRows[sector].baggageRows.forEach((baggageRow) => {
            if (
              baggageRow.paxtype.toLowerCase() !== 'infant' &&
              baggageRow.ssrcode === ''
            ) {
              if (
                baggageRow.jtype === 'onward' &&
                isBaggageMandatoryForOnward
              ) {
                isBaggageSelectedForOnward = false;
              }
              if (
                baggageRow.jtype === 'return' &&
                isBaggageMandatoryForReturn
              ) {
                isBaggageSelectedForReturn = false;
              }
            }
          });
        }
      });
      if (!isMealSelectedForOnward) {
        setAlert({
          variant: 'error',
          title: 'Meal Selection',
          description: `Meal selection is mandatory`,
        });
        return false;
      }
      if (!isMealSelectedForReturn) {
        setAlert({
          variant: 'error',
          title: 'Meal Selection',
          description: 'Meal selection is mandatory for return sectors',
        });
        return false;
      }
      if (!isBaggageSelectedForOnward) {
        setAlert({
          variant: 'error',
          title: 'Meal Selection',
          description: 'please select meal for onward sectors',
        });
        return false;
      }
      if (!isBaggageSelectedForReturn) {
        setAlert({
          variant: 'error',
          title: 'Meal Selection',
          description: 'please select meal for return sectors',
        });
        return false;
      }
    }
    if (paymentmode === '') {
      setAlert({
        variant: 'error',
        title: 'Payment Mode',
        description: 'Please select method of payment',
      });
      return false;
    }
    if (paymentmode !== 'cashcard' && selectedPg === 'payu') {
      if (!isPayuPgAccepted) {
        setAlert({
          variant: 'error',
          title: 'Accept Terms',
          description: 'Please Accept terms and conditions of payu',
        });
        return false;
      }
    }
    setIsLoading(true);
    setIsBookingClicked(true);
    const travellersList = [...travellers];
    let isError = false;
    for (let i = 0; i < travellersList.length; i++) {
      if (
        travellersList[i].first_name === undefined ||
        travellersList[i].first_name === '' ||
        travellersList[i].first_name.trim() === '' ||
        travellersList[i].first_name.trim().length < 2 ||
        NAME_REGEX.test(travellersList[i].first_name) === false ||
        travellersList[i].last_name === undefined ||
        travellersList[i].last_name === '' ||
        // travellersList[i].gender === '' ||
        travellersList[i].last_name.trim() === '' ||
        travellersList[i].last_name.trim().length < 1 ||
        NAME_REGEX.test(travellersList[i].last_name) === false
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        (islcc === 'true' || bookingPageValidations?.ispaxtitlemandatory) &&
        travellersList[i].title === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        isDobMandatoryForPax(travellersList[i].type) &&
        isEmpty(travellersList[i].dob)
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        (searchRequest.searchtype === 'student' ||
          searchRequest.searchtype === 'seniorcitizen' ||
          searchRequest.searchtype === 'defenceonly') &&
        travellersList[i].type === 'Adult'
      ) {
        if (
          isEmpty(travellersList[i].idproof.split('@')[0]) ||
          isEmpty(travellersList[i].idproof.split('@')[1])
        ) {
          isError = true;
          setIsLoading(false);
        }
      }
      if (
        bookingPageValidations?.passportmandatory &&
        travellersList[i].passport === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        bookingPageValidations?.issuedatemandatory &&
        isEmpty(travellersList[i].passport_dateofissue)
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        bookingPageValidations?.exprirydatemandatory &&
        isEmpty(travellersList[i].passport_dateofexpiry)
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        bookingPageValidations?.issueplacemandatory &&
        travellersList[i].passport_placeofissue === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
    }
    if (
      leademail === undefined ||
      leademail === '' ||
      EMAIL_REGEX.test(leademail) === false ||
      leadmobile === undefined ||
      leadmobile === '' ||
      checkValidMobileNumber()
    ) {
      isError = true;
      setIsLoading(false);
    }
    travellersList.forEach((trav) => {
      delete trav.gender;
    });
    if (isGstMandatory) {
      if (
        isEmpty(gst.gstcompany) ||
        isEmpty(gst.gstemail) ||
        isEmpty(gst.gstnumber) ||
        isEmpty(gst.gstaddress) ||
        isEmpty(gst.gstphone)
      ) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
        setAlert({
          variant: 'error',
          title: 'Flight Booking',
          description:
            'Customer GST details are mandatory, If booked without GST same will be rejected',
        });
      }
    }
    if (
      gst.gstcompany !== '' ||
      gst.gstemail !== '' ||
      gst.gstnumber !== '' ||
      gst.gstaddress !== '' ||
      gst.gstphone !== ''
    ) {
      if (/^[a-zA-Z0-9]*$/gi.test(gst.gstnumber) === false) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
      if (
        gst.gstcompany === '' ||
        gst.gstemail === '' ||
        gst.gstnumber === '' ||
        gst.gstaddress === '' ||
        gst.gstphone === ''
      ) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
      if (gst.gstphone !== '' && checkMobileNumber(gst.gstphone)) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
      if (gst.gstemail !== '' && checkEmailAddress(gst.gstemail)) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
    }
    if (
      paymentmode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu') &&
      selectedBankForNetBanking === ''
    ) {
      isError = true;
      setIsLoading(false);
    }
    if (isError) {
      setValidationError(true);
      setActiveTab(PAX);
      scrollToTop();
      return false;
    }
    if (type === 'hold' && paymentmode !== 'cashcard') {
      setIsLoading(false);
      setAlert({
        variant: 'error',
        title: 'Flight Hold',
        description: 'Hold cannot be done with payment gateway',
      });
      setValidationError(true);
      setActiveTab(PAX);
      scrollToTop();
      return false;
    }
    let hasDifferentMarkup = false;
    travellersList.forEach((traveller, index) => {
      if (traveller.type !== 'Infant') {
        let markValue = tempMarkupList[index].tax_amount;
        if (markValue === '') {
          markValue = 0;
        }
        if (markValue !== '') {
          markValue = Number(markValue);
        }
        if (traveller.additional_taxhc !== markValue) {
          hasDifferentMarkup = true;
        }
      }
    });
    // if (hasDifferentMarkup) {
    //   setIsLoading(false);
    //   setAlert({
    //     title: 'Additional Markup',
    //     description: 'Unsaved markup please apply',
    //     variant: 'error',
    //   });
    //   // scrollToTop();
    //   return false;
    // }
    const response = await getAgentBalanceApi();
    if (response?.ApiStatus?.Status === 'OK') {
      const { Result = {} } = response.ApiStatus;
      const { UserAccount = {} } = Result;
      walletBalanceRef.current =
        UserAccount.Balance + UserAccount.CreditLimit - UserAccount.Due;
    }

    let bankId = '';
    if (
      paymentmode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu')
    ) {
      bankId = selectedBankForNetBanking;
    }
    const totalAmountToShow = getTotalAmountToShow();
    fareSummaryRef.current.totalAmountToShow = totalAmountToShow;
    const pgcheckoutamount = await getPGCheckOutAmountApi(
      paymentmode,
      selectedPg,
      rePriceResponse.domint,
      totalAmountToShow,
      'flight',
      getUserAgentId(),
      bankId,
    );
    if (pgcheckoutamount?.ApiStatus?.Status === 'OK') {
      const { Result = {} } = pgcheckoutamount.ApiStatus;
      setcheckoutPgCharge(Result.PgCharges || 0);
      setgstcheckoutPgCharge(Result.GSTOnPgCharges || 0);
      setcheckoutInvTotal(Result.TotalInvoice || 0);
    }
    if (type === 'book') {
      setShowConfirmationDialog(true);
    }
    if (type === 'hold') {
      setShowConfirmHoldDialog(true);
    }
    setIsLoading(false);
  };

  const getExcessBaggage = (sector, travellerIndex) => {
    let filteredBaggageRows = [];
    filteredBaggageRows =
      userSelectedSsrRows[sector]?.baggageRows?.filter(
        (mr) => mr.travellerIndex === travellerIndex,
      ) || [];
    const bags = [];
    const selectedBags = filteredBaggageRows.filter((x) => x.ssrcode !== '');
    if (selectedBags.length === 0) {
      const isOnward = onwardFlightSectorsRef.current.indexOf(sector) > -1;
      const isReturn = returnFlightSectorsRef.current.indexOf(sector) > -1;
      if (isOnward) {
        filteredBaggageRows =
          userSelectedSsrRows[
            `${onwardOriginRef.current} - ${onwardDestinationRef.current}`
          ]?.baggageRows?.filter(
            (mr) => mr.travellerIndex === travellerIndex,
          ) || [];
      }
      if (isReturn) {
        filteredBaggageRows =
          userSelectedSsrRows[
            `${returnOriginRef.current} - ${returnDestinationRef.current}`
          ]?.baggageRows?.filter(
            (mr) => mr.travellerIndex === travellerIndex,
          ) || [];
      }
    }
    filteredBaggageRows.forEach((row) => {
      if (row.ssrcode !== '') {
        bags.push(row.ssrname);
      }
    });
    return bags.join(',');
  };

  // const getMeal = (sector, travellerIndex) => {
  //   if (userSelectedSsrRows[sector].mealRows[travellerIndex].ssrcode !== '') {
  //     return userSelectedSsrRows[sector].mealRows[travellerIndex].ssrname;
  //   }
  //   return '';
  // };

  const getMeal = (sector, travellerIndex) => {
    try {
      if (userSelectedSsrRows[sector].mealRows[travellerIndex].ssrcode !== '') {
        return userSelectedSsrRows[sector].mealRows[travellerIndex].ssrname;
      }
      if (onwardFlightSectorsRef.current.indexOf(sector) > -1) {
        if (
          !isNullOrEmpty(
            getViaMeal(
              onwardFlightSectorsRef.current,
              0,
              sector,
              travellerIndex,
              'onward',
            ),
          )
        ) {
          return getViaMeal(
            onwardFlightSectorsRef.current,
            0,
            sector,
            travellerIndex,
            'onward',
          );
        }
        if (
          !isNullOrEmpty(
            getViaMeal(
              onwardFlightSectorsRef.current,
              1,
              sector,
              travellerIndex,
              'onward',
            ),
          )
        ) {
          return getViaMeal(
            onwardFlightSectorsRef.current,
            1,
            sector,
            travellerIndex,
            'onward',
          );
        }
        return '';
      }
      if (returnFlightSectorsRef.current.indexOf(sector) > -1) {
        if (
          !isNullOrEmpty(
            getViaMeal(
              returnFlightSectorsRef.current,
              0,
              sector,
              travellerIndex,
              'return',
            ),
          )
        ) {
          return getViaMeal(
            returnFlightSectorsRef.current,
            0,
            sector,
            travellerIndex,
            'return',
          );
        }
        if (
          !isNullOrEmpty(
            getViaMeal(
              returnFlightSectorsRef.current,
              1,
              sector,
              travellerIndex,
              'return',
            ),
          )
        ) {
          return getViaMeal(
            returnFlightSectorsRef.current,
            1,
            sector,
            travellerIndex,
            'return',
          );
        }
        return '';
      }
      return '';
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      return '';
    }
  };
  const getViaMeal = (sectors, index, sector, travellerIndex, jtype) => {
    try {
      const secOrigin = sector.split(' - ')[index];
      const eligibleSectors = Object.keys(userSelectedSsrRows).filter(
        (x) =>
          x.split(' - ')[index] === secOrigin &&
          sectors.indexOf(sector) > -1 &&
          userSelectedSsrRows[x].mealRows[travellerIndex].ssrcode !== '',
      );
      if (
        eligibleSectors.length > 0 &&
        userSelectedSsrRows[eligibleSectors[0]].mealRows[travellerIndex]
          .ssrcode !== '' &&
        userSelectedSsrRows[eligibleSectors[0]].mealRows[travellerIndex]
          .jtype === jtype
      ) {
        return userSelectedSsrRows[eligibleSectors[0]].mealRows[travellerIndex]
          .ssrname;
      }
      return '';
    } catch (error) {
      console.log(error);
      return '';
    }
  };

  const getSeatNo = (sector, travellerIndex) => {
    if (userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode !== '') {
      return userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode;
    }
    return '';
  };

  const getOtherSsr = (sector, travellerIndex) => {
    let filteredSpecialSsrRows = [];
    filteredSpecialSsrRows = userSelectedSsrRows[sector].specialSsrRows.filter(
      (mr) => mr.travellerIndex === travellerIndex,
    );
    const specialSSr = [];
    const selectedSplCodes = filteredSpecialSsrRows.filter(
      (x) => x.ssrcode !== '',
    );
    if (selectedSplCodes.length === 0) {
      const isOnward = onwardFlightSectorsRef.current.indexOf(sector) > -1;
      const isReturn = returnFlightSectorsRef.current.indexOf(sector) > -1;
      if (isOnward) {
        filteredSpecialSsrRows = userSelectedSsrRows[
          `${onwardOriginRef.current} - ${onwardDestinationRef.current}`
        ].specialSsrRows.filter((mr) => mr.travellerIndex === travellerIndex);
      }
      if (isReturn) {
        filteredSpecialSsrRows = userSelectedSsrRows[
          `${returnOriginRef.current} - ${returnDestinationRef.current}`
        ].specialSsrRows.filter((mr) => mr.travellerIndex === travellerIndex);
      }
    }
    filteredSpecialSsrRows.forEach((row) => {
      if (row.ssrcode !== '') {
        specialSSr.push(row.ssrname);
      }
    });

    return specialSSr.join(',');
  };

  const handleEditTravellersPostConfirm = () => {
    setShowConfirmHoldDialog(false);
    setShowConfirmationDialog(false);
    handleFlightDetailsContinue();
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };

  const getUserSsr = (traveller, travellerIndex) => {
    const sectors = Object.keys(userSelectedSsrRows);
    let ssrStr = '';
    sectors.forEach((sector) => {
      const filteredMealRows = userSelectedSsrRows[sector].mealRows.filter(
        (mr) => mr.travellerIndex === travellerIndex,
      );
      filteredMealRows.forEach((row) => {
        if (row.ssrcode !== '') {
          ssrStr += `${formattedMessage('meal')}: ${row.ssrname}, `;
        }
      });
      const filteredBaggageRows =
        userSelectedSsrRows[sector]?.baggageRows?.filter(
          (mr) => mr.travellerIndex === travellerIndex,
        ) || [];
      filteredBaggageRows.forEach((row) => {
        if (row.ssrcode !== '') {
          ssrStr += `${formattedMessage('baggage')}: ${row.ssrname}, `;
        }
      });
      if (
        userSelectedSsrRows[sector]?.seatRows?.[travellerIndex]?.ssrcode &&
        userSelectedSsrRows[sector]?.seatRows?.[travellerIndex]?.ssrcode !== ''
      ) {
        ssrStr += `${formattedMessage('seat')}: ${
          userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode
        }, `;
      }
      if (
        userSelectedSsrRows[sector]?.specialSsrRows?.[travellerIndex]
          ?.ssrcode &&
        userSelectedSsrRows[sector]?.specialSsrRows?.[travellerIndex]
          ?.ssrcode !== ''
      ) {
        ssrStr += `${formattedMessage('special_ssr')}: ${
          userSelectedSsrRows[sector].specialSsrRows[travellerIndex].ssrcode
        }, `;
      }
      if (
        userSelectedSsrRows[sector]?.specialAssistanceRows?.[travellerIndex]
          ?.ssrcode &&
        userSelectedSsrRows[sector]?.specialAssistanceRows?.[travellerIndex]
          .ssrcode !== ''
      ) {
        ssrStr += `${formattedMessage('wheelchair')}: ${
          userSelectedSsrRows[sector].specialAssistanceRows[travellerIndex]
            .ssrname
        }, `;
      }
    });

    return ssrStr.substring(0, ssrStr.length - 1);
  };
  const checkValidName = (name) => {
    return (
      name?.toString()?.trim() !== '' && /^[a-zA-Z ]*$/.test(name) === false
    );
  };
  const checkValiGstNumber = (name) => {
    return (
      name?.toString()?.trim() !== '' && /^[a-zA-Z0-9]*$/.test(name) === false
    );
  };
  const checkValidPassport = (passport) => {
    return (
      passport?.toString()?.trim() !== '' &&
      PASSPORT_REGEX.test(passport) === false
    );
  };

  const checkValidMobileNumber = () => {
    const code = getIsoCodeFromDialCode(countryCode) || 'IN';
    const isIndia = code === 'IN';
    if (isIndia) {
      return (
        leadmobile?.toString()?.trim() !== '' &&
        /^[5-9]\d{9}$/gi.test(leadmobile) === false
      );
    }
    return (
      leadmobile?.toString()?.trim() !== '' &&
      !isValidMobileNumber(leadmobile, code)
    );
  };

  const checkValidEmailAddress = () => {
    return leademail?.trim() !== '' && EMAIL_REGEX.test(leademail) === false;
  };

  const checkMobileNumber = (phNumber) => {
    return (
      phNumber?.toString()?.trim() !== '' &&
      /^[5-9]\d{9}$/gi.test(phNumber) === false
    );
  };

  const checkEmailAddress = (email) => {
    return email !== '' && EMAIL_REGEX.test(email) === false;
  };

  const getSelectedMeals = (userMealRows, index) => {
    const filterdMeals = userMealRows.filter(
      (row) => row.travellerIndex === index && row.ssrname !== '',
    );

    return filterdMeals.length === 0 ? (
      formattedMessage('select_meal')
    ) : (
      <ul className="selected-meals">
        {filterdMeals.map((meal, fmi) => (
          <li key={fmi}>
            <span className="ssrMealDesc">
              {meal.ssrname} • {formatCurrency(meal.ssr_chargeableamount)}
            </span>
            <AppIconButton
              onClick={() =>
                handleRemoveMeal(
                  meal,
                  index,
                  `${meal.origin} - ${meal.destination}`,
                )
              }
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </li>
        ))}
      </ul>
    );
  };

  const getSelectedSpecailSsr = (userSsrRows, index) => {
    const filteredSsrs = userSsrRows.filter(
      (row) => row.travellerIndex === index && row.ssrname !== '',
    );

    return filteredSsrs.length === 0 ? (
      formattedMessage('select_special_ssr')
    ) : (
      <ul className="selected-meals">
        {filteredSsrs.map((specail, fmi) => (
          <li key={fmi}>
            <span className="specialSsrDesc">
              {specail.ssrname} • {formatCurrency(specail.ssr_chargeableamount)}
            </span>
            <AppIconButton
              onClick={() =>
                handleRemoveSpecialSsr(
                  specail,
                  index,
                  `${specail.origin} - ${specail.destination}`,
                )
              }
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </li>
        ))}
      </ul>
    );
  };

  const handleOpenFareRules = async (key, type) => {
    if (type === 'onward') {
      if (
        ['6E', '6ET', '6E7'].indexOf(
          selectedFlight.onward.flightlegs[0].carrier,
        ) > -1 &&
        domInt === 'international'
      ) {
        const link = INDIGO_FARERULES_LINK;
        const element = document.createElement('a');
        element.href = link;
        element.target = '_blank';
        element.click();
        return;
      }
    }
    if (type === 'return') {
      if (
        ['6E', '6ET', '6E7'].indexOf(
          selectedFlight.return.flightlegs[0].carrier,
        ) > -1 &&
        domInt === 'international'
      ) {
        const link = INDIGO_FARERULES_LINK;
        const element = document.createElement('a');
        element.href = link;
        element.target = '_blank';
        element.click();
        return;
      }
    }
    setIsLoading(true);
    const response = await getFareRulesApi(key, '', domInt);
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      setFareRulesHtml(JSON.parse(response.farerules_html).html);
      setIsOpenFareRulesDialog(true);
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result.AllFareRules.Rule);
      } else {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      }
      setIsOpenFareRulesDialog(true);
    }
    setIsLoading(false);
  };

  const getSelectedSeat = (ssrRow, index, sector) => {
    return (
      <div className="d-flex flex-column">
        <span className="passengersNames">
          {ssrRow.passenger_fname !== ''
            ? `${ssrRow.passenger_title} ${ssrRow.passenger_fname} ${ssrRow.passenger_lname}`
            : `${formattedMessage('traveller')} ${index + 1}`}
        </span>
        {ssrRow.ssrcode === '' ? (
          <small className="traveller-name__subheading">
            {formattedMessage('select_seat')}
          </small>
        ) : (
          <div className="d-flex gap-2 selected-seats align-items-center">
            <small className="traveller-name__subheading">
              {`${ssrRow.ssrcode} • ${formatCurrency(
                ssrRow.ssr_chargeableamount,
              )}`}
            </small>{' '}
            <AppIconButton
              onClick={() => handleRemoveSeat(ssrRow, sector)}
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </div>
        )}
      </div>
    );
  };

  const handleNomineeDetails = (event, index) => {
    const { name, value } = event.target;
    const list = [...travellers];
    list[index][name] = value;
    setTravellers(list);
  };

  const handleTravelInsuranceSelection = (isSelected) => {
    const isChanged = hasTravelInsurance !== isSelected;
    const insuranceAmount = getTravelInsuranceAmount(true);
    if (isChanged) {
      let totFare = fareSummaryRef.current.totalFare;
      if (isSelected) {
        totFare = totFare + insuranceAmount;
      } else {
        totFare = totFare - insuranceAmount;
        const list = [...travellers];
        list.forEach((pax) => (pax.beneficiaryname = ''));
        setTravellers(list);
      }
      fareSummaryRef.current.totalFare = totFare;
      fareSummaryRef.current.totalAmountToShow = getTotalAmountToShow(
        fareSummaryRef.current,
        isSelected,
      );
      setHasTravelInsurance(isSelected);
    }
  };

  const handleAddMarkupForPax = (event, index) => {
    const { name, value } = event.target;
    const numValue = value.replace(/[^0-9]/g, '');
    const list = [...tempMarkupList];
    list[index][name] = numValue;
    setTempMarkupList(list);
    setIsMarkupUpdated(false);
  };

  const handleMarkupAddition = () => {
    const prevMarkUp = fareSummaryRef.current.AdditionalMarkupToShow;
    const list = [...tempMarkupList];
    list.forEach((pax) => {
      if (pax.tax_amount === '') {
        pax.tax_amount = 0;
      } else {
        const numValue = Number(pax.tax_amount);
        pax.tax_amount = numValue;
      }
    });
    let markUpValue = 0;
    list.forEach((pax) => {
      markUpValue += pax.tax_amount;
    });
    let totFare = fareSummaryRef.current.totalFare - prevMarkUp;
    totFare += markUpValue;
    fareSummaryRef.current.AdditionalMarkupToShow = markUpValue;
    fareSummaryRef.current.totalFare = totFare;
    // const paxList = [...travellers];
    // paxList.forEach((pax, index) => {
    //   pax.additional_taxhc = list[index].tax_amount;
    // });
    setTempMarkupList(list);
    // setTravellers(paxList);
    setAdditionalMarkup(markUpValue);
    setShowMarkup(true);
    setAlert({
      title: 'Additional Markup',
      description: 'Successfully Added Markup',
      variant: 'success',
    });
    setIsMarkupUpdated(true);
  };
  const handleRefClick = (ref) => {
    // const headerHeight = 100;
    // const targetTop =
    //   ref.current.getBoundingClientRect().top +
    //   window.pageYOffset -
    //   headerHeight;
    // window.scrollTo({ top: targetTop, behavior: 'smooth' });
    scrollToTop();
  };

  const handleOnFlightDetailsClick = () => {
    // setIsFlightDetailsCompleted(true);
    handleRefClick(targetRefs.flightDetails);
    setActiveTab(FLIGHT_DETAILS);
  };

  const handleFlightDetailsContinue = () => {
    setIsFlightDetailsCompleted(true);
    setActiveTab(travelInsuranceEnabled ? INSURANCE : PAX);
  };

  const handleIdDetails = (event, index) => {
    let { name, value } = event.target;
    const prevValue = travellers[index].idproof;
    const list = [...travellers];
    let val;
    if (name === 'student_id' || name === 'senior_citizen_id') {
      value = value.replace(/[^a-zA-Z0-9]/g, '');
      val = `${value}${
        prevValue.split('@')[1] ? `@${prevValue.split('@')[1]}` : ''
      }`;
    }
    if (name === 'id_expiry_date' || name === 'dobForSeniorCitizen') {
      val = `${
        !isEmpty(prevValue.split('@')[0]) ? prevValue.split('@')[0] : ''
      }@${value}`;
    }
    list[index].idproof = val;
    setTravellers(list);
  };
  const handlePaxContinue = () => {
    setIsBookingClicked(true);
    const travellersList = [...travellers];
    let isError = false;
    for (let i = 0; i < travellersList.length; i++) {
      if (
        travellersList[i].first_name === undefined ||
        travellersList[i].first_name === '' ||
        travellersList[i].first_name.trim() === '' ||
        travellersList[i].first_name.trim().length < 2 ||
        NAME_REGEX.test(travellersList[i].first_name) === false ||
        travellersList[i].last_name === undefined ||
        travellersList[i].last_name === '' ||
        // travellersList[i].gender === '' ||
        travellersList[i].last_name.trim() === '' ||
        travellersList[i].last_name.trim().length < 1 ||
        NAME_REGEX.test(travellersList[i].last_name) === false
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (islcc === 'true' && travellersList[i].title === '') {
        isError = true;
        setIsLoading(false);
      }
      if (
        isDobMandatoryForPax(travellersList[i].type) &&
        travellersList[i].dob === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        (searchRequest.searchtype === 'student' ||
          searchRequest.searchtype === 'seniorcitizen') &&
        travellersList[i].type === 'Adult'
      ) {
        if (
          isEmpty(travellersList[i].idproof.split('@')[0]) ||
          isEmpty(travellersList[i].idproof.split('@')[0])
        ) {
          isError = true;
          setIsLoading(false);
        }
      }
      if (
        rePriceResponse.domint?.toLowerCase() !== 'domestic' &&
        PASSPORT_REGEX.test(travellersList[i].passport) === false
      ) {
        isError = true;
        setIsLoading(false);
      }
    }
    if (!handlepassportduplicates(travellersList)) {
      setAlert({
        variant: 'error',
        title: formattedMessage('validation_error'),
        description: 'Duplicate passport number',
      });
      return;
    }

    if (
      !handleduplicateffn(travellersList) &&
      getValueFromAppConfig('CHECK_DUPLICATE_FFN') === 'true'
    ) {
      setAlert({
        variant: 'error',
        title: formattedMessage('validation_error'),
        description: 'Duplicate FFN',
      });
      setIsLoading(false);
      return;
    }

    if (
      leademail === undefined ||
      leademail === '' ||
      EMAIL_REGEX.test(leademail) === false ||
      leadmobile === undefined ||
      leadmobile === '' ||
      checkValidMobileNumber()
    ) {
      isError = true;
      setIsLoading(false);
    }

    if (
      gst.gstcompany !== '' ||
      gst.gstemail !== '' ||
      gst.gstnumber !== '' ||
      gst.gstaddress !== '' ||
      gst.gstphone !== ''
    ) {
      if (/^[a-zA-Z0-9]*$/gi.test(gst.gstnumber) === false) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
      if (
        gst.gstcompany === '' ||
        gst.gstemail === '' ||
        gst.gstnumber === '' ||
        gst.gstaddress === '' ||
        gst.gstphone === ''
      ) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
      if (gst.gstphone !== '' && checkMobileNumber(gst.gstphone)) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
      if (gst.gstemail !== '' && checkEmailAddress(gst.gstemail)) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
    }
    if (isError) {
      setValidationError(true);
      scrollToTop();
      return false;
    }
    setIsPaxCompleted(true);
    setActiveTab(SSR);
    scrollToBottom();
    handleRefClick(targetRefs.ssr);
  };
  const handleSsrContinue = () => {
    setIsSSRCompleted(true);
    setActiveTab(PG);
    handleRefClick(targetRefs.pg);
  };

  const handleSavePaxDetails = async (index) => {
    setIsLoading(true);
    const selectedPax = travellers[index];
    if (
      selectedPax.first_name === '' ||
      selectedPax.last_name === '' ||
      selectedPax.title === '' ||
      NAME_REGEX.test(selectedPax.first_name) === false ||
      NAME_REGEX.test(selectedPax.last_name) === false
    ) {
      setAlert({
        variant: 'error',
        title: 'Save Pax Details',
        description: 'Enter valid pax details',
      });
      setIsLoading(false);
      return false;
    }
    if (
      leademail === undefined ||
      leademail === '' ||
      EMAIL_REGEX.test(leademail) === false ||
      leadmobile === undefined ||
      leadmobile === '' ||
      /^\+?(\d{1,4}|\(\d{1,4}\))?[-.\s]?(\d{1,4}[-.\s]?){2,3}\d{1,4}$/gi.test(
        leadmobile,
      ) === false
    ) {
      setAlert({
        variant: 'error',
        title: 'Save Pax Details',
        description: 'Enter valid contact details',
      });
      setIsLoading(false);
      return false;
    }
    const request = {
      travellerid: '',
      nickname: '',
      firstname: selectedPax.first_name,
      lastname: selectedPax.last_name,
      email: leademail,
      mobile: leadmobile,
      profileid: '',
      agentid: getUserAgentId(),
      addedon: '',
      dob: selectedPax.dob,
      passportnumber: selectedPax.passport,
      passportexpiry: selectedPax.passport_dateofexpiry,
      passportissuedate: selectedPax.passport_dateofexpiry,
      passportissueplace: selectedPax.passport_placeofissue,
      nationality: '',
      otherdata: '',
      title: selectedPax.title,
      paxtype: selectedPax.type,
      isprofile: 'false',
    };
    const response = await addPersonalTravellerApi(request);
    if (response && response.Root && response.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Save Pax Details',
        description: 'Pax details saved successfully',
      });
      const paxIndices = [...savedPaxIndex];
      paxIndices.push(index);
      setSavedPaxIndex(paxIndices);
    } else if (response.status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Save Pax Details',
        description: response
          ? response?.message
          : 'Pax details added successfully',
      });
      const paxIndices = [...savedPaxIndex];
      paxIndices.push(index);
      setSavedPaxIndex(paxIndices);
    } else {
      setAlert({
        variant: 'error',
        title: 'Save Pax Details',
        description: response
          ? response?.message
          : 'Pax details added successfully',
      });
    }
    setIsLoading(false);
  };
  const handleInsuranceContinue = () => {
    if (hasTravelInsurance) {
      let hasError = false;
      travellers.forEach((pax) => {
        if (
          pax.type !== 'Infant' &&
          (!pax.beneficiaryname || pax.beneficiaryname.trim() === '')
        ) {
          hasError = true;
        }
      });
      if (hasError) {
        setAlert({
          variant: 'error',
          title: 'Nominee Details Required',
          description: 'Please enter nominee names for all passengers.',
        });
        return;
      }
    }
    setIsInsuranceCompleted(true);
    setActiveTab(PAX);
    handleRefClick(targetRefs.pax);
  };
  const handleSearchCustomer = async () => {
    setIsLoading(true);
    if (profileName !== '') {
      const response = await chooseCustomerApi(profileName, getUserAgentId());
      if (
        response.Root.Status === 'OK' &&
        response.Root.Result.ProfileMasters !== ''
      ) {
        const { ProfileMasters } = response.Root.Result;
        const { ProfileMaster } = ProfileMasters;
        const list = Array.isArray(ProfileMaster)
          ? ProfileMaster
          : [ProfileMaster];
        const firstCustomer = list[0];
        setCustomers(list);
      } else {
        setCustomers([]);
        setAlert({
          title: 'Profile Search',
          description: 'No Profiles Found',
          variant: 'error',
        });
      }
    } else {
      setAlert({
        title: 'Profile Search',
        description: 'Please enter name',
        variant: 'error',
      });
    }

    setIsLoading(false);
  };
  const handleAddSelectPassenger = (index) => {
    selectedCustomerRef.current = index;
    setShowSelectPaxModal(true);
  };

  const handleSelectCustomer = (customersList) => {
    if (customersList.length > 0) {
      const list = [...travellers];
      customersList.forEach((customer, index) => {
        if (index === 0 && !isEmpty(customer.email)) {
          setLeademail(customer.email);
          setLeadmobile(customer.mobile);
        }
        if (list[index]) {
          list[index].first_name = customer.firstname;
          list[index].last_name = customer.lastname;
          list[index].title = customer.title;
          if (!isNullOrEmpty(customer.dob)) {
            if (
              isBeforeDate(
                getDOBMinDate(list[index].type),
                getNewDate(searchRequest.onwarddate),
              )
            ) {
              setAlert({
                variant: 'error',
                title: 'Select Passenger',
                description:
                  'Date of birth doesnt meet requirements, please update dob',
              });
              return false;
            }
            list[index].dob = customer.dob;
          }
          // if (rePriceResponse.domint === 'international') {
          list[index].passport = customer.passport;
          list[index].passport_placeofissue = customer.passportissuedate;
          list[index].passport_dateofexpiry = customer.passportexpiry;
        }
      });
      setTravellers(list);
    }
    // }
    setShowSelectPaxModal(false);
    setPersonalTravellers([]);
  };

  const getJourneys = (origin, destination, dates) => {
    const originArr = origin.split(':');
    const destinationArr = destination.split(':');
    const newDatesArray = [];
    const datesArray = dates.split(':');
    datesArray.forEach((date) => {
      let newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newdate = formatDate(getNewDate(newdate), ONLY_DATE_MONTH_FORMAT);
      newDatesArray.push(newdate);
    });
    const journeyStringArr = new Array(Number(originArr.length))
      .fill(0)
      .map(
        (d, index) =>
          `${originArr[index].split(',')[0]}-${
            destinationArr[index].split(',')[0]
          }(${newDatesArray[index]})`,
      );
    return journeyStringArr.join(', ');
  };

  const updatePaymentMode = (pmselected) => {
    setPaymentMode(pmselected);
    const pgForPmSelected = selectedPaymentGatewayRef.current.filter(
      (x) => x.PaymentMode.toLowerCase() === pmselected,
    );
    if (pgForPmSelected.length > 0) {
      setSelectedPg(pgForPmSelected[0].GatewayName);
    }
    setTempPgList(pgForPmSelected);
  };

  const isCarrierSg = () => {
    let isSg = false;
    if (
      selectedFlight?.onward?.flightlegs[0]?.carrier?.substring(0, 2) === 'SG'
    ) {
      isSg = true;
    }
    if (
      selectedFlight?.return?.flightlegs[0]?.carrier?.substring(0, 2) === 'SG'
    ) {
      isSg = true;
    }
    return isSg;
  };

  const getIndexForPax = (index, type) => {
    try {
      if (type.toLowerCase() === 'adult') {
        return index + 1;
      }
      const numAdults = parseInt(searchRequest.numadults, 10);
      const numChildren = parseInt(searchRequest.numchildren, 10);
      if (type.toLowerCase() === 'child') {
        return index - numAdults + 1;
      }
      if (type.toLowerCase() === 'infant') {
        return index - numAdults - numChildren + 1;
      }
    } catch (error) {
      return '';
    }
  };

  // eslint-disable-next-line no-shadow
  const handleAddGST = async (gst) => {
    setIsLoading(true);
    let isError = false;
    if (gst.gstphone !== '') {
      if (gst.gstphone !== '' && checkMobileNumber(gst.gstphone)) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
        return false;
      }
    }

    const response = await addAgentGSTDetails(gst, getUserAgentId());
    if (response && response.Root && response.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Save Agent GST Details',
        description: 'Agent GST details saved successfully',
      });
    } else {
      setAlert({
        variant: 'error',
        title: 'Save Agent GST Details',
        description: response
          ? response.Root.Message
          : 'Failed to save Agent GST details',
      });
    }
    setIsLoading(false);
  };
  const handleUpdateGstDetails = async () => {
    setIsLoading(true);
    const agentid = getUserAgentId();
    const { gstcompany, gstemail, gstnumber, gstphone, gstaddress } = gst;
    const req = {
      agentid,
      gstcompany,
      gstemail,
      gstnumber,
      gstcontactnumber: gstphone,
      gstaddress,
    };
    const res = await updateGstDetails(req);
    if (res && res.Root && res.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'GST Details',
        description: res?.Root?.Message || 'GST details updated successfully',
      });
    } else {
      setAlert({
        variant: 'error',
        title: 'GST Details',
        description: res?.Root?.Message || 'Failed to update GST details',
      });
    }
    setIsLoading(false);
  };
  const handleSelectGST = (gstDetails) => {
    if (!gstDetails || gstDetails === 'null') {
      setGst((prev) => ({
        ...prev,
        gstcompany: '',
        gstnumber: '',
        gstemail: '',
        gstphone: '',
        gstaddress: '',
      }));
    } else {
      setGst((prev) => ({
        ...prev,
        gstcompany: gstDetails.GSTCompany,
        gstnumber: gstDetails.GSTNumber,
        gstemail: gstDetails.GSTEmail,
        gstphone: gstDetails.GSTContactNumber,
        gstaddress: gstDetails.GSTAddress,
      }));
    }

    setShowSelectGstModal(false);
  };

  const handlePgSelection = (pgname) => {
    setSelectedPg(pgname);
    setIsPayuPgAccepted(false);
  };

  const handleDateInputChange = (name, e, index, minDate, maxDate) => {
    try {
      let input = e.target.value.replace(/\D/g, '');

      if (input.length >= 2 && input.length <= 4) {
        input = input.slice(0, 2) + '/' + input.slice(2);
      } else if (input.length >= 4) {
        input =
          input.slice(0, 2) + '/' + input.slice(2, 4) + '/' + input.slice(4, 8);
      }
      e.target.value = input;
      if (input.length === 10) {
        const [day, month, year] = input.split('/');
        const formattedDate = `${year}-${month}-${day}`;
        const parsedDate = parse(formattedDate, 'yyyy-MM-dd', new Date());

        if (isValidDate(parsedDate)) {
          if (minDate && isBeforeDate(parsedDate, minDate)) {
            e.target.value = '';
            setAlert({
              variant: 'error',
              description: 'Entered date is out of range',
            });
            return false;
          }
          if (
            maxDate &&
            isAfterDate(getNewDate(parsedDate), getNewDate(maxDate))
          ) {
            e.target.value = '';
            setAlert({
              variant: 'error',
              description: 'Entered date is out of range',
            });
            return false;
          }
          handleTextInputChange(
            {
              target: {
                name,
                value: parsedDate,
              },
            },
            index,
          );
        } else {
          e.target.value = '';
        }
      }
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      return false;
    }
  };

  const handleGetSavedpassenegers = async () => {
    // if (isEmpty(leadmobile)) {
    //   setAlert({
    //     variant: 'error',
    //     description: 'Please enter Mobile Number',
    //   });
    //   return false;
    // }
    setIsLoading(true);
    const response = await getAllPersonalTravellersForAgentIdApi(
      getUserAgentId(),
      leadmobile,
    );
    if (response && !isEmpty(response)) {
      const list = Array.isArray(response) ? response : [response];
      if (list.length > 0) {
        setPersonalTravellers(list);
        setShowSelectPaxModal(true);
      } else {
        setPersonalTravellers([]);
        setAlert({
          variant: 'error',
          description: 'No Passengers available',
        });
      }
    } else {
      setPersonalTravellers([]);
      setAlert({
        variant: 'error',
        description: 'No Passengers available',
      });
    }
    setIsLoading(false);
  };

  return (
    <section className="flight-booking-page pb-2">
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      {isLoading && <AppLoading isLoading={isLoading} />}
      <div className="flight-booking-page_header">
        <div className="flight-booking-page_header_container d-flex justify-content-end flex-sm-row flex-column">
          <div className="d-flex flex-sm-row flight-booking-page_stepper justify-content-between px-sm-0 px-2">
            <div
              onClick={handleOnFlightDetailsClick}
              className={`flight-booking-page_stepper_step ${
                isFlightDetailsCompleted ? 'completed-step' : ''
              }  ${activeTab === FLIGHT_DETAILS ? 'active-step' : ''} `}
            >
              {isFlightDetailsCompleted ? (
                activeTab === FLIGHT_DETAILS ? (
                  <MdCheckCircleOutline />
                ) : (
                  <MdCheckCircle />
                )
              ) : (
                <div className="flight-booking-page_stepper_step_count">1</div>
              )}
              <div className="flight-booking-page_stepper_step_name">
                Flight Details
              </div>
            </div>
            {travelInsuranceEnabled && (
              <div
                onClick={handleFlightDetailsContinue}
                className={`flight-booking-page_stepper_step ${
                  isInusranceCompleted ? 'completed-step' : ''
                }  ${activeTab === INSURANCE ? 'active-step' : ''} `}
              >
                {isInusranceCompleted ? (
                  activeTab === INSURANCE ? (
                    <MdCheckCircleOutline />
                  ) : (
                    <MdCheckCircle />
                  )
                ) : (
                  <div className="flight-booking-page_stepper_step_count">
                    2
                  </div>
                )}
                <div className="flight-booking-page_stepper_step_name">
                  Travel Insurance
                </div>
              </div>
            )}
            <div
              onClick={handleFlightDetailsContinue}
              className={`flight-booking-page_stepper_step ${
                isPaxCompleted ? 'completed-step' : ''
              }  ${activeTab === PAX ? 'active-step' : ''} `}
            >
              {isPaxCompleted ? (
                activeTab === PAX ? (
                  <MdCheckCircleOutline />
                ) : (
                  <MdCheckCircle />
                )
              ) : (
                <div className="flight-booking-page_stepper_step_count">
                  {travelInsuranceEnabled ? 3 : 2}
                </div>
              )}
              <div className="flight-booking-page_stepper_step_name">
                Pax Details
              </div>
            </div>
            {journeyType !== JOURNEY_TYPES.MULTI_CITY && (
              <div
                onClick={handlePaxContinue}
                className={`flight-booking-page_stepper_step ${
                  isSSRCompleted ? 'completed-step' : ''
                }  ${activeTab === SSR ? 'active-step' : ''} `}
              >
                {isSSRCompleted ? (
                  activeTab === SSR ? (
                    <MdCheckCircleOutline />
                  ) : (
                    <MdCheckCircle />
                  )
                ) : (
                  <div className="flight-booking-page_stepper_step_count">
                    {travelInsuranceEnabled ? 4 : 3}
                  </div>
                )}
                <div className="flight-booking-page_stepper_step_name">
                  Addons
                </div>
              </div>
            )}
            <div
              onClick={scrollToBottom}
              className={`flight-booking-page_stepper_step ${
                isPgCompleted ? 'completed-step' : ''
              }  ${activeTab === PG ? 'active-step' : ''} `}
            >
              {isPgCompleted ? (
                activeTab === PG ? (
                  <MdCheckCircleOutline />
                ) : (
                  <MdCheckCircle />
                )
              ) : (
                <div className="flight-booking-page_stepper_step_count">
                  {travelInsuranceEnabled ? 5 : 4}
                </div>
              )}
              <div className="flight-booking-page_stepper_step_name">
                Payment
              </div>
            </div>
            <div className="booking-counter-background">
              <CountdownTimer
                targetDate={elevenMinFromNowInMilli}
                continueBtnText={formattedMessage('back_to_search_results_btn')}
                continueRoutePath="searchResults"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flight-booking-page_header-space" />
      <section className="flight-booking-page_container">
        <Row className="spacing-8">
          <Col lg={9} md={12} sm={12} xs={12}>
            <div
              className="flight-booking-page_content p-3"
              ref={targetRefs.flightDetails}
            >
              <div className="flight-booking-page_flight-details">
                <div className="flight-booking-page_flight-details_journey-details d-flex justify-content-between align-items-center">
                  {journeyType === JOURNEY_TYPES.MULTI_CITY ? (
                    <div className="fs-16 fw-600">
                      {getJourneys(
                        searchRequest.originlocations,
                        searchRequest.destinationlocations,
                        searchRequest.onwarddate,
                      )}{' '}
                      ,{' '}
                      {parseInt(searchRequest.numadults, 10) +
                        parseInt(searchRequest.numchildren, 10) +
                        parseInt(searchRequest.numinfants, 10)}{' '}
                      Passengers
                    </div>
                  ) : (
                    <div>
                      <div className="fs-16 fw-600">{`${
                        searchRequest.originLocation.split(',')[0]
                      } (${searchRequest.origin}) -> ${
                        searchRequest.destinationLocation.split(',')[0]
                      } (${searchRequest.destination})`}</div>
                      <div className="fs-14 grey-color">{`${formattedMessage(
                        tripTypeDict[searchRequest.journeytype],
                      )} | ${formatDate(
                        getNewDate(searchRequest.onwarddate),
                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                      )} ${
                        journeyType === 'roundtrip'
                          ? ` | ${formatDate(
                              getNewDate(searchRequest.returndate),
                              DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                            )}`
                          : ''
                      }`}</div>
                    </div>
                  )}

                  <div className="d-flex align-items-center">
                    <AppLink
                      linkText="Back to search results"
                      variant="primary"
                      className="fw-600 backToSearch"
                      onClick={() => navigate(-1)}
                    />
                    {isFlightDetailsCompleted && (
                      <div>
                        {activeTab === FLIGHT_DETAILS ? (
                          <AppIconButton
                            variant="transparent"
                            onClick={() => setActiveTab(PAX)}
                            className="fs-3"
                          >
                            <MdKeyboardArrowUp />
                          </AppIconButton>
                        ) : (
                          <AppIconButton
                            variant="transparent"
                            onClick={() => setActiveTab(FLIGHT_DETAILS)}
                            className="fs-3"
                          >
                            <MdKeyboardArrowDown />
                          </AppIconButton>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {showFlightDetails && activeTab === FLIGHT_DETAILS && (
                  <>
                    {journeyType === 'roundtrip' ? (
                      <div className="border">
                        <div className="p-3 selectedOnwardDetails">
                          <div className="fs-16 fw-600 grey-color d-flex justify-content-between align-items-center">
                            <span>Onward</span>
                            <AppLink
                              linkText="Fare Rules"
                              variant="secondary"
                              className="fs-14"
                              onClick={() =>
                                handleOpenFareRules(
                                  selectedFareKeys.onward,
                                  'onward',
                                )
                              }
                            />
                          </div>
                          <SelectedFlightDetails
                            selectedFlight={selectedFlight.onward}
                            searchRequest={searchRequest}
                            showBaggage
                          />
                        </div>
                        {selectedFlight.return && (
                          <div className="p-3 pt-0 selectedReturnDetails">
                            <div className="fs-16 fw-600 grey-color d-flex justify-content-between align-items-center">
                              <span>Return</span>
                              {rePriceResponse.domint !== 'international' && (
                                <AppLink
                                  linkText="Fare Rules"
                                  variant="secondary"
                                  className="fs-14"
                                  onClick={() =>
                                    handleOpenFareRules(
                                      selectedFareKeys.return,
                                      'return',
                                    )
                                  }
                                />
                              )}
                            </div>
                            <SelectedFlightDetails
                              selectedFlight={selectedFlight.return}
                              searchRequest={{
                                ...searchRequest,
                                origin: searchRequest.destination,
                                destination: searchRequest.origin,
                                originLocation:
                                  searchRequest.destinationLocation,
                                destinationLocation:
                                  searchRequest.originLocation,
                                onwarddate: searchRequest.returndate,
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ) : journeyType === JOURNEY_TYPES.MULTI_CITY ? (
                      <>
                        <div className="d-flex justify-content-end my-2">
                          <AppLink
                            linkText="Fare Rules"
                            className="fs-14"
                            variant="secondary"
                            onClick={() =>
                              handleOpenFareRules(
                                selectedFareKeys.onward,
                                'onward',
                              )
                            }
                          />
                        </div>
                        {selectedFlight.onward.map((flt, index) => (
                          <React.Fragment key={index}>
                            <div className="selected-flight-details__multicity-trip-info fs-14 fw-600">
                              Trip - {index + 1}
                            </div>
                            <div className="p-0 p-lg-3">
                              <SelectedFlightDetails
                                selectedFlight={flt}
                                isOnward
                              />
                            </div>
                          </React.Fragment>
                        ))}
                      </>
                    ) : (
                      <>
                        <div className="p-3 border">
                          <div className="d-flex justify-content-end mb-1">
                            <AppLink
                              linkText="Fare Rules"
                              variant="secondary"
                              onClick={() =>
                                handleOpenFareRules(
                                  selectedFareKeys.onward,
                                  'onward',
                                )
                              }
                            />
                          </div>
                          <SelectedFlightDetails
                            selectedFlight={selectedFlight.onward}
                            searchRequest={searchRequest}
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
            {activeTab === FLIGHT_DETAILS && (
              <div className="m-2 mb-0 d-flex justify-content-end">
                <AppButton
                  btnText="Continue"
                  className="continue"
                  variant="outlined"
                  onClick={handleFlightDetailsContinue}
                />
              </div>
            )}
            <div className="separator" ref={targetRefs.insurance} />
            {travelInsuranceEnabled && (
              <div className="flight-booking-page_content">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="flight-booking-page_title d-flex flex-column">
                    <span>Travel Insurance</span>
                    <span className="fs-14 grey-color fw-300">
                      {isInusranceCompleted &&
                        (hasTravelInsurance ? 'Yes' : 'No')}
                    </span>
                  </div>
                  {isInusranceCompleted && (
                    <div className="pe-sm-3 pe-0">
                      {activeTab === INSURANCE ? (
                        <AppIconButton
                          variant="transparent"
                          onClick={() => setActiveTab(PG)}
                          className="fs-3"
                        >
                          <MdKeyboardArrowUp />
                        </AppIconButton>
                      ) : (
                        <AppIconButton
                          variant="transparent"
                          onClick={() => setActiveTab(INSURANCE)}
                          className="fs-3"
                        >
                          <MdKeyboardArrowDown />
                        </AppIconButton>
                      )}
                    </div>
                  )}
                </div>
                {activeTab === INSURANCE && (
                  <div className="p-3">
                    <div className="fs-16 fw-600 mb-3 secondary-color">
                      {`₹ ${INSURANCE_AMOUNT}/traveller(Infant is Not Eligible)`}
                    </div>
                    <div className="insurance-benefits-preview mb-3">
                      <div className="insurance-benefits-preview-header">
                        Plan benefits
                      </div>
                      <div className="insurance-benefits-preview-list">
                        {(rePriceResponse.domint === 'international'
                          ? INTERNATIONAL_INSURANCE_BENEFITS
                          : DOMESTIC_INSURANCE_BENEFITS
                        )
                          .slice(0, 3)
                          .map((item, idx) => (
                            <div
                              key={idx}
                              className="insurance-benefits-preview-item"
                            >
                              {item.benefit}
                            </div>
                          ))}
                        <div
                          className="insurance-benefits-preview-more"
                          onClick={() => setShowInsuranceBenefitsModal(true)}
                        >
                          +
                          {(rePriceResponse.domint === 'international'
                            ? INTERNATIONAL_INSURANCE_BENEFITS
                            : DOMESTIC_INSURANCE_BENEFITS
                          ).length - 3}{' '}
                          more benefits
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <AppRadioInput
                        checked={hasTravelInsurance === true}
                        id="true"
                        labelText={`Yes, Secure my trip for ₹ ${INSURANCE_AMOUNT}/traveller`}
                        name="travelInsurance"
                        onChange={() => handleTravelInsuranceSelection(true)}
                      />
                      {hasTravelInsurance && (
                        <div className="my-2">
                          {travellers.map(
                            (pax, index) =>
                              pax.type !== 'Infant' && (
                                <div key={index} className="my-2 d-flex">
                                  <AppTextInput
                                    label={`Nominee For ${pax.type} ${
                                      pax.type === 'Child'
                                        ? index +
                                          1 -
                                          parseInt(searchRequest.numadults, 10)
                                        : index + 1
                                    }`}
                                    value={pax.beneficiaryname}
                                    name="beneficiaryname"
                                    placeholderText=""
                                    onChange={(event) =>
                                      handleNomineeDetails(event, index)
                                    }
                                  />
                                </div>
                              ),
                          )}
                        </div>
                      )}
                      <AppRadioInput
                        checked={hasTravelInsurance === false}
                        id="false"
                        labelText="No, I will book without travel insurance."
                        name="travelInsurance"
                        onChange={() => handleTravelInsuranceSelection(false)}
                      />
                      <div className="fs-12 grey-color">
                        By adding insurance I agree to the Terms & Conditions
                        and confirm all passengers are between 2 to 70 years of
                        age. I hereby declare and understand that{' '}
                        {appConfig?.companyName}. facilitates the access of
                        third party travel insurance to its customer. I shall
                        not mark-up or charge any additional amount for
                        facilitating the access of third party travel insurance
                        to the end customer.
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {activeTab === INSURANCE && (
              <>
                <div className="separator" />
                <div className="flight-booking-page_content important-content p-3">
                  <div>
                    <div className="fs-16 fw-600 mb-2">
                      IMPORTANT INFORMATION
                    </div>
                    <ul className="fs-12 grey-color ps-3">
                      <li>
                        Check travel guidelines and baggage information below: :
                      </li>
                      <li>
                        Carry no more than 1 check-in baggage and 1 hand baggage
                        per passenger. If violated, airline may levy extra
                        charges.Wearing a mask/face cover is no longer
                        mandatory. However, all travellers are advised to do so
                        as a precautionary measure.
                      </li>
                      <li>Valid ID proof needed :</li>
                      <li>
                        Carry a valid photo identification proof (Driver
                        Licence, Aadhar Card, Pan Card or any other Government
                        recognised photo identification)
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="m-2 mb-0 d-flex justify-content-end">
                  <AppButton
                    btnText="Continue"
                    variant="outlined"
                    className="continue"
                    onClick={handleInsuranceContinue}
                  />
                </div>
              </>
            )}
            <div className="separator" />
            <div className="flight-booking-page_content" ref={targetRefs.pax}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="flight-booking-page_title d-flex flex-column travellersDetails">
                  {formattedMessage('traveller_details')}
                  {isPaxCompleted && (
                    <div>
                      {travellers.map((traveller, index) => (
                        <div key={index} className="fs-14 grey-color fw-300">
                          {traveller.first_name !== '' &&
                            `${index + 1}) ${traveller.title} ${
                              traveller.first_name
                            } ${traveller.last_name} (${
                              traveller.type === 'Adult'
                                ? 'adt'
                                : traveller.type === 'Child'
                                ? 'chd'
                                : traveller.type === 'Infant'
                                ? 'inf'
                                : traveller.type
                            })`}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {isPaxCompleted && (
                  <div className="pe-sm-3 pe-0">
                    {activeTab === PAX ? (
                      <AppIconButton
                        variant="transparent"
                        onClick={() => setActiveTab(SSR)}
                        className="fs-3"
                      >
                        <MdKeyboardArrowUp />
                      </AppIconButton>
                    ) : (
                      <AppIconButton
                        variant="transparent"
                        onClick={() => setActiveTab(PAX)}
                        className="fs-3"
                      >
                        <MdKeyboardArrowDown />
                      </AppIconButton>
                    )}
                  </div>
                )}
              </div>
              {activeTab === PAX && (
                <div className="p-3 pt-0 travellersDetials">
                  <p className="contact-details__subtitle mt-2">
                    {formattedMessage('contact_information')} (
                    {formattedMessage(
                      'your_ticket_and_flight_info_will_sent_here',
                    )}
                    )
                  </p>
                  <Row className="spacing-8 my-2">
                    <Col lg={3} md={3} sm={3} xs={12}>
                      <AppSelect
                        className="country-codes-input"
                        name="countryCode"
                        id="countryCode"
                        label={formattedMessage('country_code')}
                        placeholder=""
                        required
                        selectedValue={countryCode}
                        options={countryCodeOptions}
                        isClearable={false}
                        errorText={
                          validationError &&
                          isBookingClicked &&
                          formattedMessage('country_code_validation')
                        }
                        onSelect={(value) =>
                          value !== null
                            ? setCountryCode(value.value)
                            : setCountryCode('')
                        }
                      />
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={12}>
                      <AppTextInput
                        className="contact-input mobileNumber"
                        name="leadmobile"
                        id="leadmobile"
                        required
                        label={formattedMessage('mobile_number')}
                        value={leadmobile}
                        onChange={(event) => setLeadmobile(event.target.value)}
                      />
                      {(checkValidMobileNumber() ||
                        (isEmpty(leadmobile) && validationError)) && (
                        <small className="app-error-text">
                          {formattedMessage('enter_valid_mobile_number')}
                        </small>
                      )}
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={12}>
                      <AppTextInput
                        className="contact-input emailId"
                        name="leademail"
                        id="leademail"
                        required
                        label={formattedMessage('email_id')}
                        value={leademail}
                        onChange={(event) => setLeademail(event.target.value)}
                      />
                      {(checkValidEmailAddress() ||
                        (isEmpty(leademail) && validationError)) && (
                        <small className="app-error-text">
                          {formattedMessage('email_id_validation')}
                        </small>
                      )}
                    </Col>
                  </Row>
                  <span className="primary-color my-2 fs-16 fw-600">
                    {formattedMessage('traveller_details')}{' '}
                    {islcc === 'false' && (
                      <span className="red-color fs-12 fw-300">
                        (Please avoid selecting any title while entering Title
                        in the First/Last name textbox.)
                      </span>
                    )}
                  </span>
                  {travellers.map((traveller, index) => (
                    <div key={index}>
                      <div className="traveller-count p-2 ">
                        {getIndexForPax(index, traveller.type)}&#41;{' '}
                        {traveller.type}
                      </div>
                      <div className="saved-travellers">
                        <Row className="spacing-8 my-3">
                          <Col lg={2} md={2} sm={2} xs={12}>
                            <AppSelect
                              label={formattedMessage('title_select')}
                              required={
                                islcc === 'true' ||
                                bookingPageValidations?.ispaxtitlemandatory
                              }
                              className="title-select"
                              name="title"
                              id="title"
                              placeholder=""
                              errorText={
                                (islcc === 'true' ||
                                  bookingPageValidations?.ispaxtitlemandatory) &&
                                validationError &&
                                isBookingClicked &&
                                formattedMessage('title_seelect_validation')
                              }
                              options={
                                traveller.type === 'Adult'
                                  ? TITLE_OPTIONS
                                  : OTHER_TITLE_OPTIONS
                              }
                              selectedValue={traveller.title}
                              onSelect={(event) =>
                                handleTitleSelect(event, index)
                              }
                            />
                            {/* {validationError &&
                              islcc === 'true' &&
                              isEmpty(traveller.title) && (
                                <small className="app-error-text">
                                  {formattedMessage('title_seelect_validation')}
                                </small>
                              )} */}
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={12}>
                            <OverlayTrigger
                              placement="bottom-start"
                              overlay={
                                <Tooltip id="bkp-layover-tooltip">
                                  <div
                                    className="fs-12"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        airlineData[
                                          validatingOrOperatingCarrierCodeRef.current.toLowerCase()
                                        ]?.firstname,
                                    }}
                                  />
                                </Tooltip>
                              }
                            >
                              <div className="name-tooltip-container d-block d-sm-flex">
                                <AppTextInput
                                  className="traveller-input firstName"
                                  name="first_name"
                                  id="first_name"
                                  required
                                  label={formattedMessage('first_name')}
                                  value={traveller.first_name}
                                  errorText={
                                    isBookingClicked &&
                                    validationError &&
                                    formattedMessage('first_name_validation')
                                  }
                                  onChange={(event) =>
                                    handleTextInputChange(event, index)
                                  }
                                />
                                <div className="name-tooltip-container_text cursor-pointer secondary-color hide-in-mobile">
                                  <MdInfo />
                                </div>
                              </div>
                            </OverlayTrigger>
                            {validationError &&
                              isBookingClicked &&
                              traveller.first_name !== undefined &&
                              traveller.first_name.trim() !== '' &&
                              traveller.first_name.trim().length < 2 && (
                                <small className="app-error-text pe-1">
                                  {formattedMessage(
                                    'first_name_length_validation',
                                  )}
                                </small>
                              )}
                            {checkValidName(traveller.first_name) && (
                              <small className="app-error-text">
                                {formattedMessage('name_validation')}
                              </small>
                            )}
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={12}>
                            <OverlayTrigger
                              placement="bottom-start"
                              overlay={
                                <Tooltip id="bkp-layover-tooltip">
                                  <div
                                    className="fs-12"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        airlineData[
                                          validatingOrOperatingCarrierCodeRef.current.toLowerCase()
                                        ]?.lastname,
                                    }}
                                  />
                                </Tooltip>
                              }
                            >
                              <div className="name-tooltip-container d-block d-sm-flex">
                                <AppTextInput
                                  className="traveller-input lastName"
                                  name="last_name"
                                  id="last_name"
                                  required
                                  label={formattedMessage('last_name')}
                                  errorText={
                                    validationError &&
                                    isBookingClicked &&
                                    formattedMessage('last_name_validation')
                                  }
                                  value={traveller.last_name}
                                  onChange={(event) =>
                                    handleTextInputChange(event, index)
                                  }
                                />
                                <div className="name-tooltip-container_text cursor-pointer secondary-color hide-in-mobile">
                                  <MdInfo />
                                </div>
                              </div>
                            </OverlayTrigger>
                            {validationError &&
                              isBookingClicked &&
                              traveller.last_name !== undefined &&
                              traveller.last_name.trim() !== '' &&
                              traveller.last_name.trim().length < 1 && (
                                <small className="app-error-text">
                                  {formattedMessage(
                                    'last_name_length_validation',
                                  )}
                                </small>
                              )}
                            {checkValidName(traveller.last_name) && (
                              <small className="app-error-text">
                                {formattedMessage('name_validation')}
                              </small>
                            )}
                          </Col>
                          {bookingPageValidations?.pannumbermandatory &&
                            index === 0 && (
                              <Col lg={3} md={3} sm={3} xs={12}>
                                <AppTextInput
                                  className="traveller-input"
                                  name="pannumber"
                                  id="pannumber"
                                  required
                                  maxLength={10}
                                  label="PAN Number"
                                  errorText={
                                    !isEmpty(panNumber) &&
                                    !PAN_REGEX.test(
                                      panNumber.trim().toUpperCase(),
                                    )
                                      ? 'Please enter a valid 10-digit PAN Number (e.g. ABCDE1234F)'
                                      : isBookingClicked &&
                                        validationError &&
                                        isEmpty(panNumber)
                                      ? 'Please enter PAN Number'
                                      : ''
                                  }
                                  value={panNumber}
                                  onChange={(event) =>
                                    setPanNumber(
                                      event.target.value.toUpperCase(),
                                    )
                                  }
                                />
                                {!isEmpty(panNumber) &&
                                  !PAN_REGEX.test(
                                    panNumber.trim().toUpperCase(),
                                  ) && (
                                    <small className="app-error-text">
                                      Please enter a valid 10-digit PAN Number
                                      (e.g. ABCDE1234F)
                                    </small>
                                  )}
                              </Col>
                            )}
                          {searchRequest.searchtype === 'student' &&
                            traveller.type === 'Adult' && (
                              <>
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppTextInput
                                    className="traveller-input"
                                    name="student_id"
                                    id="student_id"
                                    required
                                    label="Student ID"
                                    errorText={
                                      validationError &&
                                      isBookingClicked &&
                                      'Please enter student ID'
                                    }
                                    value={traveller.idproof.split('@')[0]}
                                    onChange={(event) =>
                                      handleIdDetails(event, index)
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppDatePicker
                                    label="ID expiry date"
                                    className="app-date-picker"
                                    customClassName={`position-relative flight-booking-picker ${
                                      validationError &&
                                      isBookingClicked &&
                                      isEmpty(traveller.idproof.split('@')[1])
                                        ? 'app-error-text-border'
                                        : ''
                                    }`}
                                    placeholder="DD/MM/YYYY"
                                    isCustomeInput={false}
                                    showMonthDropdown
                                    onChangeRaw={(e) =>
                                      handleDateInputChange(
                                        'id_expiry_date',
                                        e,
                                        index,
                                        getNewDate(searchRequest.onwarddate),
                                        '',
                                      )
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    required
                                    minDate={getNewDate(
                                      searchRequest.onwarddate,
                                    )}
                                    selectedDate={
                                      !isEmpty(
                                        traveller.idproof.split('@')[1],
                                      ) &&
                                      getNewDate(
                                        traveller.idproof.split('@')[1],
                                      )
                                    }
                                    onChange={(date) =>
                                      handleIdDetails(
                                        {
                                          target: {
                                            name: 'id_expiry_date',
                                            value: formatDate(
                                              getNewDate(date),
                                              API_DATE_FORMAT,
                                            ),
                                          },
                                        },
                                        index,
                                      )
                                    }
                                    labelClassName="booking-date-label"
                                  />
                                  {validationError &&
                                    isBookingClicked &&
                                    isEmpty(
                                      traveller.idproof.split('@')[1],
                                    ) && (
                                      <small className="app-error-text">
                                        Please select ID expiry date
                                      </small>
                                    )}
                                </Col>
                              </>
                            )}
                          {searchRequest.searchtype === 'defenceonly' &&
                            traveller.type === 'Adult' && (
                              <>
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppTextInput
                                    className="traveller-input"
                                    name="defence_citizen_id"
                                    id="defence_citizen_id"
                                    required
                                    label="Defence ID"
                                    errorText={
                                      validationError &&
                                      isBookingClicked &&
                                      'Please enter ID proof number'
                                    }
                                    value={traveller.idproof.split('@')[0]}
                                    onChange={(event) =>
                                      handleIdDetails(event, index)
                                    }
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppDatePicker
                                    label="Date of birth"
                                    className="app-date-picker"
                                    customClassName={`position-relative flight-booking-picker ${
                                      validationError &&
                                      isBookingClicked &&
                                      isEmpty(traveller.idproof.split('@')[1])
                                        ? 'app-error-text-border'
                                        : ''
                                    }`}
                                    placeholder=""
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    disabledKeyboardNavigation
                                    required
                                    maxDate={getNewDate(TODAY_DATE)}
                                    selectedDate={
                                      !isEmpty(
                                        traveller.idproof.split('@')[1],
                                      ) &&
                                      getNewDate(
                                        traveller.idproof.split('@')[1],
                                      )
                                    }
                                    onChange={(date) =>
                                      handleIdDetails(
                                        {
                                          target: {
                                            name: 'defence_expiry_date',
                                            value: getAPIFormattedDate(date),
                                          },
                                        },
                                        index,
                                      )
                                    }
                                    labelClassName="booking-date-label"
                                  />
                                  {validationError &&
                                    isBookingClicked &&
                                    isEmpty(
                                      traveller.idproof.split('@')[1],
                                    ) && (
                                      <small className="app-error-text">
                                        Please select Date of birth
                                      </small>
                                    )}
                                </Col>
                              </>
                            )}
                          {searchRequest.searchtype === 'seniorcitizen' &&
                            traveller.type === 'Adult' && (
                              <>
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppTextInput
                                    className="traveller-input"
                                    name="senior_citizen_id"
                                    id="senior_citizen_id"
                                    required
                                    label="ID proof number"
                                    errorText={
                                      validationError &&
                                      isBookingClicked &&
                                      'Please enter ID proof number'
                                    }
                                    value={traveller.idproof.split('@')[0]}
                                    onChange={(event) =>
                                      handleIdDetails(event, index)
                                    }
                                  />
                                </Col>
                                {/* <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppDatePicker
                                    label="Dob"
                                    className="app-date-picker"
                                    customClassName={`position-relative flight-booking-picker ${
                                      validationError &&
                                      isBookingClicked &&
                                      isEmpty(traveller.idproof.split('@')[1])
                                        ? 'app-error-text-border'
                                        : ''
                                    }`}
                                    placeholder=""
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    disabledKeyboardNavigation
                                    required
                                    maxDate={getNewDate(TODAY_DATE)}
                                    selectedDate={
                                      !isEmpty(
                                        traveller.idproof.split('@')[1],
                                      ) &&
                                      getNewDate(
                                        traveller.idproof.split('@')[1],
                                      )
                                    }
                                    onChange={(date) =>
                                      handleIdDetails(
                                        {
                                          target: {
                                            name: 'dobForSeniorCitizen',
                                            value: formatDate(
                                              getNewDate(date),
                                              API_DATE_FORMAT,
                                            ),
                                          },
                                        },
                                        index,
                                      )
                                    }
                                    labelClassName="booking-date-label"
                                  />
                                  {validationError &&
                                    isBookingClicked &&
                                    isEmpty(
                                      traveller.idproof.split('@')[1],
                                    ) && (
                                      <small className="app-error-text">
                                        Please select Dob
                                      </small>
                                    )}
                                </Col> */}
                              </>
                            )}
                          {isDobMandatoryForPax(traveller.type) && (
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppDatePicker
                                label="Date of Birth"
                                className="dob-input"
                                customClassName={`position-relative flight-booking-picker dateOfBirth ${
                                  validationError &&
                                  isBookingClicked &&
                                  isDobMandatoryForPax(traveller.type) &&
                                  traveller.dob === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder="DD/MM/YYYY"
                                onChangeRaw={(e) =>
                                  handleDateInputChange(
                                    'dob',
                                    e,
                                    index,
                                    getDOBMinDate(traveller.type),
                                    getDOBMaxDate(traveller.type),
                                  )
                                }
                                isCustomeInput={false}
                                required
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                minDate={getDOBMinDate(traveller.type)}
                                maxDate={getDOBMaxDate(traveller.type)}
                                selectedDate={
                                  !isEmpty(traveller.dob) &&
                                  getNewDate(traveller.dob)
                                }
                                onChange={(date) => {
                                  if (isDobMandatoryForPax(traveller.type)) {
                                    handleTextInputChange(
                                      {
                                        target: {
                                          name: 'dob',
                                          value: formatDate(
                                            getNewDate(date),
                                            API_DATE_FORMAT,
                                          ),
                                        },
                                      },
                                      index,
                                    );
                                  }
                                  if (
                                    searchRequest.searchtype ===
                                      'seniorcitizen' &&
                                    traveller.type === 'Adult'
                                  ) {
                                    handleIdDetails(
                                      {
                                        target: {
                                          name: 'dobForSeniorCitizen',
                                          value: formatDate(
                                            getNewDate(date),
                                            API_DATE_FORMAT,
                                          ),
                                        },
                                      },
                                      index,
                                    );
                                  }
                                }}
                                labelClassName="app-date-label"
                              />
                              {isDobMandatoryForPax(traveller.type) &&
                                (traveller.dob === '' ||
                                  traveller.dob === null) &&
                                validationError &&
                                isBookingClicked && (
                                  <small className="app-error-text">
                                    Please select date of birth
                                  </small>
                                )}
                            </Col>
                          )}
                          {traveller.type !== 'Infant' && (
                            <>
                              {selectedFlight.onward.isffnrequired ===
                                'true' && (
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppTextInput
                                    className="traveller-input"
                                    name="frequent_flyer_number_onward"
                                    id="frequent_flyer_number_onward"
                                    label="FFN Number"
                                    value={
                                      traveller.frequent_flyer_number_onward
                                    }
                                    onChange={(event) =>
                                      handleTextInputChange(event, index)
                                    }
                                  />
                                </Col>
                              )}
                              {selectedFlight?.return?.isffnrequired ===
                                'true' && (
                                <Col lg={3} md={3} sm={3} xs={12}>
                                  <AppTextInput
                                    className="traveller-input"
                                    name="frequent_flyer_number_return"
                                    id="frequent_flyer_number_return"
                                    label="FFN Number for return"
                                    value={
                                      traveller.frequent_flyer_number_return
                                    }
                                    onChange={(event) =>
                                      handleTextInputChange(event, index)
                                    }
                                  />
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                        {rePriceResponse.domint === 'international' && (
                          <Row className="spacing-8 my-3">
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppTextInput
                                className="traveller-input passportNumber"
                                name="passport"
                                id="passport"
                                required={
                                  bookingPageValidations?.passportmandatory
                                }
                                label={formattedMessage('passport_number')}
                                value={traveller.passport}
                                errorText={
                                  isBookingClicked &&
                                  validationError &&
                                  rePriceResponse.domint === 'international' &&
                                  bookingPageValidations?.passportmandatory &&
                                  formattedMessage('passport_number_validation')
                                }
                                onChange={(event) =>
                                  handleTextInputChange(event, index)
                                }
                              />{' '}
                              {checkValidPassport(traveller.passport) && (
                                <small className="app-error-text">
                                  Enter Vaild Passport Number
                                </small>
                              )}
                            </Col>

                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppDatePicker
                                label={formattedMessage('passport_issue_date')}
                                className="app-date-picker"
                                customClassName={`position-relative flight-booking-picker ${
                                  validationError &&
                                  isBookingClicked &&
                                  rePriceResponse.domint === 'international' &&
                                  traveller.passport_dateofissue === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder="DD/MM/YYYY"
                                onChangeRaw={(e) =>
                                  handleDateInputChange(
                                    'passport_dateofissue',
                                    e,
                                    index,
                                    getDOBMinDate(traveller.type),
                                    traveller.type.toLowerCase() === 'infant'
                                      ? getYesterdayDate()
                                      : getNewDate(TODAY_DATE),
                                  )
                                }
                                isCustomeInput={false}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                required={
                                  bookingPageValidations?.issuedatemandatory
                                }
                                minDate={getDOBMinDate(traveller.type)}
                                maxDate={
                                  traveller.type.toLowerCase() === 'infant'
                                    ? getYesterdayDate()
                                    : getNewDate(TODAY_DATE)
                                }
                                selectedDate={
                                  traveller.passport_dateofissue !== '' &&
                                  getNewDate(traveller.passport_dateofissue)
                                }
                                onChange={(date) =>
                                  handleTextInputChange(
                                    {
                                      target: {
                                        name: 'passport_dateofissue',
                                        value: formatDate(
                                          getNewDate(date),
                                          API_DATE_FORMAT,
                                        ),
                                      },
                                    },
                                    index,
                                  )
                                }
                                labelClassName="booking-date-label"
                              />
                              {validationError &&
                                isBookingClicked &&
                                rePriceResponse.domint === 'international' &&
                                bookingPageValidations?.issuedatemandatory &&
                                traveller.passport_dateofissue === '' && (
                                  <small className="app-error-text">
                                    {formattedMessage(
                                      'date_of_issue_validation',
                                    )}
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppDatePicker
                                label={formattedMessage('passport_expiry')}
                                className="app-date-picker"
                                customClassName={`position-relative flight-booking-picker ${
                                  validationError &&
                                  isBookingClicked &&
                                  rePriceResponse.domint === 'international' &&
                                  traveller.passport_dateofexpiry === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder="DD/MM/YYYY"
                                onChangeRaw={(e) =>
                                  handleDateInputChange(
                                    'passport_dateofexpiry',
                                    e,
                                    index,
                                    journeyType === JOURNEY_TYPES.ROUND_TRIP
                                      ? getNewDate(searchRequest.returndate)
                                      : getNewDate(searchRequest.onwarddate),
                                    '',
                                  )
                                }
                                isCustomeInput={false}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                required={
                                  bookingPageValidations?.exprirydatemandatory
                                }
                                // minDate={getNewDate(TODAY_DATE)}
                                minDate={
                                  journeyType === JOURNEY_TYPES.ROUND_TRIP
                                    ? getNewDate(searchRequest.returndate)
                                    : getNewDate(searchRequest.onwarddate)
                                }
                                selectedDate={
                                  traveller.passport_dateofexpiry !== '' &&
                                  getNewDate(traveller.passport_dateofexpiry)
                                }
                                onChange={(date) =>
                                  handleTextInputChange(
                                    {
                                      target: {
                                        name: 'passport_dateofexpiry',
                                        value: formatDate(
                                          getNewDate(date),
                                          API_DATE_FORMAT,
                                        ),
                                      },
                                    },
                                    index,
                                  )
                                }
                                labelClassName="booking-date-label"
                              />
                              {validationError &&
                                isBookingClicked &&
                                rePriceResponse.domint === 'international' &&
                                bookingPageValidations?.exprirydatemandatory &&
                                traveller.passport_dateofexpiry === '' && (
                                  <small className="app-error-text">
                                    {formattedMessage(
                                      'date_of_expiry_validation',
                                    )}
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppSelect
                                required={
                                  bookingPageValidations?.issueplacemandatory
                                }
                                options={COUNTRY_OPTIONS}
                                className="passportPlaceOfIssue"
                                name="passport_placeofissue"
                                id="passport_placeofissue"
                                label="Passport Place Of Issue"
                                errorText={
                                  isBookingClicked &&
                                  validationError &&
                                  rePriceResponse.domint === 'international' &&
                                  'Select Passport Place of Issue'
                                }
                                onSelect={(obj) =>
                                  handleTextInputChange(
                                    {
                                      target: {
                                        name: 'passport_placeofissue',
                                        value: obj.value,
                                      },
                                    },
                                    index,
                                  )
                                }
                                selectedValue={traveller.passport_placeofissue}
                              />
                              {!isEmpty(traveller.passport_placeofissue) &&
                                checkValidName(
                                  traveller.passport_placeofissue,
                                ) && (
                                  <small className="app-error-text">
                                    Please enter valid place of issue
                                  </small>
                                )}
                            </Col>
                          </Row>
                        )}
                        {hasWheelChairRows &&
                          traveller.type.toLowerCase() !== 'infant' && (
                            <div className="special-assistance-box mt-3">
                              <span className="pe-3">
                                {formattedMessage('special_assistance')}
                              </span>
                              <AppLink
                                isLink={false}
                                variant="primary"
                                onClick={() => handleSwitchChange(index)}
                                linkText={
                                  traveller.hasWheelChair
                                    ? formattedMessage('remove_btn')
                                    : formattedMessage('add')
                                }
                              />
                            </div>
                          )}
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          {savedPaxIndex.indexOf(index) > -1 ? (
                            <span className="green-color fs-12">Saved</span>
                          ) : (
                            <AppLink
                              linkText="Save Pax Details"
                              className="fs-12"
                              onClick={() => handleSavePaxDetails(index)}
                            />
                          )}
                        </div>
                        <div>
                          <AppLink
                            linkText="Select Passengers"
                            className="fs-12"
                            onClick={handleGetSavedpassenegers}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {activeTab === PAX && (
              <>
                <div className="separator" />
                {(!appConfig.isIntlClient ||
                  appConfig.isIntlClient === 'false') && (
                  <div className="flight-booking-page_content">
                    <div className="flight-booking-page_title">
                      {formattedMessage('gst_details_header')}
                    </div>
                    <div className="p-3 fs-14">
                      <Row className="spacing-8">
                        <Col lg={3} md={3} sm={4} xs={12}>
                          <AppSelect
                            label="Select Corporate"
                            className="title-select"
                            name="Select Corporate"
                            id="selectcorporate"
                            placeholder=""
                            errorText=""
                            options={agentwiseGSTlist}
                            selectedValue={gstCompany}
                            onSelect={(value) => {
                              if (value !== null) {
                                setGSTCompany(value.value);
                              } else {
                                setGSTCompany('');
                              }
                              handleSelectGST(value);
                            }}
                          />
                        </Col>
                        <Col lg={3} md={3} sm={6} xs={12}>
                          <AppTextInput
                            name="gstnumber"
                            value={gst.gstnumber}
                            label={formattedMessage('gst_number')}
                            errorText={
                              gstValidationError &&
                              formattedMessage('gst_number_validation')
                            }
                            onChange={handleGstChange}
                          />
                          {checkValiGstNumber(gst.gstnumber?.trim()) && (
                            <small className="app-error-text">
                              {formattedMessage('gst_number_validation')}
                            </small>
                          )}
                        </Col>
                        <Col lg={3} md={3} sm={6} xs={12}>
                          <AppTextInput
                            name="gstcompany"
                            value={gst.gstcompany}
                            label={formattedMessage('company_name')}
                            errorText={
                              gstValidationError &&
                              formattedMessage('please_enter_gst_company')
                            }
                            onChange={handleGstChange}
                          />
                        </Col>
                        <Col lg={3} md={3} sm={6} xs={12}>
                          <AppTextInput
                            name="gstemail"
                            value={gst.gstemail}
                            label={formattedMessage('company_email_address')}
                            errorText={
                              gstValidationError &&
                              formattedMessage('please_enter_gst_email_address')
                            }
                            onChange={handleGstChange}
                          />
                          {checkEmailAddress(gst.gstemail) &&
                            !isEmpty(gst.gstemail) && (
                              <small className="app-error-text">
                                Enter valid email
                              </small>
                            )}
                        </Col>
                        <Col lg={3} md={3} sm={6} xs={12}>
                          <AppTextInput
                            name="gstphone"
                            value={gst.gstphone}
                            label="GST Phone Number"
                            errorText={
                              gstValidationError && 'Please enter GST phone'
                            }
                            onChange={handleGstChange}
                          />
                          {checkMobileNumber(gst.gstphone) && (
                            <small className="app-error-text">
                              Enter valid phone number
                            </small>
                          )}
                        </Col>
                        <Col lg={3} md={3} sm={6} xs={12}>
                          <AppTextInput
                            name="gstaddress"
                            value={gst.gstaddress}
                            label="GST company Address"
                            errorText={
                              gstValidationError && 'Please enter GST Address'
                            }
                            onChange={handleGstChange}
                          />
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={12}>
                          <AppIconButton
                            onClick={() => handleAddGST(gst)}
                            variant="transparent"
                            className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                          >
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdSave className="success-color" /> Save GST
                            </div>
                          </AppIconButton>
                        </Col>
                        <Col lg={3} md={3} sm={4} xs={12}>
                          <AppIconButton
                            onClick={handleUpdateGstDetails}
                            variant="transparent"
                            className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                          >
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdSave className="success-color" /> Upadate GST
                              Details
                            </div>
                          </AppIconButton>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
                <div className="m-2 mb-0 d-flex justify-content-end">
                  <AppButton
                    btnText="Continue"
                    variant="outlined"
                    className="continue"
                    onClick={handlePaxContinue}
                  />
                </div>
              </>
            )}
            {(seatmapavailable !== false ||
              ssravailable !== false ||
              isGdsSearch) && (
              <>
                <div className="separator" />
                <div
                  className="flight-booking-page_content add-ons-section"
                  ref={targetRefs.ssr}
                >
                  {journeyType !== JOURNEY_TYPES.MULTI_CITY && (
                    <div className=" d-flex justify-content-between align-items-center">
                      <div className="flight-booking-page_title d-flex flex-column">
                        Add on ( optional )
                        {isSSRCompleted && (
                          <div className="fs-14 grey-color fw-300">
                            {travellers.map((traveller, index) => (
                              <div
                                key={index}
                                className="flight-booking-page_display-text"
                              >
                                <div className="fw-300 fs-12">
                                  {getUserSsr(traveller, index)}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {isSSRCompleted && (
                        <div className="pe-sm-3 pe-0">
                          {activeTab === SSR ? (
                            <AppIconButton
                              variant="transparent"
                              onClick={() => setActiveTab(PG)}
                              className="fs-3"
                            >
                              <MdKeyboardArrowUp />
                            </AppIconButton>
                          ) : (
                            <AppIconButton
                              variant="transparent"
                              onClick={() => setActiveTab(SSR)}
                              className="fs-3"
                            >
                              <MdKeyboardArrowDown />
                            </AppIconButton>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === SSR &&
                    journeyType !== JOURNEY_TYPES.MULTI_CITY && (
                      <div className="d-flex flex-wrap">
                        {seatmapavailable !== false && (
                          <div className="m-2 d-flex justify-content-center align-items-center">
                            <AppIconButton
                              onClick={() => handleAddAddOn(ADDONS.SEAT)}
                              variant="transparent"
                              className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                            >
                              {isSeatSelected ? (
                                <div className=" d-flex justify-content-center align-items-center gap-1">
                                  <MdChair className="primary-color" /> Edit
                                  Seat
                                </div>
                              ) : (
                                <div className=" d-flex justify-content-center align-items-center gap-1 seatMapButton">
                                  <MdChair className="primary-color" /> Seat
                                  Selection
                                </div>
                              )}
                            </AppIconButton>
                          </div>
                        )}
                        {(ssravailable !== false || isGdsSearch) && (
                          <>
                            <div className="m-2 d-flex justify-content-center align-items-center">
                              <AppIconButton
                                onClick={() => handleAddAddOn(ADDONS.MEALS)}
                                variant="transparent"
                                className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                              >
                                {isMealSelected ? (
                                  <div className=" d-flex justify-content-center align-items-center gap-1">
                                    <MdOutlineFastfood className="primary-color" />{' '}
                                    Edit Meal
                                  </div>
                                ) : (
                                  <div className=" d-flex justify-content-center align-items-center gap-1 seatmealsBtn">
                                    <MdOutlineFastfood className="primary-color" />{' '}
                                    Add Meals
                                  </div>
                                )}
                              </AppIconButton>
                            </div>
                            <div className="m-2 d-flex justify-content-center align-items-center">
                              <AppIconButton
                                onClick={() => handleAddAddOn(ADDONS.BAGGAGE)}
                                variant="transparent"
                                className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                              >
                                {isBaggageSelected ? (
                                  <div className=" d-flex justify-content-center align-items-center gap-1">
                                    <MdLuggage className="primary-color" /> Edit
                                    Baggage
                                  </div>
                                ) : (
                                  <div className=" d-flex justify-content-center align-items-center gap-1 seatBaggagebtn">
                                    <MdLuggage className="primary-color" /> Add
                                    Baggage
                                  </div>
                                )}
                              </AppIconButton>
                            </div>
                            <div className="m-2 d-flex justify-content-center align-items-center">
                              <AppIconButton
                                onClick={() =>
                                  handleAddAddOn(ADDONS.SPECIAL_SSR)
                                }
                                variant="transparent"
                                className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                              >
                                {isSpecialSsrSelected ? (
                                  <div className=" d-flex justify-content-center align-items-center gap-1">
                                    <MdList className="primary-color" /> Edit
                                    Other SSR
                                  </div>
                                ) : (
                                  <div className=" d-flex justify-content-center align-items-center gap-1 otherSsrBtn">
                                    <MdList className="primary-color" /> Other
                                    SSR
                                  </div>
                                )}
                              </AppIconButton>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                </div>
                {activeTab === SSR &&
                  journeyType !== JOURNEY_TYPES.MULTI_CITY && (
                    <div className="m-2 mb-0 d-flex justify-content-end">
                      <AppButton
                        btnText="Continue"
                        variant="outlined"
                        className="continue"
                        onClick={handleSsrContinue}
                      />
                    </div>
                  )}
              </>
            )}
            <div className="separator" />
            <div className="flight-booking-page_content" ref={targetRefs.pg}>
              <div className="flight-booking-page_title">Payment options</div>
              <div className="d-flex cursor-pointer">
                {getEligibilityForPaymentMode('wallet') && (
                  <div
                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                      paymentmode === 'cashcard'
                        ? 'primary-color'
                        : 'grey-color'
                    }`}
                    onClick={() => updatePaymentMode('cashcard')}
                  >
                    <CiWallet />
                    Wallet
                  </div>
                )}
                {/* {journeyType !== JOURNEY_TYPES.MULTI_CITY && (
                  <> */}
                {getEligibilityForPaymentMode('creditcard') && (
                  <div
                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                      paymentmode === 'creditcard'
                        ? 'primary-color'
                        : 'grey-color'
                    }`}
                    onClick={() => updatePaymentMode('creditcard')}
                  >
                    <MdOutlineCreditCard /> CreditCard
                  </div>
                )}
                {getEligibilityForPaymentMode('debitcard') && (
                  <div
                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                      paymentmode === 'debitcard'
                        ? 'primary-color'
                        : 'grey-color'
                    }`}
                    onClick={() => updatePaymentMode('debitcard')}
                  >
                    <MdOutlineCreditCard /> DebitCard
                  </div>
                )}
                {getEligibilityForPaymentMode('netbanking') && (
                  <div
                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                      paymentmode === 'netbanking'
                        ? 'primary-color'
                        : 'grey-color'
                    }`}
                    onClick={() => updatePaymentMode('netbanking')}
                  >
                    <CiBank />
                    Netbanking
                  </div>
                )}
                {getEligibilityForPaymentMode('upi') && (
                  <div
                    className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                      paymentmode === 'upi' ? 'primary-color' : 'grey-color'
                    }`}
                    onClick={() => updatePaymentMode('upi')}
                  >
                    <CiBank />
                    UPI
                  </div>
                )}
                {/* </>
                )} */}
              </div>

              {PaymentGateway === true &&
                tempPgList.length > 0 &&
                paymentmode !== 'cashcard' &&
                paymentmode !== '' && (
                  <div className="d-flex justify-content-start gap-4">
                    <div className="flight-booking-page_title">
                      Payment Gateway
                    </div>
                    {tempPgList.map((pgdisp, index) => (
                      <AppRadioInput
                        key={index}
                        id={pgdisp.GatewayName}
                        name="paymentGateway"
                        labelText={
                          pgdisp.GatewayName === 'techprocessv2'
                            ? 'Worldline'
                            : pgdisp.GatewayName
                        }
                        value={pgdisp.GatewayName}
                        onChange={() => handlePgSelection(pgdisp.GatewayName)}
                        checked={selectedPg === pgdisp.GatewayName}
                      />
                    ))}
                  </div>
                )}
              {/* {paymentmode === 'netbanking' &&
                paymentmode !== '' &&
                isEmpty(getValueFromAppConfig('disableDropDown')) && (
                  <div className="d-flex justify-content-start p-3">
                    <AppSelect
                      name="selected_bank"
                      id="selected_bank"
                      label="Select Bank"
                      placeholder=""
                      required={
                        selectedPg === 'techprocessv2' ||
                        selectedPg === 'techprocessv2_netbanking' ||
                        selectedPg === 'payu'
                      }
                      selectWidth="300px"
                      isClearable={false}
                      options={NET_BANKING_OPTIONS_LIVE}
                      selectedValue={selectedBankForNetBanking}
                      onSelect={(dataObj) =>
                        setSelectedBankForNetBanking(dataObj.value)
                      }
                      errorText={
                        validationError &&
                        (selectedPg === 'techprocessv2' ||
                          selectedPg === 'techprocessv2_netbanking' ||
                          selectedPg === 'payu') &&
                        'select bank'
                      }
                    />
                  </div>
                )} */}

              {paymentmode !== '' &&
                paymentmode !== 'cashcard' &&
                selectedPg === 'payu' && (
                  <div className="px-3 d-flex flex-column">
                    <p className="mb-2 px-4 fs-14">
                      Accept Terms and Conditions of <b>payu</b>
                    </p>
                    <AppCheckBox
                      labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                      id="payuPgAccepted"
                      name="payuPgAccepted"
                      radioClassName="w-25px"
                      checked={isPayuPgAccepted}
                      labelClassName="fs-12"
                      onChange={() => setIsPayuPgAccepted((prev) => !prev)}
                    />
                    <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                      <img src="/images/others/payu.jpg" alt="" height="20px" />
                      <img
                        src="/images/others/visa_mastercard.gif"
                        alt=""
                        height="20px"
                      />
                      <span>
                        (Only Personal Credit Cards @ 1.77% | Rupay Debit Card
                        allowed @0.25%)
                      </span>
                    </div>
                  </div>
                )}
            </div>
            <div className="separator" />
            <div className="flight-booking-page_content p-3 d-flex justify-content-between d-column d-md-row">
              <AppCheckBox
                labelText="I have reviewed and agreed to the fares and commission offered for this booking"
                id="acceptTerms"
                name="acceptTerms"
                checked={acceptTerms}
                labelClassName="fs-12"
                onChange={() => setAcceptTerms((prev) => !prev)}
              />
              <div className="d-flex gap-2 align-items-center">
                <div className="fs-4 fw-600">
                  {formatCurrency(fareSummaryRef.current.totalFare)}
                </div>
                {getEligibilityForPaymentMode('book') && (
                  <AppButton
                    btnText={formattedMessage('confirm_booking')}
                    disabled={!acceptTerms}
                    className="make-payment-btn"
                    onClick={() => handleConfirmBooking('book')}
                  />
                )}
                {isHoldSupported &&
                  appConfig?.companyName.toLowerCase() !== 'sanram travels' && (
                    <AppButton
                      btnText="Confirm Hold"
                      disabled={!acceptTerms}
                      variant="make-payment-btn"
                      onClick={() => handleConfirmBooking('hold')}
                    />
                  )}
                {/* {rePriceResponse.holdsupported === true &&
                  !isCarrierSg() &&
                  journeyType !== JOURNEY_TYPES.MULTI_CITY &&
                  getEligibilityForPaymentMode('hold') && (
                    <AppButton
                      btnText="Hold booking"
                      disabled={!acceptTerms}
                      variant="secondary"
                      onClick={() => handleConfirmBooking('hold')}
                    />
                  )} */}
              </div>
            </div>
          </Col>
          <Col lg={3} md={12} sm={12} xs={12}>
            <section className="flight-fare-summary-section">
              <div className="fare-summary_container flex-1">
                {isEmpty(getValueFromAppConfig('SHOW_NET_FARE')) && (
                  <div className="fare-summary_title d-flex justify-content-between align-items-center">
                    <span>{formattedMessage('fare_summary_caps')}</span>
                    <AppIconButton
                      className="p-0 fs-16"
                      variant="white"
                      onClick={() => setShowNetFare((prev) => !prev)}
                    >
                      {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                    </AppIconButton>
                  </div>
                )}
                <div
                  className="fare-summary_table watermarked"
                  data-watermark={getUserAgentId()}
                >
                  <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between fw-600 mb-2">
                      <span>Fare/Pax Type</span>
                      <span>Amount</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Adult:</span>
                      <span className="fw-500">
                        {formatCurrency(fareSummaryRef.current.adultBaseFare)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>OT Tax:</span>
                      <span className="fw-500">
                        {formatCurrency(fareSummaryRef.current.adultOTCharge)}
                      </span>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                      <span>K3/AirlineGST:</span>
                      <span className="fw-500">
                        {formatCurrency(fareSummaryRef.current.adultKValue)}
                      </span>
                    </div> */}
                    <div className="d-flex justify-content-between">
                      <span>YQ Tax:</span>
                      <span className="fw-500">
                        {formatCurrency(fareSummaryRef.current.adultFuelCharge)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>YR Tax:</span>
                      <span className="fw-500">
                        {formatCurrency(fareSummaryRef.current.adultYRValue)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Other Charges:</span>
                      <span className="fw-500">
                        {formatCurrency(
                          fareSummaryRef.current.transactionFeePerPax,
                        )}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Adult Total:</span>
                      <span className="fw-600">
                        {formatCurrency(fareSummaryRef.current.adultTotalFare)}
                      </span>
                    </div>
                  </div>
                  {parseInt(searchRequest.numchildren, 10) > 0 && (
                    <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                      <div className="d-flex justify-content-between">
                        <span>Child:</span>
                        <span className="fw-500">
                          {formatCurrency(fareSummaryRef.current.childBaseFare)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span> OT Tax:</span>
                        <span className="fw-500">
                          {formatCurrency(fareSummaryRef.current.childOTCharge)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>YQ Tax:</span>
                        <span className="fw-500">
                          {formatCurrency(
                            fareSummaryRef.current.childFuelCharge,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>YR Tax:</span>
                        <span className="fw-500">
                          {formatCurrency(fareSummaryRef.current.childYRValue)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Other Charges:</span>
                        <span className="fw-500">
                          {formatCurrency(
                            fareSummaryRef.current.transactionFeePerPax,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Child Total:</span>
                        <span className="fw-600">
                          {formatCurrency(
                            fareSummaryRef.current.childTotalFare,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                  {parseInt(searchRequest.numinfants, 10) > 0 && (
                    <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                      <div className="d-flex justify-content-between">
                        <span>Infant:</span>
                        <span className="fw-500">
                          {formatCurrency(
                            fareSummaryRef.current.infantBaseFare,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span> OT Tax:</span>
                        <span className="fw-500">
                          {formatCurrency(
                            fareSummaryRef.current.infantOTCharge,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>YQ Tax:</span>
                        <span className="fw-500">
                          {formatCurrency(
                            fareSummaryRef.current.infantFuelCharge,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>YR Tax:</span>
                        <span className="fw-500">
                          {formatCurrency(fareSummaryRef.current.infantYRValue)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Infant Total:</span>
                        <span className="fw-600">
                          {formatCurrency(
                            fareSummaryRef.current.infantTotalFare,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                  <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                    <div className="text-center fw-600 fs-14 ">Total Fare</div>
                    <div className="d-flex justify-content-between">
                      <span className="fw-500">
                        {parseInt(searchRequest.numadults, 10)} x{' '}
                        {formattedMessage('adult')}
                      </span>
                      <span className="fw-600">
                        {formatCurrency(
                          fareSummaryRef.current.adultTotalFare *
                            parseInt(searchRequest.numadults, 10),
                        )}
                      </span>
                    </div>
                    {searchRequest.numchildren > 0 && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">
                          {parseInt(searchRequest.numchildren, 10)} x child
                        </span>
                        <span className="fw-600">
                          {formatCurrency(
                            fareSummaryRef.current.childTotalFare *
                              parseInt(searchRequest.numchildren, 10),
                          )}
                        </span>
                      </div>
                    )}
                    {searchRequest.numinfants > 0 && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">
                          {parseInt(searchRequest.numinfants, 10)} x{' '}
                          {formattedMessage('infant')}
                        </span>
                        <span className="fw-600">
                          {formatCurrency(
                            fareSummaryRef.current.infantTotalFare *
                              parseInt(searchRequest.numinfants, 10),
                          )}
                        </span>
                      </div>
                    )}
                    {fareSummaryRef.current.hasSeat && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500 seatsTotal">
                          {formattedMessage('seats_total')}
                        </span>
                        <span className="fw-600 selectedSeatsTotal">
                          {formatCurrency(fareSummaryRef.current.seatPrice)}
                        </span>
                      </div>
                    )}
                    {fareSummaryRef.current.hasMeal && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500 mealsTotal">
                          {formattedMessage('meal_total')}
                        </span>
                        <span className="fw-600 mealTotal">
                          {formatCurrency(fareSummaryRef.current.mealPrice)}
                        </span>
                      </div>
                    )}
                    {fareSummaryRef.current.hasBaggage && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500 baggageTotal">
                          Baggage Total
                        </span>
                        <span className="fw-600 selectedBaggageTotal">
                          {formatCurrency(fareSummaryRef.current.baggagePrice)}
                        </span>
                      </div>
                    )}
                    {fareSummaryRef.current.hasSpecialSsr && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500 specialSsrTotal">
                          {formattedMessage('special_ssr_total')}
                        </span>
                        <span className="fw-600 ssrTotalPrice">
                          {formatCurrency(
                            fareSummaryRef.current.specialSsrPrice,
                          )}
                        </span>
                      </div>
                    )}
                    <div className="d-flex justify-content-between">
                      <span className="fw-500">Handling Charges(+)</span>
                      <span className="fw-600">
                        {formatCurrency(fareSummaryRef.current.handlingCharges)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="fw-500">GST</span>
                      <span className="fw-600">
                        {formatCurrency(fareSummaryRef.current.gst)}
                      </span>
                    </div>
                    {hasTravelInsurance && (
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">Insurance</span>
                        <span className="fw-600">
                          {formatCurrency(
                            eligiblePaxForTravelInsurance * INSURANCE_AMOUNT,
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                  {showNetFare && (
                    <div className="row spacing-0 d-flex flex-column gap-2 px-2 py-1">
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">Markup</span>
                        <span className="fw-600">
                          {fareSummaryRef.current.AdditionalMarkupToShow}
                          {/* {formatCurrency(fareSummaryRef.current.markUp)} */}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">Discount(-)</span>
                        <span className="fw-600">
                          {formatCurrency(fareSummaryRef.current.discount)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">PLB(-)</span>
                        <span className="fw-600">
                          {formatCurrency(fareSummaryRef.current.plbEarned)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">TDS(+)</span>
                        <span className="fw-600">
                          {formatCurrency(fareSummaryRef.current.tds)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">Total Payable</span>
                        <span className="fw-600">
                          {formatCurrency(
                            fareSummaryRef.current.totalAmountToShow,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="fw-500">Commission Earned</span>
                        <span className="fw-600">
                          {formatCurrency(
                            fareSummaryRef.current.discount +
                              fareSummaryRef.current.plbEarned,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="fare-summary_footer watermarked"
                  data-watermark={getUserAgentId()}
                >
                  <div className="row spacing-0">
                    <span className="col fare-summary_footer_title">
                      {formattedMessage('total_fare')}
                    </span>
                    <span className="col fare-summary_footer_value d-flex flex-column">
                      <span className="fareSummaryTotalFare">
                        {formatCurrency(fareSummaryRef.current.totalFare)}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              {getValueFromAppConfig('SHOWADDMARKUPINBOOKINGPAGE') === 'show' &&
                getValueFromAppConfig('REQUIRE_MARKUP') !== 'true' && (
                  <div className="flight-booking-page_apply-markup mt-3 p-3 d-flex flex-column gap-2">
                    <div className="text-center fs-14 fw-600 d-flex justify-content-between">
                      {formattedMessage('apply_markup')}
                      <AppIconButton
                        className="p-0 fs-16"
                        onClick={() => setShowMarkupOption((prev) => !prev)}
                      >
                        {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                      </AppIconButton>
                    </div>
                    {showMarkupOption && (
                      <>
                        {tempMarkupList.map(
                          (pax, index) =>
                            pax.Type !== 'Infant' && (
                              <div key={index} className="my-2">
                                <AppTextInput
                                  label={`Markup For ${pax.Type} ${
                                    pax.Type === 'Child'
                                      ? index +
                                        1 -
                                        parseInt(searchRequest.numadults, 10)
                                      : index + 1
                                  }`}
                                  value={pax.tax_amount}
                                  className="w-100"
                                  name="tax_amount"
                                  placeholderText=""
                                  onChange={(event) =>
                                    handleAddMarkupForPax(event, index)
                                  }
                                />
                              </div>
                            ),
                        )}
                        <AppButton
                          btnText={isMarkupUpdated ? 'Applied' : 'Apply'}
                          className="fs-12 white-color"
                          variant="select"
                          onClick={handleMarkupAddition}
                        />
                      </>
                    )}
                  </div>
                )}
            </section>
          </Col>
        </Row>
      </section>
      {isOpenFareRulesDialog && (
        <AppSidebar
          sidebarTitle={formattedMessage('fare_rules_btn')}
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setIsOpenFareRulesDialog(false)}
          className="overflow-auto flight-details-sidebar"
        >
          <div
            dangerouslySetInnerHTML={{ __html: fareRulesHtml }}
            className="overflow-auto"
          />
        </AppSidebar>
      )}
      {showSeatMap && (
        <AppSidebar
          className="overflow-auto flight-details-sidebar p-0"
          sidebarTitle="Seat selection"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowSeatMap(false)}
          showFooter
          footerBtnText="Done"
          onFooterClick={() => setShowSeatMap(false)}
        >
          {Object.keys(flightLegsWithSeatsRef.current).length > 0 ? (
            <section className="seat-selection-section">
              <div className="seat-sectors-row d-flex">
                {Object.keys(flightLegsWithSeatsRef.current).map((sector) => (
                  <div
                    key={sector}
                    className={`seat-sector activeSeatSector ${
                      seatSelectionSector === sector ? 'active-seat-sector' : ''
                    }`}
                    onClick={() => setSeatSelectionSector(sector)}
                  >
                    {sector}
                  </div>
                ))}
              </div>
              <div className="separator" />
              {Object.keys(userSelectedSsrRows).length > 0 &&
                Object.keys(flightLegsWithSeatsRef.current).map((sector) => {
                  const sectorSeats = flightLegsWithSeatsRef.current[sector]
                    ? flightLegsWithSeatsRef.current[sector].seats
                    : {};
                  const seatLetters = flightLegsWithSeatsRef.current[sector]
                    ? flightLegsWithSeatsRef.current[sector].seatLetterArray
                    : [];
                  const seatNumbers = flightLegsWithSeatsRef.current[sector]
                    ? flightLegsWithSeatsRef.current[sector].seatDigitArray
                    : [];
                  return (
                    userSelectedSsrRows[sector] &&
                    seatSelectionSector === sector && (
                      <div
                        key={sector}
                        className="d-flex flex-sm-row flex-column mainContent"
                      >
                        <div className="d-flex flex-sm-column flex-row travellers-info overflow-auto gap-1">
                          {userSelectedSsrRows[sector].seatRows &&
                            userSelectedSsrRows[sector].seatRows.map(
                              (ssrRow, index) =>
                                ssrRow.paxtype.toLowerCase() !== 'infant' && (
                                  <div
                                    className={`traveller-name travellersSeatSelection ${
                                      activeSeatIndex === index &&
                                      'current-traveller-seat-selection'
                                    }`}
                                    key={index}
                                    onClick={() => setActiveSeatIndex(index)}
                                  >
                                    {getSelectedSeat(ssrRow, index, sector)}
                                  </div>
                                ),
                            )}
                        </div>
                        <div className="flight-seat-map d-flex justify-content-center align-items-center flex-1">
                          <div className="flight-seat-map_container seatMapContainer">
                            <div className="flight-seat-map_cockpit">
                              <img src="/images/others/cockpit.svg" alt="" />
                            </div>
                            <div className="flight-seat-map_layout">
                              {Object.keys(sectorSeats).map(
                                (seatRow, seatRowIndex) => (
                                  <div
                                    key={seatRow}
                                    className="d-flex position-relative"
                                  >
                                    <div
                                      className="flight-seat-map_row-designator_left-number"
                                      style={{
                                        marginTop:
                                          seatRowIndex === 0 ? '32px' : '',
                                      }}
                                    >
                                      {seatNumbers[seatRowIndex]}
                                    </div>
                                    <div
                                      className="flight-seat-map_row-designator_right-number"
                                      style={{
                                        marginTop:
                                          seatRowIndex === 0 ? '32px' : '',
                                      }}
                                    >
                                      {seatNumbers[seatRowIndex]}
                                    </div>

                                    {sectorSeats[seatRow].map((seat, index) => (
                                      <div
                                        key={index}
                                        className="d-flex flex-column align-items-center "
                                      >
                                        {seatRowIndex === 0 && (
                                          <div
                                            className={`flight-seat-map_row-designator ${
                                              seat.additionalinfo.indexOf(
                                                'margin-left',
                                              ) > -1
                                                ? 'flight-seat-map_row-designator_aisle-space'
                                                : ''
                                            } `}
                                          >
                                            {seatLetters[index]}
                                          </div>
                                        )}
                                        <div
                                          className={`flight-seat-map_seat ${
                                            seat.additionalinfo.indexOf(
                                              'margin-left',
                                            ) > -1
                                              ? 'flight-seat-map_aisle-space'
                                              : ''
                                          } ${
                                            seat.additionalinfo
                                              .toLowerCase()
                                              .indexOf('exitrow') > -1
                                              ? 'flight-seat-map_exit-row'
                                              : ''
                                          } ${
                                            seat.additionalinfo.indexOf(
                                              'no-seat',
                                            ) > -1
                                              ? 'flight-seat-map_empty-space'
                                              : ''
                                          } ${
                                            seat.seatstatus
                                              .toLowerCase()
                                              .indexOf('open') === -1
                                              ? 'flight-seat-map_booked-seat'
                                              : ''
                                          } ${
                                            userSelectedSsrRows[
                                              sector
                                            ].seatRows.find(
                                              (s) =>
                                                s.ssrcode ===
                                                seat.seatdesignator,
                                            )
                                              ? 'flight-seat-map_selected-seat'
                                              : ''
                                          } `}
                                        >
                                          {seat.additionalinfo.indexOf(
                                            'no-seat',
                                          ) > -1 ? (
                                            ''
                                          ) : (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="seat-info-tooltip">
                                                  <div className="fs-10 d-flex flex-column">
                                                    {getSeatToolTipText(seat)}
                                                  </div>
                                                </Tooltip>
                                              }
                                            >
                                              <div
                                                className="seat-text seatTextContainer"
                                                onClick={() =>
                                                  handleSeatSelection(
                                                    seat,
                                                    sector,
                                                    userSelectedSsrRows[
                                                      sector
                                                    ].seatRows[0].carrier.substring(
                                                      0,
                                                      2,
                                                    ),
                                                  )
                                                }
                                              >
                                                {getDesignatorForSeat(seat)}
                                              </div>
                                            </OverlayTrigger>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ),
                              )}
                            </div>
                            {/* <div className="flight-seat-map_cockpit">
                           <img src="/images/others/tailgate.svg" alt="" />
                         </div> */}
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}
            </section>
          ) : (
            <div className="text-center">
              Seat map is not available at the moment
            </div>
          )}
        </AppSidebar>
      )}
      {showMeals && (
        <AppSidebar
          sidebarTitle={formattedMessage('meals')}
          className="overflow-auto flight-details-sidebar p-0"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowMeals(false)}
          showFooter
          footerBtnText="Done"
          onFooterClick={() => setShowMeals(false)}
        >
          {Object.keys(flightLegsWithMealRef.current).length > 0 ? (
            <>
              <div className="meal-sectors-row d-flex">
                {Object.keys(flightLegsWithMealRef.current)
                  .filter(
                    (sector) =>
                      userSelectedSsrRows && userSelectedSsrRows[sector],
                  )
                  .map((sector) => (
                    <div
                      key={sector}
                      className={`meal-sector mealSectors ${
                        mealSelectionSector === sector
                          ? 'active-meal-sector'
                          : ''
                      }`}
                      onClick={() => setMealSelectionSector(sector)}
                    >
                      {sector}
                    </div>
                  ))}
              </div>
              <div className="separator extraSpace" />
              {Object.keys(flightLegsWithMealRef.current)
                .filter(
                  (sector) =>
                    userSelectedSsrRows && userSelectedSsrRows[sector],
                )
                .map((sector) => {
                  const mealsList = flightLegsWithMealRef.current[sector];
                  const userMealRows =
                    userSelectedSsrRows[sector]?.mealRows || [];
                  return (
                    mealSelectionSector === sector && (
                      <div key={sector}>
                        <div className="d-flex p-3 travellers-info">
                          {travellers.map(
                            (traveller, index) =>
                              traveller.type.toLowerCase() !== 'infant' && (
                                <div
                                  className={`traveller-name ${
                                    activeMealIndex === index &&
                                    'active-traveller'
                                  }`}
                                  key={index}
                                  onClick={() => setActiveMealIndex(index)}
                                >
                                  {traveller.first_name !== ''
                                    ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                    : `Traveller ${index + 1}`}
                                  <small className="traveller-name__subheading">
                                    {getSelectedMeals(userMealRows, index)}
                                  </small>
                                </div>
                              ),
                          )}
                        </div>
                        <div className="separator" />
                        <div className="d-flex flex-wrap justify-content-between p-3 mealsContent">
                          {mealsList.map((meal, index) => (
                            <div
                              key={`${meal.ssrcode}_${index}`}
                              className="ssr-card p-2 mb-2"
                            >
                              <div>
                                <img
                                  className="meal-image"
                                  src={meal.imageurl}
                                  alt={meal.ssrname}
                                />
                              </div>
                              <div className="ps-3 pe-3 w-100 d-flex flex-column">
                                <div className="flex-1">
                                  <p className="ssr-card__meal-name">
                                    {meal.ssrname}
                                  </p>
                                  <p className="ssr-card__meal-description">
                                    {meal.Desc}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <p className="ssr-card__meal-name ssrCardMealPrice">
                                    {formatCurrency(meal.chargeableamount)}
                                  </p>
                                  {userMealRows[activeMealIndex]?.ssrcode ===
                                  meal.ssrcode ? (
                                    <AppButton
                                      variant="outlined"
                                      className="ssr-card__add-btn ssrAddMealsBtn"
                                      btnText={formattedMessage('remove_btn')}
                                      onClick={() =>
                                        handleRemoveMeal(
                                          meal,
                                          index,
                                          `${meal.origin} - ${meal.destination}`,
                                        )
                                      }
                                    />
                                  ) : (
                                    <AppButton
                                      className="ssr-card__add-btn ssrAddMealsBtn"
                                      btnText={formattedMessage('add_btn')}
                                      onClick={() =>
                                        handleAddMeal(meal, sector)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  );
                })}
            </>
          ) : (
            <div className="text-center p-2 mealNotAvailable">
              Meals are not available at the moment
            </div>
          )}
        </AppSidebar>
      )}
      {showBaggage && (
        <AppSidebar
          sidebarTitle={formattedMessage('baggage')}
          className="overflow-auto flight-details-sidebar  p-0"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowBaggage(false)}
          showFooter
          footerBtnText="Done"
          onFooterClick={() => setShowBaggage(false)}
        >
          <div className="separator" />
          <div className="baggage-sectors-row d-flex">
            {Object.keys(flightLegsWithBaggageRef.current)
              .filter(
                (sector) => userSelectedSsrRows && userSelectedSsrRows[sector],
              )
              .map((sector) => (
                <div
                  key={sector}
                  className={`baggage-sector baggaeSectorInfo ${
                    baggageSelectionSector === sector
                      ? 'active-baggage-sector'
                      : ''
                  }`}
                  onClick={() => setBaggageSelectionSector(sector)}
                >
                  {sector}
                </div>
              ))}
          </div>
          <div className="separator extraSpace" />
          {Object.keys(flightLegsWithBaggageRef.current).length === 0 && (
            <div className="p-3">
              {formattedMessage('baggage_not_available')}.
            </div>
          )}
          {Object.keys(flightLegsWithBaggageRef.current)
            .filter(
              (sector) => userSelectedSsrRows && userSelectedSsrRows[sector],
            )
            .map((sector) => {
              const baggageList = flightLegsWithBaggageRef.current[sector];
              const userBaggageRows =
                userSelectedSsrRows[sector]?.baggageRows || [];
              return (
                baggageSelectionSector === sector && (
                  <div key={sector}>
                    <div className="d-flex p-3 travellers-info">
                      {travellers.map(
                        (traveller, index) =>
                          traveller.type.toLowerCase() !== 'infant' && (
                            <div
                              className={`traveller-name ${
                                activeBagIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveBagIndex(index)}
                            >
                              {traveller.first_name !== ''
                                ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                : `Traveller ${index + 1}`}
                              <small className="traveller-name__subheading">
                                {getSelectedBaggage(userBaggageRows, index)}
                              </small>
                            </div>
                          ),
                      )}
                    </div>
                    <div className="separator" />
                    <div className="d-flex flex-wrap justify-content-between p-3 baggageContent">
                      {baggageList.map((baggage, index) => (
                        <div
                          key={`${baggage.ssrcode}_${index}`}
                          className="ssr-card p-2 mb-2"
                        >
                          <div>
                            <img
                              className="meal-image"
                              src={baggage.imageurl}
                              alt={baggage.ssrname}
                            />
                          </div>
                          <div className="ps-3 pe-3 w-100 d-flex flex-column">
                            <div className="flex-1">
                              <p className="ssr-card__meal-name">
                                {baggage.ssrname}
                              </p>
                              <p className="ssr-card__meal-description">
                                {baggage.Desc === 'internationalconnections' ? (
                                  <div>
                                    <span>
                                      {formattedMessage('baggage_warn')}.
                                    </span>
                                    <AppLink
                                      linkText={formattedMessage(
                                        'terms_conditions',
                                      )}
                                      isLink={false}
                                      onClick={handleTermsConditions}
                                    />
                                  </div>
                                ) : (
                                  baggage.Desc
                                )}
                              </p>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="ssr-card__meal-name baggagePrice">
                                {formatCurrency(baggage.chargeableamount)}
                              </p>
                              {getBaggageKey(
                                userBaggageRows[activeBagIndex]?.ssrcode,
                                userBaggageRows[activeBagIndex]?.ssrid,
                              ) ===
                              getBaggageKey(baggage.ssrcode, baggage.ssrid) ? (
                                <AppButton
                                  variant="outlined"
                                  className="ssr-card__add-btn"
                                  btnText={formattedMessage('remove_btn')}
                                  onClick={() =>
                                    handleRemoveBaggage(
                                      baggage,
                                      activeBagIndex,
                                      sector,
                                    )
                                  }
                                />
                              ) : (
                                <AppButton
                                  className="ssr-card__add-btn baggageAddBtn"
                                  btnText={formattedMessage('add_btn')}
                                  onClick={() =>
                                    handleAddBaggage(baggage, sector)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              );
            })}
        </AppSidebar>
      )}
      {showSpecialSsr && (
        <AppSidebar
          sidebarTitle={formattedMessage('special_ssr')}
          className="overflow-auto flight-details-sidebar"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowSpecialSsr(false)}
          showFooter
          footerBtnText="Done"
          onFooterClick={() => setShowSpecialSsr(false)}
        >
          {Object.keys(flightLegsWithSpecialSsr.current).length > 0 ? (
            <>
              <div className="baggage-sectors-row d-flex">
                {Object.keys(flightLegsWithSpecialSsr.current)
                  .filter(
                    (sector) =>
                      userSelectedSsrRows && userSelectedSsrRows[sector],
                  )
                  .map((sector) => (
                    <div
                      key={sector}
                      className={`baggage-sector showSpecialSsr ${
                        specialSsrSelectionSector === sector
                          ? 'active-baggage-sector'
                          : ''
                      }`}
                      onClick={() => setSpecialSsrSelectionSector(sector)}
                    >
                      {sector}
                    </div>
                  ))}
              </div>
              <div className="separator extraSpace" />
              {Object.keys(flightLegsWithSpecialSsr.current)
                .filter(
                  (sector) =>
                    userSelectedSsrRows && userSelectedSsrRows[sector],
                )
                .map((sector) => {
                  const allSpecialSsr =
                    flightLegsWithSpecialSsr.current[sector];
                  const userSpecialSsrRows =
                    userSelectedSsrRows[sector]?.specialSsrRows || [];
                  return (
                    specialSsrSelectionSector === sector && (
                      <div key={sector}>
                        <>
                          {allSpecialSsr?.length ? (
                            <div className="d-flex p-3 travellers-info">
                              {travellers.map(
                                (traveller, index) =>
                                  traveller.type.toLowerCase() !== 'infant' && (
                                    <div
                                      className={`traveller-name ${
                                        activeSsrIndex === index &&
                                        'active-traveller'
                                      }`}
                                      key={index}
                                      onClick={() => setActiveSsrIndex(index)}
                                    >
                                      {traveller.first_name !== ''
                                        ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                        : `Traveller ${index + 1}`}
                                      <small className="traveller-name__subheading">
                                        {getSelectedSpecailSsr(
                                          userSpecialSsrRows,
                                          index,
                                        )}
                                      </small>
                                    </div>
                                  ),
                              )}
                            </div>
                          ) : (
                            <div key={sector} className="text-center">
                              Special SSR is not available
                            </div>
                          )}
                        </>
                        <div className="separator" />
                        <div className="d-flex flex-wrap justify-content-between p-3 ssrContent">
                          {allSpecialSsr.map((specialSsr, index) => (
                            <div
                              key={`${specialSsr.ssrcode}_${index}`}
                              className="ssr-card p-2 mb-2"
                            >
                              <div>
                                <img
                                  className="meal-image"
                                  src={specialSsr.imageurl}
                                  alt={specialSsr.ssrname}
                                />
                              </div>
                              <div className="ps-3 pe-3 w-100 d-flex flex-column">
                                <div className="flex-1">
                                  <p className="ssr-card__meal-name">
                                    {specialSsr.ssrname}
                                  </p>
                                  <p className="ssr-card__meal-description">
                                    {specialSsr.Desc}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <p className="ssr-card__meal-name specialSsrPrice">
                                    {formatCurrency(
                                      specialSsr.chargeableamount,
                                    )}
                                  </p>
                                  {userSpecialSsrRows[activeSsrIndex]
                                    ?.ssrcode === specialSsr.ssrcode ? (
                                    <AppButton
                                      variant="outlined"
                                      className="ssr-card__add-btn"
                                      btnText={formattedMessage('remove_btn')}
                                      onClick={() =>
                                        handleRemoveSpecialSsr(
                                          specialSsr,
                                          activeSsrIndex,
                                          `${specialSsr.origin} - ${specialSsr.destination}`,
                                        )
                                      }
                                    />
                                  ) : (
                                    <AppButton
                                      className="ssr-card__add-btn specialSsrBtn"
                                      btnText={formattedMessage('add_btn')}
                                      onClick={() =>
                                        handleAddSpecialSsr(specialSsr, sector)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  );
                })}
            </>
          ) : (
            <div className="text-center ssrNotAvailable">
              Special SSR is not available
            </div>
          )}
        </AppSidebar>
      )}
      {showConfirmationDialog && (
        <Modal
          className="app-modal booking-confirm-modal"
          size="lg"
          show={showConfirmationDialog}
          onHide={handleConfirmationDialogClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>{formattedMessage('reconfirm_title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {journeyType === JOURNEY_TYPES.MULTI_CITY ? (
              <>
                <div className="fs-16 fw-600">
                  {getJourneys(
                    searchRequest.originlocations,
                    searchRequest.destinationlocations,
                    searchRequest.onwarddate,
                  )}{' '}
                  ,{' '}
                  {parseInt(searchRequest.numadults, 10) +
                    parseInt(searchRequest.numchildren, 10) +
                    parseInt(searchRequest.numinfants, 10)}{' '}
                  Passengers
                </div>
                {selectedFlight.onward.map((flt, index) => (
                  <React.Fragment key={index}>
                    <div className="selected-flight-details__multicity-trip-info fs-14 fw-600">
                      Trip - {index + 1}
                    </div>
                    <div className="p-0 p-lg-3">
                      <SelectedFlightDetails selectedFlight={flt} isOnward />
                    </div>
                  </React.Fragment>
                ))}
              </>
            ) : (
              <>
                <div className="p-2 border-bottom mb-2">
                  <div className="fs-16 fw-600">{`${
                    searchRequest.originLocation.split(',')[0]
                  } (${searchRequest.origin}) -> ${
                    searchRequest.destinationLocation.split(',')[0]
                  } (${searchRequest.destination})`}</div>
                  <div className="fs-14 grey-color">{`${formattedMessage(
                    tripTypeDict[searchRequest.journeytype],
                  )} | ${formatDate(
                    getNewDate(searchRequest.onwarddate),
                    DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                  )} ${
                    journeyType === 'roundtrip'
                      ? ` | ${formatDate(
                          getNewDate(searchRequest.returndate),
                          DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}`
                      : ''
                  }`}</div>
                </div>
                <div className="pt- pe-3 ps-3">
                  {journeyType === 'roundtrip' ? (
                    <>
                      <div className="fs-16 fw-600 grey-color d-flex justify-content-between align-items-center">
                        <span>Onward</span>
                        <AppLink
                          linkText="Fare Rules"
                          variant="secondary"
                          onClick={() =>
                            handleOpenFareRules(
                              selectedFareKeys.onward,
                              'onward',
                            )
                          }
                        />
                      </div>
                      <SelectedFlightDetails
                        selectedFlight={selectedFlight.onward}
                        isOnward
                        searchRequest={searchRequest}
                      />
                      {selectedFlight.return && (
                        <div className="fs-16 fw-600 grey-color d-flex justify-content-between align-items-center">
                          <span>Return</span>
                          {rePriceResponse.domint !== 'international' && (
                            <AppLink
                              linkText="Fare Rules"
                              variant="secondary"
                              onClick={() =>
                                handleOpenFareRules(
                                  selectedFareKeys.return,
                                  'return',
                                )
                              }
                            />
                          )}
                        </div>
                      )}
                      <SelectedFlightDetails
                        selectedFlight={selectedFlight.return}
                        searchRequest={searchRequest}
                      />
                    </>
                  ) : (
                    <>
                      <div className="fs-16 fw-600 grey-color d-flex justify-content-end ">
                        <AppLink
                          linkText="Fare Rules"
                          variant="secondary"
                          onClick={() =>
                            handleOpenFareRules(
                              selectedFareKeys.onward,
                              'onward',
                            )
                          }
                        />
                      </div>
                      <SelectedFlightDetails
                        selectedFlight={selectedFlight.onward}
                        searchRequest={searchRequest}
                      />
                    </>
                  )}
                </div>
              </>
            )}
            <div className="d-flex justify-content-between align-items-center p-2 fw-600">
              <span>Travellers</span>
              <AppLink
                variant="secondary"
                linkText="Edit Travellers"
                onClick={handleEditTravellersPostConfirm}
              />
            </div>
            <div className="px-3">
              <table className="table table-bordered fs-14">
                <thead>
                  <tr>
                    <th>Guest Name</th>
                    <th>Segment</th>
                    <th>Seat No.</th>
                    <th>Meal</th>
                    <th>Excess Baggage</th>
                    <th>Other SSR</th>
                  </tr>
                </thead>
                <tbody>
                  {travellers.map((traveller, index) =>
                    flightSectorsRef.current.map((sector, sectorKey) => (
                      <React.Fragment key={sectorKey}>
                        {sectorKey === 0 && (
                          <tr key={index}>
                            <td
                              rowSpan={flightSectorsRef.current.length}
                            >{`${traveller.title} ${traveller.first_name} ${traveller.last_name}`}</td>
                            <td>{sector}</td>
                            <td>{getSeatNo(sector, index)}</td>
                            <td>{getMeal(sector, index)}</td>
                            <td>{getExcessBaggage(sector, index)}</td>
                            <td>{getOtherSsr(sector, index)}</td>
                          </tr>
                        )}
                        {sectorKey !== 0 && (
                          <tr>
                            <td>{sector}</td>
                            <td>{getSeatNo(sector, index)}</td>
                            <td>{getMeal(sector, index)}</td>
                            <td>{getExcessBaggage(sector, index)}</td>
                            <td>{getOtherSsr(sector, index)}</td>
                          </tr>
                        )}
                      </React.Fragment>
                    )),
                  )}
                </tbody>
              </table>
            </div>
            <div className="p-3">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_email')}
                  </span>
                  <span>{leademail}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_mobile')}
                  </span>
                  <span>{leadmobile}</span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-1 px-3">
              <span className="secondary-text">
                {formattedMessage('total_fare')}
              </span>
              <span className="fare-summary">
                {formatCurrency(fareSummaryRef.current.totalFare)}
              </span>
            </div>
            {checkoutPgCharge !== 0 && (
              <div className="d-flex justify-content-between mt-1 px-3">
                <span className="secondary-text">
                  {formattedMessage('payment_surcharge')}
                </span>
                <span className="fare-summary">
                  {formatCurrency(checkoutPgCharge)}
                </span>
              </div>
            )}
            {checkoutgstPgCharge !== 0 && (
              <div className="d-flex justify-content-between mt-1 px-3">
                <span className="secondary-text">GST on Payment Surcharge</span>
                <span className="fare-summary">
                  {formatCurrency(checkoutgstPgCharge)}
                </span>
              </div>
            )}
            {checkoutInvTotal !== 0 && (
              <div className="d-flex justify-content-between mt-1 px-3">
                <span className="secondary-text">
                  {formattedMessage('you_pay')}
                </span>
                <span className="fare-summary">
                  {formatCurrency(checkoutInvTotal)}
                </span>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <div className="d-flex flex-column align-items-center">
              <span className="fs-5">{formattedMessage('wallet_balance')}</span>
              <span className="fs-4 fw-500">
                {formatCurrency(walletBalanceRef.current)}
              </span>
            </div>
            <div>
              <AppButton
                variant="outlined"
                btnText={formattedMessage('cancel_btn')}
                className="me-2"
                onClick={handleConfirmationDialogClose}
              />
              <AppButton
                btnText={formattedMessage('confirm_btn')}
                onClick={handleBook}
              />
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {showConfirmHoldDialog && (
        <Modal
          className="app-modal booking-confirm-modal"
          size="lg"
          show={showConfirmHoldDialog}
          onHide={handleConfirmHoldDialogClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Confirm Hold</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-2 border-bottom mb-2">
              <div className="fs-16 fw-600">{`${
                searchRequest.originLocation.split(',')[0]
              } (${searchRequest.origin}) -> ${
                searchRequest.destinationLocation.split(',')[0]
              } (${searchRequest.destination})`}</div>
              <div className="fs-14 grey-color">{`${formattedMessage(
                tripTypeDict[searchRequest.journeytype],
              )} | ${formatDate(
                getNewDate(searchRequest.onwarddate),
                DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
              )} ${
                journeyType === 'roundtrip'
                  ? ` | ${formatDate(
                      getNewDate(searchRequest.returndate),
                      DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}`
                  : ''
              }`}</div>
            </div>
            <div className="pt- pe-3 ps-3">
              {journeyType === 'roundtrip' ? (
                <>
                  {selectedFlight.onward && (
                    <div className=" mb-3">
                      {formattedMessage('onward_journey')}
                    </div>
                  )}
                  <SelectedFlightDetails
                    selectedFlight={selectedFlight.onward}
                    searchRequest={searchRequest}
                  />
                  {selectedFlight.return && (
                    <div className="flight-details-modal__return mb-3">
                      {formattedMessage('return_journey')}
                    </div>
                  )}
                  <SelectedFlightDetails
                    selectedFlight={selectedFlight.return}
                    searchRequest={searchRequest}
                  />
                </>
              ) : (
                <SelectedFlightDetails
                  selectedFlight={selectedFlight.onward}
                  searchRequest={searchRequest}
                />
              )}
            </div>
            <div className="d-flex justify-content-between align-items-center p-2 fw-600">
              <span>Travellers</span>
              <AppLink
                variant="secondary"
                linkText="Edit Travellers"
                onClick={handleEditTravellersPostConfirm}
              />
            </div>
            <div className="px-3">
              <table className="table table-bordered fs-14">
                <thead>
                  <th>Guest Name</th>
                  <th>Segment</th>
                  <th>Seat No.</th>
                  <th>Meal</th>
                  <th>Excess Baggage</th>
                  <th>Other SSR</th>
                </thead>
                <tbody>
                  {travellers.map((traveller, index) =>
                    flightSectorsRef.current.map((sector, sectorKey) => (
                      <React.Fragment key={sectorKey}>
                        {sectorKey === 0 && (
                          <tr key={index}>
                            <td
                              rowSpan={flightSectorsRef.current.length}
                            >{`${traveller.title} ${traveller.first_name} ${traveller.last_name}`}</td>
                            <td>{sector}</td>
                            <td>{getSeatNo(sector, index)}</td>
                            <td>{getMeal(sector, index)}</td>
                            <td>{getExcessBaggage(sector, index)}</td>
                            <td>{getOtherSsr(sector, index)}</td>
                          </tr>
                        )}
                        {sectorKey !== 0 && (
                          <tr>
                            <td>{sector}</td>
                            <td>{getSeatNo(sector, index)}</td>
                            <td>{getMeal(sector, index)}</td>
                            <td>{getExcessBaggage(sector, index)}</td>
                            <td>{getOtherSsr(sector, index)}</td>
                          </tr>
                        )}
                      </React.Fragment>
                    )),
                  )}
                </tbody>
              </table>
            </div>
            <div className="p-3">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_email')}
                  </span>
                  <span>{leademail}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_mobile')}
                  </span>
                  <span>{leadmobile}</span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3 p-3">
              <span className="secondary-text">
                {formattedMessage('total_fare')}
              </span>
              <span className="fare-summary">
                {formatCurrency(fareSummaryRef.current.totalFare)}
              </span>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <div className="d-flex flex-column align-items-center">
              <span className="fs-5">{formattedMessage('wallet_balance')}</span>
              <span className="fs-4 fw-500">
                {formatCurrency(walletBalanceRef.current)}
              </span>
            </div>
            <div>
              <AppButton
                variant="outlined"
                btnText={formattedMessage('cancel_btn')}
                className="me-2"
                onClick={handleConfirmHoldDialogClose}
              />
              <AppButton btnText="Confirm Hold" onClick={handleHold} />
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {showSpecialAssistance && (
        <Modal
          className="app-modal booking-confirm-modal"
          size="md"
          show={showSpecialAssistance}
          onHide={setShowSpecialAssistance}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {formattedMessage('requires_special_assistance_for')}{' '}
              {selectedTravellerRef.current.title}{' '}
              {selectedTravellerRef.current.first_name}{' '}
              {selectedTravellerRef.current.last_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="separator" />
            <div className="baggage-sectors-row d-flex">
              {Object.keys(FlightLegsWithSpecialAssistanceRef.current).map(
                (sector) => (
                  <div
                    key={sector}
                    className={`baggage-sector ${
                      specialAssistanceSelectionSector === sector
                        ? 'active-baggage-sector'
                        : ''
                    }`}
                    onClick={() => setSpecialAssistanceSelectionSector(sector)}
                  >
                    {sector}
                  </div>
                ),
              )}
            </div>
            <div className="separator" />
            {Object.keys(FlightLegsWithSpecialAssistanceRef.current).map(
              (sector) => {
                const specialAssistanceList =
                  FlightLegsWithSpecialAssistanceRef.current[sector];
                return (
                  specialAssistanceSelectionSector === sector && (
                    <div key={sector} className="p-3">
                      {specialAssistanceList.map((sa) => (
                        <div
                          key={sa.ssrcode}
                          className="py-2 d-flex justify-content-between"
                        >
                          <span>{sa.ssrname}</span>
                          <input
                            type="radio"
                            name={`${sector}_specialSsr`}
                            id={sa.ssrcode}
                            checked={
                              wheelChairSsr &&
                              wheelChairSsr[sector] &&
                              wheelChairSsr[sector][
                                selectedSpecialAssistanceIndexRef.current
                              ] &&
                              wheelChairSsr[sector][
                                selectedSpecialAssistanceIndexRef.current
                              ].ssrcode === sa.ssrcode
                            }
                            onChange={(event) =>
                              handleSAChange(
                                event,
                                sa,
                                specialAssistanceSelectionSector,
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )
                );
              },
            )}
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <AppButton
              variant="secondary"
              onClick={handleClearSsr}
              btnText={formattedMessage('remove_btn')}
            />
            <AppButton
              onClick={() => handleAddWheelChariSsr()}
              btnText={formattedMessage('add_btn')}
              // btnText={`Add ${specialAssistanceSelectionSector} ${selectedSpecialAssistanceIndexRef.current}`}
            />
          </Modal.Footer>
        </Modal>
      )}
      {showInsuranceBenefitsModal && (
        <AppModal
          modalTitle={
            rePriceResponse.domint === 'international'
              ? 'International Travel Insurance - Plan Benefits'
              : 'Domestic Travel Insurance - Plan Benefits'
          }
          showCloseButton
          size="md"
          onModalClose={() => setShowInsuranceBenefitsModal(false)}
        >
          <div className="insurance-benefits-modal-content">
            <div className="fs-12 grey-color mb-3">
              {rePriceResponse.domint === 'international'
                ? 'Below are the coverage limits and plan benefits for International Trip Protection:'
                : 'Below are the coverage limits and plan benefits for Domestic Trip Protection:'}
            </div>
            <div className="insurance-benefits-list">
              {(rePriceResponse.domint === 'international'
                ? INTERNATIONAL_INSURANCE_BENEFITS
                : DOMESTIC_INSURANCE_BENEFITS
              ).map((item, idx) => (
                <div key={idx} className="insurance-benefit-item">
                  <span className="benefit-name">{item.benefit}</span>
                  <span className="benefit-amount">{item.amount}</span>
                </div>
              ))}
            </div>
          </div>
        </AppModal>
      )}
      {showBagTermsDialog && (
        <BaggageTerms onHide={() => setShowBagTermsDialog(false)} />
      )}
      {showSelectPaxModal && (
        <AppModal
          showCloseButton
          size="xl"
          className="overflow-auto flight-details-sidebar"
          modalTitle="Choose Passenger"
          onModalClose={() => setShowSelectPaxModal(false)}
        >
          <PersonalTravelersModal
            personalTravellers={personalTravellers}
            onSelectCustomer={handleSelectCustomer}
          />
        </AppModal>
      )}
      {showSelectGstModal && (
        <AppSidebar
          className="overflow-auto flight-details-sidebar"
          sidebarTitle="Select GST"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowSelectGstModal(false)}
        >
          {/* <SelectGstModal onSelect={handleSelectGST} /> */}
        </AppSidebar>
      )}
    </section>
  );
}

export default FlightBookingPage;
